import React from 'react';

export default (
  <>
    <defs>
      <clipPath id="clippath">
        <path
          d="m83.03,50.26c-3.45-2.25-3.25-4.12-3.25-4.12-.51-1.93,5.18-2.73,5.18-2.73,1.2-.34,1.17-1.42,1.17-1.42.93-3.96,2.39-5.32,2.39-5.32.59-.71.78-.28.78-.28.04,1.17-.67,1.3-.67,1.3-.95,1.33-.97,3.01-.97,3.01.31,1.5.85.33.85.33.92-2.41,3.27-4.36,3.27-4.36.77-.73.97-.21.97-.21-.21,1.25-1.14,1.48-1.14,1.48-.75.91-2.13,3.01-2.13,3.01-.65,1.13.12.98.12.98,1.51-1.51,4.92-3.55,4.92-3.55,1.1-.43,1.09.06,1.09.06-.36,1.29-1.49,1.21-1.49,1.21-1.63.67-3.14,2.98-3.14,2.98-.56.63.4.69.4.69,1.37.03,5.42-2.42,5.42-2.42.99-1.76,1.8-1.45,1.8-1.45.49.36-.3,1.13-.3,1.13-2.37,2.83-6.68,3.85-6.68,3.85,1,1.1,4.24.33,4.24.33.68-.5,1.59-.55,1.59-.55.35.13-.07.64-.07.64-3.12,2.23-8.72.45-8.72.45-2.53.91-.84,2.09-.84,2.09,6.21,2.11,5.26,5.07,5.23,5.19l.08.03c4.91,2.28,8.26.98,8.26.98,3.91-.68,13.56-5.1,13.56-5.1,3.42-1.74,6.02-4.27,7.77-6.37,0,0,1.17-1.54,1.19-1.54.98-1.35,1.48-2.29,1.48-2.29.83-1.91,1.38-3.73,1.7-5.44,0,0,.15-.96.16-.96.75-5.17-.53-9.31-2.02-12.17l-.28-.53h0c-.31-.56-.62-1.06-.92-1.5,0,0-.11-.16-.18-.26-.02-.03-.04-.06-.06-.08-.36-.5-.94-1.2-.93-1.21-.52-.62-.87-.94-.87-.94-.46-.51-1.03-1-1.69-1.46-.27-.18-.48-.31-.48-.31h0c-6.68-4.2-21.03-5.85-21.03-5.85-7.44-1.6-4.41-7.2-4.41-7.2.61-.79.6-.04.6-.04-1.28,4.98,6.07,5.31,6.07,5.31,7.61.86,12.96,2.15,16.16,3.1.02,0,.53.16.53.16,2.07.64,3.09,1.09,3.09,1.09,6.31,3.1,9.57,7.54,11.1,12.06.02.02.13.4.13.4.56,1.78.87,3.56,1,5.27,0,0,.05.86.05.86,0,.02,0,.04,0,.05l.06,1.21s-.09,1.97-.18,2.9c0,0,0,0,0,0,0,.02-.01.12-.04.28-.1.9-.22,1.74-.37,2.51-.02.12-.03.18-.03.17-.25,1.33-.55,2.43-.79,3.23-.02.08-.05.17-.08.27-.23.72-.39,1.12-.39,1.12-.6,1.59-1.39,3.07-2.32,4.45,0,.01-.2.29-.2.29-1.3,1.89-2.84,3.58-4.49,5.09,0,.01-.39.35-.39.35-1.76,1.56-3.62,2.92-5.44,4.07,0,.01-2.17,1.31-2.17,1.3-1.48.85-2.89,1.55-4.11,2.11,0,.01-.36.17-.36.17-2.39,1.09-3.99,1.61-3.99,1.61-3.05.9-8.13,2.62-11.35,3.73l-1.18.42s0,0,0-.01c-1.11.38-1.81.62-1.81.62-1.67.37-2.34,1.31-2.34,1.31-2.45,2.74-4.15,3.16-4.15,3.16,2.63,1.47,4.04.97,4.04.97,3.53-1.29,6.16.29,6.16.29.95.66.33.79.33.79-1.62-.12-1.77-.51-1.77-.51-2.77-.79-4.25,1.25-4.25,1.25-.49,5.82,3.7,7.09,3.7,7.09,1.66.63,1.39,1.27,1.39,1.27-.17.34-.58.21-.58.21-4.76-1.35-5.98-5.49-5.98-5.49-.12-.55-.37-.17-.37-.17-.78,2.83,1.04,5.06,1.04,5.06,1.04.77.7,1.23.7,1.23-.16.17-.51-.16-.51-.16-2.4-2.09-2.37-6.11-2.37-6.11-.54.03-2.69,3.45-2.21,4.83.47,1.38-.14,1.36-.14,1.36-.26.07-.45-.95-.45-.95-.55-2.85,1.03-4.98,1.03-4.98.35-.47,0-.36,0-.36-1.03.34-2.66,2.59-2.66,2.59-.21.64-.39.93-.52,1.05-.16.1-.28.05-.34,0-.26-.21.06-.82.06-.82.78-1.58,2.67-3.55,2.67-3.55h0c-.58.2-3.25.77-3.25.77-1.42.26-2.98.45-2.98.45-1.94.1-2.18-1.27-2.18-1.27-.5-1.58.16-3.65.97-5.37-11.77-1.15-15.98-6.8-15.98-6.8-.24,1-.2,2.1-.2,2.1-.12,3.63-1.96,3.49-1.96,3.49-.63.1-1.92-.41-3.3-1.11-.23-.11-.45-.22-.61-.32-2.18-1.16-4.37-2.6-4.37-2.6-2.39-1.35-3.17-.71-3.17-.71-4.79,2.77-7.24.77-7.24.77-.07-.53,1.46-.24,1.46-.24,1.8.52,3.07-.26,3.07-.26.29-.16-.15-.22-.15-.22-3.83-.29-4.54-1.74-4.54-1.74,0,0-.37-.84.62-.22,2.17,1.08,4.43.79,4.43.79.47-.02.34-.44.34-.44-.14-.42-1.87-.78-1.87-.78-3.16-.91-4.15-2.75-4.15-2.75-.17-.77.7-.17.7-.17,2.42,2.22,4.94,2.32,5.74,2.28,0,0,.31,0,.29-.2-.03-.63-1.29-1.14-1.29-1.14-.72-.26-1.66-.8-2-1.02-.77-.43-1.14-1.02-1.14-1.02,0,0-.01-.02-.02-.02-.3-.59.34-.46.34-.46.92.21,1.73.82,1.73.82.68.66,3.02,1.98,3.02,1.98.63.44.57-.18.57-.18-.45-1.78-1.57-2.97-2.43-3.66-1.06-.37-1.1-.76-1.1-.76.03-.39,1.06-.03,1.06-.03,1.92.98,3.02,2.63,3.46,3.42,0,0,1.12,1.79,4.33,2.71,1.51.45,2.73.56,2.73.56,1.12.23.66-1.65.66-1.65-.3-1.58.16-3.48.3-4.19.14-.71-.54-2.13-.54-2.13h0c-.41.65-.95.52-.95.52-.65-.12-.95-.75-1.06-1.42h0c-.61,1.77-1.64,1.42-1.64,1.42-.79-.19-.88-1.04-.9-1.32-.01-.14.08-.58.08-.58-2.01.79-1.61-1.5-1.56-1.73l.11-.53c-.28.48-.69.39-.69.39-.94-.16-.8-1.84-.8-1.84l.02-.29c-1.43-.09-1.39-1.2-1.39-1.2v-1.08c-1.18-.05-1.18-.98-1.18-.98.15-.74-.08-2.67-.08-2.67-2.11-2.61-3.75-7.38-3.75-7.38-.94-3.3-.05-4.66-.05-4.66h0c.08-.29.18-.46.18-.46,1.14-1.84,2.78-.81,2.78-.81,0,0,4.42,2.82,8.15,3.05,3.48.21,3.9,2.75,3.95,3.08.33-.03.68,0,.89.26,0,0,.36.47-.01,1.11,0,0,.91-.5,1.27-.21,0,0,.28.42-.47,1.02,0,0,1.67-.61,2.16-.09,0,0,.11.61-.58,1.37,0,0,1.71-.67,2.26-.12,0,0,.07,1.04-1.32,1.67.25-.04,1.24-.15,1.87.46,0,0,.26.72-1.6,1.33,0,0,1.71.5,1.82,1.22,0,0,.11.49-1.32.8-.11.02-.23.04-.36.05.13.05.72.3.97.64,0,0,.21.24-.21.49-.11.06-.5.16-.67.21.36.15.89.46.87.75,0,0-.1.51-.92.78.21.03.69.12.85.45,0,0,.08.22-.25.43.79,1.64,2.25,1.59,2.25,1.59,1.07-1.06,2.6-1.1,2.6-1.1,1.88.1,2.98-.15,3.54-.36l-.02-.21c-.07-2.25-1.92-2.92-1.92-2.92-2.35-.49-3.96-2.09-3.96-2.09-1.59-1.54-.88-1.76-.88-1.76,1.04-.27,1.68,1.18,1.68,1.18.73.64,1.95.96,1.95.96.33.17.24-.4.24-.4-1.41-2.14-1.65-5.22-1.65-5.22,0-.48.4-.47.4-.47.69.62.5,1.62.5,1.62.25,1.34,1.79,3.22,1.79,3.22.66.48.62-.12.62-.12.18-2.11-.88-5.27-.88-5.27-1.03-1.24-.42-1.45-.42-1.45.41-.15,1.1.96,1.1.96.64,1,1.22,5.54,1.22,5.54.18.33.39.02.39.02.35-1.6-.15-4.37-.15-4.37-.63-.55-.4-1.4-.4-1.4.1-.27.43.03.43.03,1.47,1.27,1.01,5.73,1.01,5.73.05.68.7.13.7.13.52-.65.85-3.15.85-3.15-.38-.77-.11-1.33-.11-1.33.12-.44.37-.17.37-.17.93,1.64-.45,5.12-.45,5.12-.6,1.23.46,3.11.46,3.11,1.97,2.53,2.43,4.13,2.43,4.13.39,1.29-1.38,2.04-1.55,2.11l-.76.26s5.8-.57,7.86-.3Z"
          fill="none"
          strokeWidth="0"
        />
      </clipPath>
      <linearGradient
        id="Fade_to_Black_2"
        data-name="Fade to Black 2"
        x1="144.84"
        y1="304.85"
        x2="144.44"
        y2="303.6"
        gradientTransform="translate(30.79 -302.04) rotate(20.91)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#000" />
        <stop offset=".09" stopColor="#000" stopOpacity=".8" />
        <stop offset="1" stopColor="#000" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="Fade_to_Black_2-2"
        data-name="Fade to Black 2"
        x1="146.54"
        y1="305.55"
        x2="145.86"
        y2="303.4"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-3"
        data-name="Fade to Black 2"
        x1="148.03"
        y1="305.63"
        x2="147.52"
        y2="304.03"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-4"
        data-name="Fade to Black 2"
        x1="149.76"
        y1="306.63"
        x2="148.97"
        y2="304.12"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-5"
        data-name="Fade to Black 2"
        x1="151.7"
        y1="307.5"
        x2="150.79"
        y2="304.63"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-6"
        data-name="Fade to Black 2"
        x1="153.06"
        y1="308.86"
        x2="152.22"
        y2="306.2"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-7"
        data-name="Fade to Black 2"
        x1="154.05"
        y1="310.73"
        x2="153.1"
        y2="307.73"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-8"
        data-name="Fade to Black 2"
        x1="154.18"
        y1="311.93"
        x2="153.57"
        y2="310.02"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-9"
        data-name="Fade to Black 2"
        x1="154.66"
        y1="313.46"
        x2="153.93"
        y2="311.14"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-10"
        data-name="Fade to Black 2"
        x1="155.15"
        y1="314.11"
        x2="154.75"
        y2="312.84"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-11"
        data-name="Fade to Black 2"
        x1="141.34"
        y1="307.45"
        x2="141.02"
        y2="306.44"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-12"
        data-name="Fade to Black 2"
        x1="142.92"
        y1="307.8"
        x2="142.51"
        y2="306.51"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-13"
        data-name="Fade to Black 2"
        x1="144.55"
        y1="308.51"
        x2="144.01"
        y2="306.8"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-14"
        data-name="Fade to Black 2"
        x1="146.5"
        y1="309.53"
        x2="145.78"
        y2="307.26"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-15"
        data-name="Fade to Black 2"
        x1="148.66"
        y1="310.8"
        x2="147.76"
        y2="307.95"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-16"
        data-name="Fade to Black 2"
        x1="149.62"
        y1="312.29"
        x2="148.8"
        y2="309.7"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-17"
        data-name="Fade to Black 2"
        x1="150.44"
        y1="313.96"
        x2="149.57"
        y2="311.2"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-18"
        data-name="Fade to Black 2"
        x1="150.58"
        y1="315.38"
        x2="149.91"
        y2="313.27"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-19"
        data-name="Fade to Black 2"
        x1="150.94"
        y1="316.65"
        x2="150.33"
        y2="314.72"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-20"
        data-name="Fade to Black 2"
        x1="151.38"
        y1="317.97"
        x2="150.78"
        y2="316.06"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="linear-gradient"
        x1="159.9"
        y1="318.65"
        x2="161.83"
        y2="318.65"
        gradientTransform="translate(30.79 -302.04) rotate(20.91)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#bfbfbf" />
        <stop offset="1" stopColor="#8f8f8f" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1="163.4"
        y1="318.55"
        x2="165.29"
        y2="318.55"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-3"
        x1="167.41"
        y1="318.05"
        x2="169.97"
        y2="318.05"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-4"
        x1="172.64"
        y1="316.87"
        x2="175.74"
        y2="316.87"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-5"
        x1="177.19"
        y1="315.64"
        x2="180.05"
        y2="315.64"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-6"
        x1="181.71"
        y1="313.8"
        x2="184.74"
        y2="313.8"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-7"
        x1="186.48"
        y1="311.97"
        x2="189.38"
        y2="311.97"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-8"
        x1="190.89"
        y1="310.16"
        x2="193.49"
        y2="310.16"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-9"
        x1="195.15"
        y1="307.49"
        x2="197.48"
        y2="307.49"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-10"
        x1="199.25"
        y1="304.1"
        x2="201.57"
        y2="304.1"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-11"
        x1="202.82"
        y1="300.85"
        x2="204.71"
        y2="300.85"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-12"
        x1="205.8"
        y1="297"
        x2="207.31"
        y2="297"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-13"
        x1="208.4"
        y1="292.97"
        x2="209.61"
        y2="292.97"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-14"
        x1="210.34"
        y1="289.14"
        x2="211.15"
        y2="289.14"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-15"
        x1="211.43"
        y1="285.25"
        x2="212.03"
        y2="285.25"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-16"
        x1="211.86"
        y1="281.77"
        x2="212.33"
        y2="281.77"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-17"
        x1="211.5"
        y1="278.26"
        x2="211.98"
        y2="278.26"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-18"
        x1="179.48"
        y1="262.17"
        x2="180.64"
        y2="262.17"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-19"
        x1="182"
        y1="261.69"
        x2="183.09"
        y2="261.69"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-20"
        x1="184.67"
        y1="261.15"
        x2="185.82"
        y2="261.15"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-21"
        x1="187.81"
        y1="260.67"
        x2="189.29"
        y2="260.67"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-22"
        x1="190.85"
        y1="260.38"
        x2="192.25"
        y2="260.38"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-23"
        x1="193.99"
        y1="260.47"
        x2="195.56"
        y2="260.47"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-24"
        x1="196.89"
        y1="260.78"
        x2="198.78"
        y2="260.78"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-25"
        x1="200.66"
        y1="262.03"
        x2="202.43"
        y2="262.03"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-26"
        x1="203.87"
        y1="264.05"
        x2="205.6"
        y2="264.05"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-27"
        x1="207.22"
        y1="267.36"
        x2="208.56"
        y2="267.36"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-28"
        x1="209.22"
        y1="270.82"
        x2="210.18"
        y2="270.82"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-29"
        x1="210.9"
        y1="274.8"
        x2="211.39"
        y2="274.8"
        href="#linear-gradient"
      />
      <linearGradient
        id="Fade_to_Black_2-21"
        data-name="Fade to Black 2"
        x1="160.85"
        y1="318.98"
        x2="160.93"
        y2="318.06"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-22"
        data-name="Fade to Black 2"
        x1="164.44"
        y1="319.09"
        x2="164.07"
        y2="317.91"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-23"
        data-name="Fade to Black 2"
        x1="168.82"
        y1="318.72"
        x2="168.37"
        y2="317.3"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-24"
        data-name="Fade to Black 2"
        x1="174.27"
        y1="317.32"
        x2="173.84"
        y2="315.96"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-25"
        data-name="Fade to Black 2"
        x1="178.68"
        y1="316.04"
        x2="178.29"
        y2="314.79"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-26"
        data-name="Fade to Black 2"
        x1="183.34"
        y1="314.33"
        x2="182.83"
        y2="312.72"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-27"
        data-name="Fade to Black 2"
        x1="188.01"
        y1="312.41"
        x2="187.53"
        y2="310.87"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-28"
        data-name="Fade to Black 2"
        x1="192.32"
        y1="310.66"
        x2="191.84"
        y2="309.12"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-29"
        data-name="Fade to Black 2"
        x1="196.52"
        y1="308.14"
        x2="195.95"
        y2="306.34"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-30"
        data-name="Fade to Black 2"
        x1="200.68"
        y1="304.94"
        x2="200"
        y2="302.8"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-31"
        data-name="Fade to Black 2"
        x1="204.11"
        y1="301.87"
        x2="203.34"
        y2="299.43"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-32"
        data-name="Fade to Black 2"
        x1="206.98"
        y1="298.13"
        x2="206.14"
        y2="295.47"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-33"
        data-name="Fade to Black 2"
        x1="209.38"
        y1="294"
        x2="208.62"
        y2="291.57"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-34"
        data-name="Fade to Black 2"
        x1="211.09"
        y1="290.06"
        x2="210.4"
        y2="287.86"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-35"
        data-name="Fade to Black 2"
        x1="212.2"
        y1="286.41"
        x2="211.34"
        y2="283.7"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-36"
        data-name="Fade to Black 2"
        x1="212.56"
        y1="283.1"
        x2="211.57"
        y2="279.99"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-37"
        data-name="Fade to Black 2"
        x1="212.11"
        y1="279.4"
        x2="211.26"
        y2="276.71"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-38"
        data-name="Fade to Black 2"
        x1="179.49"
        y1="262.16"
        x2="180.64"
        y2="262.16"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-39"
        data-name="Fade to Black 2"
        x1="182"
        y1="261.67"
        x2="183.09"
        y2="261.67"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-40"
        data-name="Fade to Black 2"
        x1="184.67"
        y1="261.14"
        x2="185.82"
        y2="261.14"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-41"
        data-name="Fade to Black 2"
        x1="187.81"
        y1="260.66"
        x2="189.29"
        y2="260.66"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-42"
        data-name="Fade to Black 2"
        x1="190.85"
        y1="260.36"
        x2="192.25"
        y2="260.36"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-43"
        data-name="Fade to Black 2"
        x1="193.99"
        y1="260.46"
        x2="195.56"
        y2="260.46"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-44"
        data-name="Fade to Black 2"
        x1="196.89"
        y1="260.76"
        x2="198.78"
        y2="260.76"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-45"
        data-name="Fade to Black 2"
        x1="200.66"
        y1="262.01"
        x2="202.43"
        y2="262.01"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-46"
        data-name="Fade to Black 2"
        x1="203.87"
        y1="264.04"
        x2="205.6"
        y2="264.04"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-47"
        data-name="Fade to Black 2"
        x1="207.22"
        y1="267.35"
        x2="208.57"
        y2="267.35"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-48"
        data-name="Fade to Black 2"
        x1="209.22"
        y1="270.8"
        x2="210.18"
        y2="270.8"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-49"
        data-name="Fade to Black 2"
        x1="210.9"
        y1="274.79"
        x2="211.39"
        y2="274.79"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="linear-gradient-30"
        x1="161.51"
        y1="318.39"
        x2="160.8"
        y2="318.79"
        gradientTransform="translate(30.79 -302.04) rotate(20.91)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#d4d4d4" />
        <stop offset=".2" stopColor="#d4d4d4" stopOpacity=".71" />
        <stop offset=".4" stopColor="#d4d4d4" stopOpacity=".46" />
        <stop offset=".59" stopColor="#d4d4d4" stopOpacity=".26" />
        <stop offset=".76" stopColor="#d4d4d4" stopOpacity=".12" />
        <stop offset=".9" stopColor="#d4d4d4" stopOpacity=".03" />
        <stop offset="1" stopColor="#d4d4d4" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-31"
        x1="164.73"
        y1="318.19"
        x2="164.39"
        y2="318.68"
        gradientTransform="translate(30.79 -302.04) rotate(20.91)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#d4d4d4" />
        <stop offset=".1" stopColor="#d4d4d4" stopOpacity=".79" />
        <stop offset=".2" stopColor="#d4d4d4" stopOpacity=".58" />
        <stop offset=".32" stopColor="#d4d4d4" stopOpacity=".4" />
        <stop offset=".43" stopColor="#d4d4d4" stopOpacity=".25" />
        <stop offset=".55" stopColor="#d4d4d4" stopOpacity=".14" />
        <stop offset=".68" stopColor="#d4d4d4" stopOpacity=".06" />
        <stop offset=".82" stopColor="#d4d4d4" stopOpacity=".02" />
        <stop offset="1" stopColor="#d4d4d4" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-32"
        x1="169.24"
        y1="317.58"
        x2="168.68"
        y2="318.33"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-33"
        x1="175.09"
        y1="316.11"
        x2="174.34"
        y2="316.79"
        href="#linear-gradient-30"
      />
      <linearGradient
        id="linear-gradient-34"
        x1="179.34"
        y1="314.85"
        x2="178.73"
        y2="315.64"
        href="#linear-gradient-30"
      />
      <linearGradient
        id="linear-gradient-35"
        x1="184.16"
        y1="312.84"
        x2="183.45"
        y2="313.48"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-36"
        x1="188.58"
        y1="311.1"
        x2="187.43"
        y2="312.43"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-37"
        x1="192.85"
        y1="309.11"
        x2="192.05"
        y2="310.26"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-38"
        x1="196.66"
        y1="306.4"
        x2="196.33"
        y2="307.37"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-39"
        x1="200.56"
        y1="303.05"
        x2="200.38"
        y2="304.08"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-40"
        x1="203.51"
        y1="300"
        x2="203.74"
        y2="300.69"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-41"
        x1="206.36"
        y1="296.09"
        x2="206.59"
        y2="296.89"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-42"
        x1="208.65"
        y1="292.39"
        x2="209.08"
        y2="292.98"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-43"
        x1="210.54"
        y1="288.43"
        x2="210.83"
        y2="289.2"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-44"
        x1="211.56"
        y1="284.82"
        x2="211.84"
        y2="285.2"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-45"
        x1="211.84"
        y1="281.22"
        x2="212.2"
        y2="281.83"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-46"
        x1="211.58"
        y1="277.67"
        x2="211.86"
        y2="278.62"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-47"
        x1="179.78"
        y1="261.97"
        x2="180.14"
        y2="262.24"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-48"
        x1="182.23"
        y1="261.48"
        x2="182.54"
        y2="261.69"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-49"
        x1="185.2"
        y1="261.05"
        x2="185.28"
        y2="261.28"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-50"
        x1="188.45"
        y1="260.43"
        x2="188.66"
        y2="261.07"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-51"
        x1="191.48"
        y1="260.2"
        x2="191.66"
        y2="260.76"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-52"
        x1="194.5"
        y1="260.15"
        x2="194.81"
        y2="260.56"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-53"
        x1="196.89"
        y1="260.76"
        x2="198.78"
        y2="260.76"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-54"
        x1="201.31"
        y1="261.6"
        x2="201.6"
        y2="262.22"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-55"
        x1="204.16"
        y1="263.54"
        x2="205.11"
        y2="264.33"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-56"
        x1="207.38"
        y1="266.86"
        x2="208.26"
        y2="267.8"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-57"
        x1="209.41"
        y1="270.17"
        x2="209.77"
        y2="271.01"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="linear-gradient-58"
        x1="210.97"
        y1="273.96"
        x2="211.15"
        y2="274.78"
        href="#linear-gradient-31"
      />
      <linearGradient
        id="Fade_to_Black_2-50"
        data-name="Fade to Black 2"
        x1="40.14"
        y1="41.04"
        x2="41.53"
        y2="37.52"
        gradientTransform="translate(6.74 3.95) rotate(-.66)"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-51"
        data-name="Fade to Black 2"
        x1="41.41"
        y1="43.32"
        x2="42.96"
        y2="39.38"
        gradientTransform="translate(6.74 3.95) rotate(-.66)"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-52"
        data-name="Fade to Black 2"
        x1="42.75"
        y1="45.68"
        x2="44.34"
        y2="41.66"
        gradientTransform="translate(6.74 3.95) rotate(-.66)"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="Fade_to_Black_2-53"
        data-name="Fade to Black 2"
        x1="44.29"
        y1="47.76"
        x2="45.74"
        y2="44.09"
        gradientTransform="translate(6.74 3.95) rotate(-.66)"
        href="#Fade_to_Black_2"
      />
      <linearGradient
        id="linear-gradient-59"
        x1="45.96"
        y1="49.51"
        x2="47.21"
        y2="46.36"
        gradientTransform="translate(6.74 3.95) rotate(-.66)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#000" />
        <stop offset="1" stopColor="#000" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-60"
        x1="48.44"
        y1="49.7"
        x2="50.15"
        y2="45.39"
        gradientTransform="translate(6.74 3.95) rotate(-.66)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#000" />
        <stop offset=".72" stopColor="#000" stopOpacity="0" />
      </linearGradient>
    </defs>
    <g>
      <g id="Layer_1" data-name="Layer 1">
        <g>
          <path
            d="m83.03,50.26c-3.45-2.25-3.25-4.12-3.25-4.12-.51-1.93,5.18-2.73,5.18-2.73,1.2-.34,1.17-1.42,1.17-1.42.93-3.96,2.39-5.32,2.39-5.32.59-.71.78-.28.78-.28.04,1.17-.67,1.3-.67,1.3-.95,1.33-.97,3.01-.97,3.01.31,1.5.85.33.85.33.92-2.41,3.27-4.36,3.27-4.36.77-.73.97-.21.97-.21-.21,1.25-1.14,1.48-1.14,1.48-.75.91-2.13,3.01-2.13,3.01-.65,1.13.12.98.12.98,1.51-1.51,4.92-3.55,4.92-3.55,1.1-.43,1.09.06,1.09.06-.36,1.29-1.49,1.21-1.49,1.21-1.63.67-3.14,2.98-3.14,2.98-.56.63.4.69.4.69,1.37.03,5.42-2.42,5.42-2.42.99-1.76,1.8-1.45,1.8-1.45.49.36-.3,1.13-.3,1.13-2.37,2.83-6.68,3.85-6.68,3.85,1,1.1,4.24.33,4.24.33.68-.5,1.59-.55,1.59-.55.35.13-.07.64-.07.64-3.12,2.23-8.72.45-8.72.45-2.53.91-.84,2.09-.84,2.09,6.21,2.11,5.26,5.07,5.23,5.19l.08.03c4.91,2.28,8.26.98,8.26.98,3.91-.68,13.56-5.1,13.56-5.1,3.42-1.74,6.02-4.27,7.77-6.37,0,0,1.17-1.54,1.19-1.54.98-1.35,1.48-2.29,1.48-2.29.83-1.91,1.38-3.73,1.7-5.44,0,0,.15-.96.16-.96.75-5.17-.53-9.31-2.02-12.17l-.28-.53h0c-.31-.56-.62-1.06-.92-1.5,0,0-.11-.16-.18-.26-.02-.03-.04-.06-.06-.08-.36-.5-.94-1.2-.93-1.21-.52-.62-.87-.94-.87-.94-.46-.51-1.03-1-1.69-1.46-.27-.18-.48-.31-.48-.31h0c-6.68-4.2-21.03-5.85-21.03-5.85-7.44-1.6-4.41-7.2-4.41-7.2.61-.79.6-.04.6-.04-1.28,4.98,6.07,5.31,6.07,5.31,7.61.86,12.96,2.15,16.16,3.1.02,0,.53.16.53.16,2.07.64,3.09,1.09,3.09,1.09,6.31,3.1,9.57,7.54,11.1,12.06.02.02.13.4.13.4.56,1.78.87,3.56,1,5.27,0,0,.05.86.05.86,0,.02,0,.04,0,.05l.06,1.21s-.09,1.97-.18,2.9c0,0,0,0,0,0,0,.02-.01.12-.04.28-.1.9-.22,1.74-.37,2.51-.02.12-.03.18-.03.17-.25,1.33-.55,2.43-.79,3.23-.02.08-.05.17-.08.27-.23.72-.39,1.12-.39,1.12-.6,1.59-1.39,3.07-2.32,4.45,0,.01-.2.29-.2.29-1.3,1.89-2.84,3.58-4.49,5.09,0,.01-.39.35-.39.35-1.76,1.56-3.62,2.92-5.44,4.07,0,.01-2.17,1.31-2.17,1.3-1.48.85-2.89,1.55-4.11,2.11,0,.01-.36.17-.36.17-2.39,1.09-3.99,1.61-3.99,1.61-3.05.9-8.13,2.62-11.35,3.73l-1.18.42s0,0,0-.01c-1.11.38-1.81.62-1.81.62-1.67.37-2.34,1.31-2.34,1.31-2.45,2.74-4.15,3.16-4.15,3.16,2.63,1.47,4.04.97,4.04.97,3.53-1.29,6.16.29,6.16.29.95.66.33.79.33.79-1.62-.12-1.77-.51-1.77-.51-2.77-.79-4.25,1.25-4.25,1.25-.49,5.82,3.7,7.09,3.7,7.09,1.66.63,1.39,1.27,1.39,1.27-.17.34-.58.21-.58.21-4.76-1.35-5.98-5.49-5.98-5.49-.12-.55-.37-.17-.37-.17-.78,2.83,1.04,5.06,1.04,5.06,1.04.77.7,1.23.7,1.23-.16.17-.51-.16-.51-.16-2.4-2.09-2.37-6.11-2.37-6.11-.54.03-2.69,3.45-2.21,4.83.47,1.38-.14,1.36-.14,1.36-.26.07-.45-.95-.45-.95-.55-2.85,1.03-4.98,1.03-4.98.35-.47,0-.36,0-.36-1.03.34-2.66,2.59-2.66,2.59-.21.64-.39.93-.52,1.05-.16.1-.28.05-.34,0-.26-.21.06-.82.06-.82.78-1.58,2.67-3.55,2.67-3.55h0c-.58.2-3.25.77-3.25.77-1.42.26-2.98.45-2.98.45-1.94.1-2.18-1.27-2.18-1.27-.5-1.58.16-3.65.97-5.37-11.77-1.15-15.98-6.8-15.98-6.8-.24,1-.2,2.1-.2,2.1-.12,3.63-1.96,3.49-1.96,3.49-.63.1-1.92-.41-3.3-1.11-.23-.11-.45-.22-.61-.32-2.18-1.16-4.37-2.6-4.37-2.6-2.39-1.35-3.17-.71-3.17-.71-4.79,2.77-7.24.77-7.24.77-.07-.53,1.46-.24,1.46-.24,1.8.52,3.07-.26,3.07-.26.29-.16-.15-.22-.15-.22-3.83-.29-4.54-1.74-4.54-1.74,0,0-.37-.84.62-.22,2.17,1.08,4.43.79,4.43.79.47-.02.34-.44.34-.44-.14-.42-1.87-.78-1.87-.78-3.16-.91-4.15-2.75-4.15-2.75-.17-.77.7-.17.7-.17,2.42,2.22,4.94,2.32,5.74,2.28,0,0,.31,0,.29-.2-.03-.63-1.29-1.14-1.29-1.14-.72-.26-1.66-.8-2-1.02-.77-.43-1.14-1.02-1.14-1.02,0,0-.01-.02-.02-.02-.3-.59.34-.46.34-.46.92.21,1.73.82,1.73.82.68.66,3.02,1.98,3.02,1.98.63.44.57-.18.57-.18-.45-1.78-1.57-2.97-2.43-3.66-1.06-.37-1.1-.76-1.1-.76.03-.39,1.06-.03,1.06-.03,1.92.98,3.02,2.63,3.46,3.42,0,0,1.12,1.79,4.33,2.71,1.51.45,2.73.56,2.73.56,1.12.23.66-1.65.66-1.65-.3-1.58.16-3.48.3-4.19.14-.71-.54-2.13-.54-2.13h0c-.41.65-.95.52-.95.52-.65-.12-.95-.75-1.06-1.42h0c-.61,1.77-1.64,1.42-1.64,1.42-.79-.19-.88-1.04-.9-1.32-.01-.14.08-.58.08-.58-2.01.79-1.61-1.5-1.56-1.73l.11-.53c-.28.48-.69.39-.69.39-.94-.16-.8-1.84-.8-1.84l.02-.29c-1.43-.09-1.39-1.2-1.39-1.2v-1.08c-1.18-.05-1.18-.98-1.18-.98.15-.74-.08-2.67-.08-2.67-2.11-2.61-3.75-7.38-3.75-7.38-.94-3.3-.05-4.66-.05-4.66h0c.08-.29.18-.46.18-.46,1.14-1.84,2.78-.81,2.78-.81,0,0,4.42,2.82,8.15,3.05,3.48.21,3.9,2.75,3.95,3.08.33-.03.68,0,.89.26,0,0,.36.47-.01,1.11,0,0,.91-.5,1.27-.21,0,0,.28.42-.47,1.02,0,0,1.67-.61,2.16-.09,0,0,.11.61-.58,1.37,0,0,1.71-.67,2.26-.12,0,0,.07,1.04-1.32,1.67.25-.04,1.24-.15,1.87.46,0,0,.26.72-1.6,1.33,0,0,1.71.5,1.82,1.22,0,0,.11.49-1.32.8-.11.02-.23.04-.36.05.13.05.72.3.97.64,0,0,.21.24-.21.49-.11.06-.5.16-.67.21.36.15.89.46.87.75,0,0-.1.51-.92.78.21.03.69.12.85.45,0,0,.08.22-.25.43.79,1.64,2.25,1.59,2.25,1.59,1.07-1.06,2.6-1.1,2.6-1.1,1.88.1,2.98-.15,3.54-.36l-.02-.21c-.07-2.25-1.92-2.92-1.92-2.92-2.35-.49-3.96-2.09-3.96-2.09-1.59-1.54-.88-1.76-.88-1.76,1.04-.27,1.68,1.18,1.68,1.18.73.64,1.95.96,1.95.96.33.17.24-.4.24-.4-1.41-2.14-1.65-5.22-1.65-5.22,0-.48.4-.47.4-.47.69.62.5,1.62.5,1.62.25,1.34,1.79,3.22,1.79,3.22.66.48.62-.12.62-.12.18-2.11-.88-5.27-.88-5.27-1.03-1.24-.42-1.45-.42-1.45.41-.15,1.1.96,1.1.96.64,1,1.22,5.54,1.22,5.54.18.33.39.02.39.02.35-1.6-.15-4.37-.15-4.37-.63-.55-.4-1.4-.4-1.4.1-.27.43.03.43.03,1.47,1.27,1.01,5.73,1.01,5.73.05.68.7.13.7.13.52-.65.85-3.15.85-3.15-.38-.77-.11-1.33-.11-1.33.12-.44.37-.17.37-.17.93,1.64-.45,5.12-.45,5.12-.6,1.23.46,3.11.46,3.11,1.97,2.53,2.43,4.13,2.43,4.13.39,1.29-1.38,2.04-1.55,2.11l-.76.26s5.8-.57,7.86-.3Z"
            strokeWidth="0"
          />
          <g>
            <path
              d="m24.72,18.68c1.54-1.37,2.5-3.08,2.5-5.02,0-4.19-4.39-7.58-9.79-7.58H0v27.54s16.82,0,16.82,0c6.24,0,11.29-3.92,11.28-8.72,0-2.43-1.31-4.63-3.38-6.21Zm-15.55-7.58h5.05c1.8,0,3.3,1.14,3.3,2.56s-1.49,2.51-3.3,2.51h-5.05v-5.06Zm4.75,17.49h-4.74s0-7.4,0-7.4h4.74c2.64,0,4.79,1.67,4.79,3.7,0,2.02-2.15,3.7-4.78,3.7Z"
              strokeWidth="0"
            />
            <path
              d="m78.6,33.61h21.2s0-5.02,0-5.02h-7.81l8.69-12.42h-20.33s-6.41,0-6.41,0V7.53s-9.18,0-9.18,0v8.63h-2.99s0,5.02,0,5.02h2.99s0,6.34,0,6.34c0,3.35,2.72,6.07,6.06,6.08h5.58s0-4.32,0-4.32h-1.27c-.66,0-1.19-.52-1.19-1.19v-6.91s7.39,0,7.39,0h0s5.96,0,5.96,0l-8.69,12.42Z"
              strokeWidth="0"
            />
            <rect
              x="51.33"
              y="16.17"
              width="9.18"
              height="17.44"
              strokeWidth="0"
            />
            <path
              d="m44.96,15.28c-4.79,0-5.97,2.16-11.02,2.16-1.84,0-3.56-.84-4.56-2.16v18.33h9.18s0-13.43,0-13.39c.31-.4.79-.61,1.32-.61.35,0,.7.09.96.3,0,2.47,2.07,4.54,4.57,4.53,2.5,0,4.61-2.07,4.61-4.58,0-2.51-2.54-4.58-5.05-4.58Z"
              strokeWidth="0"
            />
          </g>
          <path
            d="m83.03,50.26c-3.45-2.25-3.25-4.12-3.25-4.12-.51-1.93,5.18-2.73,5.18-2.73,1.2-.34,1.17-1.42,1.17-1.42.93-3.96,2.39-5.32,2.39-5.32.59-.71.78-.28.78-.28.04,1.17-.67,1.3-.67,1.3-.95,1.33-.97,3.01-.97,3.01.31,1.5.85.33.85.33.92-2.41,3.27-4.36,3.27-4.36.77-.73.97-.21.97-.21-.21,1.25-1.14,1.48-1.14,1.48-.75.91-2.13,3.01-2.13,3.01-.66,1.13.11.98.11.98,1.51-1.51,4.92-3.55,4.92-3.55,1.1-.43,1.09.06,1.09.06-.36,1.29-1.49,1.21-1.49,1.21-1.63.67-3.14,2.98-3.14,2.98-.56.63.4.69.4.69,1.37.03,5.42-2.42,5.42-2.42.99-1.76,1.8-1.45,1.8-1.45.49.36-.3,1.13-.3,1.13-2.37,2.83-6.68,3.85-6.68,3.85,1,1.1,4.24.33,4.24.33.68-.5,1.59-.55,1.59-.55.35.13-.07.64-.07.64-3.12,2.23-8.72.45-8.72.45-2.53.91-.84,2.09-.84,2.09,6.21,2.11,5.26,5.07,5.23,5.19l.08.03c4.91,2.28,8.26.98,8.26.98,3.91-.68,13.56-5.1,13.56-5.1,3.42-1.74,6.02-4.27,7.77-6.37,0,0,1.17-1.54,1.19-1.54.98-1.35,1.48-2.29,1.48-2.29.83-1.91,1.38-3.73,1.7-5.44,0,0,.15-.96.16-.96.75-5.17-.53-9.31-2.02-12.17l-.28-.53h0c-.31-.56-.62-1.06-.92-1.5,0,0-.11-.16-.18-.26-.02-.03-.04-.06-.06-.08-.36-.5-.94-1.2-.93-1.21-.52-.62-.87-.94-.87-.94-.46-.51-1.03-1-1.69-1.46-.27-.18-.48-.31-.48-.31h0c-6.68-4.2-21.03-5.85-21.03-5.85-7.44-1.6-4.41-7.2-4.41-7.2.61-.79.6-.04.6-.04-1.28,4.98,6.07,5.31,6.07,5.31,7.61.86,12.96,2.15,16.16,3.1.02,0,.53.16.53.16,2.07.64,3.09,1.09,3.09,1.09,6.31,3.1,9.57,7.54,11.1,12.06.02.02.13.4.13.4.56,1.78.87,3.56,1,5.27,0,0,.05.86.05.86,0,.02,0,.04,0,.05l.06,1.21s-.09,1.97-.18,2.9c0,0,0,0,0,0,0,.02-.01.12-.04.28-.1.9-.22,1.74-.37,2.51-.02.12-.03.18-.03.17-.25,1.33-.55,2.43-.79,3.23-.02.08-.05.17-.08.27-.23.72-.39,1.12-.39,1.12-.6,1.59-1.39,3.07-2.32,4.45,0,.01-.2.29-.2.29-1.3,1.89-2.84,3.58-4.49,5.09,0,.01-.39.35-.39.35-1.76,1.56-3.62,2.92-5.44,4.07,0,.01-2.17,1.31-2.17,1.3-1.48.85-2.89,1.55-4.11,2.11,0,.01,0,.02,0,.02l-.36.15c-2.39,1.09-3.99,1.61-3.99,1.61-3.05.9-8.13,2.62-11.35,3.73l-1.18.42s0,0,0-.01c-1.11.38-1.81.62-1.81.62-1.67.37-2.34,1.31-2.34,1.31-2.45,2.74-4.15,3.16-4.15,3.16,2.63,1.47,4.04.97,4.04.97,3.53-1.29,6.16.29,6.16.29.95.66.33.79.33.79-1.62-.12-1.77-.51-1.77-.51-2.77-.79-4.25,1.25-4.25,1.25-.49,5.82,3.7,7.09,3.7,7.09,1.66.63,1.39,1.27,1.39,1.27-.17.34-.58.21-.58.21-4.76-1.35-5.98-5.49-5.98-5.49-.12-.55-.37-.17-.37-.17-.78,2.83,1.04,5.06,1.04,5.06,1.04.77.7,1.23.7,1.23-.16.17-.51-.16-.51-.16-2.4-2.09-2.37-6.11-2.37-6.11-.54.03-2.69,3.45-2.21,4.83.47,1.38-.14,1.36-.14,1.36-.26.07-.45-.95-.45-.95-.55-2.85,1.03-4.98,1.03-4.98.35-.47,0-.36,0-.36-1.03.34-2.66,2.59-2.66,2.59-.21.64-.39.93-.52,1.05-.16.1-.28.05-.34,0-.26-.21.06-.82.06-.82.78-1.58,2.67-3.55,2.67-3.55h0c-.58.2-3.25.77-3.25.77-1.42.26-2.98.45-2.98.45-1.94.1-2.18-1.27-2.18-1.27-.5-1.58.16-3.65.97-5.37-11.77-1.15-15.98-6.8-15.98-6.8-.24,1-.2,2.1-.2,2.1-.12,3.63-1.96,3.49-1.96,3.49-.63.1-1.92-.41-3.3-1.11-.23-.11-.45-.22-.61-.32-2.18-1.16-4.37-2.6-4.37-2.6-2.39-1.35-3.17-.71-3.17-.71-4.79,2.77-7.24.77-7.24.77-.07-.53,1.46-.24,1.46-.24,1.8.52,3.07-.26,3.07-.26.29-.16-.15-.22-.15-.22-3.83-.29-4.54-1.74-4.54-1.74,0,0-.37-.84.62-.22,2.17,1.08,4.43.79,4.43.79.47-.02.34-.44.34-.44-.14-.42-1.87-.78-1.87-.78-3.16-.91-4.15-2.75-4.15-2.75-.17-.77.7-.17.7-.17,2.42,2.22,4.94,2.32,5.74,2.28,0,0,.31,0,.29-.2-.03-.63-1.29-1.14-1.29-1.14-.72-.26-1.66-.8-2-1.02-.77-.43-1.14-1.02-1.14-1.02,0,0-.01-.02-.02-.02-.3-.59.34-.46.34-.46.92.21,1.73.82,1.73.82.68.66,3.02,1.98,3.02,1.98.63.44.57-.18.57-.18-.45-1.78-1.57-2.97-2.43-3.66-1.06-.37-1.1-.76-1.1-.76.03-.39,1.06-.03,1.06-.03,1.92.98,3.02,2.63,3.46,3.42,0,0,1.12,1.79,4.33,2.71,1.51.45,2.73.56,2.73.56,1.12.23.66-1.65.66-1.65-.3-1.58.16-3.48.3-4.19.14-.71-.54-2.13-.54-2.13h0c-.41.65-.95.52-.95.52-.65-.12-.95-.75-1.06-1.42h0c-.61,1.77-1.64,1.42-1.64,1.42-.79-.19-.88-1.04-.9-1.32-.01-.14.08-.58.08-.58-2.01.79-1.61-1.5-1.56-1.73l.11-.53c-.28.48-.69.39-.69.39-.94-.16-.8-1.84-.8-1.84l.02-.29c-1.43-.09-1.39-1.2-1.39-1.2v-1.08c-1.18-.05-1.18-.98-1.18-.98.15-.74-.08-2.67-.08-2.67-2.11-2.61-3.75-7.38-3.75-7.38-.94-3.3-.05-4.66-.05-4.66h0c.08-.29.18-.46.18-.46,1.14-1.84,2.78-.81,2.78-.81,0,0,4.42,2.82,8.15,3.05,3.48.21,3.9,2.75,3.95,3.08.33-.03.68,0,.89.26,0,0,.36.47-.01,1.11,0,0,.91-.5,1.27-.21,0,0,.28.42-.47,1.02,0,0,1.67-.61,2.16-.09,0,0,.11.61-.58,1.37,0,0,1.71-.67,2.26-.12,0,0,.07,1.04-1.32,1.67.25-.04,1.24-.15,1.87.46,0,0,.26.72-1.6,1.33,0,0,1.71.5,1.82,1.22,0,0,.11.49-1.32.8-.11.02-.23.04-.36.05.13.05.72.3.97.64,0,0,.21.24-.21.49-.11.06-.5.16-.67.21.36.15.89.46.87.75,0,0-.1.51-.92.78.21.03.69.12.85.45,0,0,.08.22-.25.43.79,1.64,2.25,1.59,2.25,1.59,1.07-1.06,2.6-1.1,2.6-1.1,1.88.1,2.98-.15,3.54-.36l-.02-.21c-.07-2.25-1.92-2.92-1.92-2.92-2.35-.49-3.96-2.09-3.96-2.09-1.59-1.54-.88-1.76-.88-1.76,1.04-.27,1.68,1.18,1.68,1.18.73.64,1.95.96,1.95.96.33.17.24-.4.24-.4-1.41-2.14-1.65-5.22-1.65-5.22,0-.48.4-.47.4-.47.69.62.5,1.62.5,1.62.25,1.34,1.79,3.22,1.79,3.22.66.48.62-.12.62-.12.18-2.11-.88-5.27-.88-5.27-1.03-1.24-.42-1.45-.42-1.45.41-.15,1.1.96,1.1.96.64,1,1.22,5.54,1.22,5.54.18.33.39.02.39.02.35-1.6-.15-4.37-.15-4.37-.63-.55-.4-1.4-.4-1.4.1-.27.43.03.43.03,1.47,1.27,1.01,5.73,1.01,5.73.05.68.7.13.7.13.52-.65.85-3.15.85-3.15-.38-.77-.11-1.33-.11-1.33.12-.44.37-.17.37-.17.93,1.64-.45,5.12-.45,5.12-.6,1.23.46,3.11.46,3.11,1.97,2.53,2.43,4.13,2.43,4.13.39,1.29-1.38,2.04-1.55,2.11l-.76.26s5.8-.57,7.86-.3Z"
            fill="none"
            strokeWidth="0"
          />
          <path
            d="m96.29,63.46c3.22-1.11,8.48-2.81,11.53-3.71,0,0,1.6-.52,3.99-1.61l.36-.15s0,0,0-.02c1.22-.56,2.62-1.27,4.11-2.11,0,.01,0,.02,0,.03l2.17-1.31s0,0,0-.02c1.82-1.15,3.68-2.51,5.44-4.07,0,0,.39-.34.39-.35,1.65-1.51,3.19-3.2,4.49-5.09,0,0,.2-.28.2-.29.92-1.38,1.71-2.86,2.32-4.45,0,0,.16-.4.39-1.12.03-.09.06-.18.08-.27.24-.8.79-3.23.8-3.22,0,0,0-.07.03-.18.15-.77.27-1.62.37-2.51.02-.16.04-.26.04-.28,0,0,0,0,0,0,.09-.93.18-2.9.18-2.9l-.06-1.21s0-.04,0-.05c0,0-.05-.86-.05-.86-.13-1.72-.43-3.5-1-5.27,0,0-.11-.38-.13-.4-1.54-4.53-4.79-8.96-11.1-12.06,0,0-1.02-.45-3.09-1.09,0,0-.52-.17-.53-.16-3.2-.95-8.54-2.24-16.16-3.1,0,0-7.35-.32-6.07-5.31,0,0,.02-.75-.6.04,0,0-3.03,5.6,4.41,7.2,0,0,14.35,1.65,21.04,5.85h0s.21.13.48.31c.66.45,1.24.94,1.69,1.46,0,0,.35.33.87.94,0,.01,1.16,1.56,1.17,1.56.3.44.61.95.92,1.5h0l.28.53c1.49,2.87,2.77,7.01,2.02,12.17,0,0-.16.96-.16.96-.33,1.71-.87,3.52-1.7,5.44,0,0-.5.94-1.48,2.29-.02,0-1.19,1.54-1.19,1.54-1.75,2.1-4.35,4.63-7.77,6.37,0,0-9.65,4.41-13.56,5.1,0,0-2.46.96-6.27-.21,0,0,3.32,2.25,1.2,10.08Z"
            strokeWidth="0"
          />
          <image
            width="335"
            height="349"
            transform="translate(17.49 -2.84) scale(.24)"
            href="data:image/png;base64,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"
          />
          <image
            width="341"
            height="355"
            transform="translate(11.49 -3.56) scale(.24)"
            href="data:image/png;base64,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"
          />
          <g opacity=".7">
            <image
              width="337"
              height="342"
              transform="translate(42.93 27.4) scale(.24)"
              href="data:image/png;base64,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"
            />
          </g>
          <g opacity=".7">
            <image
              width="329"
              height="328"
              transform="translate(32.37 7.24) scale(.24)"
              href="data:image/png;base64,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"
            />
          </g>
          <g opacity=".7">
            <image
              width="440"
              height="331"
              transform="translate(27.57 14.68) scale(.24)"
              href="data:image/png;base64,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"
            />
          </g>
          <g opacity=".8">
            <image
              width="327"
              height="360"
              transform="translate(16.53 -1.16) scale(.24)"
              href="data:image/png;base64,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"
            />
          </g>
          <g opacity=".3">
            <path
              d="m46.5,30.21c-.03.07-.1.1-.16.07-.06-.02-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m47.05,30.9c-.03.09-.13.13-.21.09-.09-.03-.13-.13-.1-.21.03-.08.13-.13.21-.09.08.03.13.13.1.21Z"
              strokeWidth="0"
            />
            <path
              d="m47.82,30.49s-.07.07-.11.05c-.04-.01-.06-.07-.05-.11.02-.04.06-.06.11-.05.04.02.06.06.05.11Z"
              strokeWidth="0"
            />
            <path
              d="m45.59,33.51c-.04.1-.15.14-.24.11-.09-.04-.14-.14-.11-.24.04-.1.14-.15.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m46.16,35.02c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.14.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m45.79,34.37s-.07.06-.11.05c-.04-.02-.06-.06-.04-.11.01-.04.06-.06.1-.04.04.01.06.06.05.1Z"
              strokeWidth="0"
            />
            <path
              d="m47.47,36.15c-.04.09-.14.14-.24.11-.09-.04-.14-.14-.11-.24.03-.1.14-.14.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m46.6,36.12c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m46.92,37.35c-.02.06-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m48.1,39.35c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m48.65,30.92c-.03.08-.11.11-.19.08-.07-.03-.11-.11-.08-.19s.11-.11.19-.08c.07.03.11.11.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m48.19,31.78c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.06.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m47.57,31.28c-.03.08-.11.11-.19.08-.08-.03-.11-.11-.08-.19.03-.08.11-.11.18-.08.08.03.11.11.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m50.44,33.35c-.04.09-.14.14-.24.11-.1-.04-.14-.15-.11-.24.04-.1.14-.15.24-.11.09.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m51.77,34.44c-.02.06-.09.1-.16.07-.06-.02-.09-.1-.07-.16.03-.06.1-.1.16-.07.06.03.1.09.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m52.37,33.97c-.02.07-.1.1-.16.08-.07-.03-.1-.1-.07-.16.02-.06.09-.09.16-.07.07.02.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m53.14,32.77c-.02.05-.08.08-.13.06-.06-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m53.23,31.94c-.02.06-.08.08-.13.06-.05-.02-.08-.08-.06-.14.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m53.95,32.08c-.02.06-.08.08-.14.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m54.34,32.1c-.04.12-.17.18-.29.13-.12-.05-.17-.18-.13-.29.05-.12.17-.17.29-.13.12.05.18.18.13.29Z"
              strokeWidth="0"
            />
            <path
              d="m54.82,32.35s-.06.06-.11.05c-.04-.02-.06-.06-.05-.11.02-.04.06-.06.11-.05.04.02.06.06.05.11Z"
              strokeWidth="0"
            />
            <path
              d="m55.39,31.71c-.03.08-.13.13-.21.09-.09-.03-.13-.13-.1-.21.03-.08.13-.13.21-.09.09.03.13.13.09.21Z"
              strokeWidth="0"
            />
            <path
              d="m56.12,31.83c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m55.7,32.78c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.14-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m55.75,32.16s-.06.06-.11.05c-.04-.02-.06-.06-.05-.11.02-.04.07-.06.11-.05.04.02.06.06.05.11Z"
              strokeWidth="0"
            />
            <path
              d="m56.45,32.29c-.04.1-.14.15-.24.11-.09-.04-.14-.15-.11-.24.04-.09.14-.14.24-.11.1.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m56.83,32.59c-.03.07-.11.11-.19.08-.07-.03-.11-.11-.08-.19.03-.08.11-.11.19-.08.08.03.11.11.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m57.33,33.11c-.03.08-.13.13-.21.1-.08-.03-.13-.13-.1-.21.04-.09.13-.13.21-.09.09.03.13.13.1.21Z"
              strokeWidth="0"
            />
            <path
              d="m50.96,30.77c-.03.07-.11.11-.19.08-.08-.03-.11-.12-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m59.18,37.22c-.03.07-.11.11-.18.08-.08-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.08.03.12.11.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m60.43,38.07c-.03.08-.13.13-.21.1-.08-.04-.13-.13-.09-.21.03-.08.12-.13.21-.09.08.03.13.13.09.21Z"
              strokeWidth="0"
            />
            <path
              d="m61.75,39.3c-.02.06-.09.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.09-.1.16-.07.06.03.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m62.13,40.22c-.04.11-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.1.04.16.16.12.27Z"
              strokeWidth="0"
            />
            <path
              d="m60.63,39.06c-.04.1-.16.15-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.26-.12.11.04.16.16.12.27Z"
              strokeWidth="0"
            />
            <path
              d="m61.62,41.26c-.03.07-.11.11-.19.08-.08-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.18Z"
              strokeWidth="0"
            />
            <path
              d="m61.7,42.55s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m61.19,43.07c-.04.11-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.11.04.16.16.12.27Z"
              strokeWidth="0"
            />
            <path
              d="m61.34,44.58c-.04.1-.15.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.14-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m60.81,41.93c-.04.12-.18.18-.29.13-.12-.05-.18-.18-.13-.3.04-.12.18-.17.29-.13.12.04.17.18.13.29Z"
              strokeWidth="0"
            />
            <path
              d="m56.23,44.02c-.03.07-.11.11-.19.08-.08-.03-.11-.12-.08-.19.03-.07.11-.11.19-.08.08.03.11.12.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m55.77,43.67c-.04.12-.17.17-.29.13-.12-.04-.18-.18-.13-.29.04-.12.17-.18.29-.13.12.05.18.18.13.29Z"
              strokeWidth="0"
            />
            <path
              d="m56.87,42.81c-.04.12-.18.18-.29.13-.12-.04-.17-.18-.13-.29.04-.12.18-.17.29-.13.12.04.17.18.13.29Z"
              strokeWidth="0"
            />
            <path
              d="m54.73,41.24c-.04.11-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.11.04.16.16.12.27Z"
              strokeWidth="0"
            />
            <path
              d="m51.98,41.91c-.03.08-.13.13-.21.1-.09-.03-.13-.13-.09-.21.03-.09.13-.13.21-.1.09.03.13.13.09.21Z"
              strokeWidth="0"
            />
            <path
              d="m51.95,42.58c-.03.08-.11.11-.19.08-.08-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.08.03.11.12.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m52.9,42.29c-.03.08-.13.12-.21.1-.09-.04-.13-.13-.1-.21.03-.09.13-.13.21-.1.08.04.13.13.09.22Z"
              strokeWidth="0"
            />
            <path
              d="m52.61,43.41c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.17.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m53.45,40.44c-.03.07-.11.11-.19.08-.08-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m53.33,39.6c-.04.09-.14.15-.24.11-.1-.04-.14-.15-.11-.24.04-.09.14-.14.24-.11.1.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m53.95,39.98c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m53.03,38.78c-.03.07-.11.11-.18.08-.08-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m54.13,38.95c-.04.11-.16.16-.26.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.1.04.16.16.12.26Z"
              strokeWidth="0"
            />
            <path
              d="m53.51,38.19c-.04.11-.16.16-.26.12-.11-.04-.16-.16-.12-.26.04-.11.16-.16.27-.12.1.04.16.16.12.26Z"
              strokeWidth="0"
            />
            <path
              d="m54.38,37.95c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m54.24,43c-.03.08-.13.13-.21.1-.09-.03-.13-.13-.1-.21.03-.09.13-.13.21-.1.08.03.13.13.1.21Z"
              strokeWidth="0"
            />
            <path
              d="m54.12,43.59c-.04.11-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.11.04.16.16.12.27Z"
              strokeWidth="0"
            />
            <path
              d="m53.4,43.38c-.04.12-.17.17-.29.13-.12-.04-.17-.17-.13-.29.04-.12.17-.18.29-.13.12.04.18.18.13.29Z"
              strokeWidth="0"
            />
            <path
              d="m53.86,44.29c-.03.07-.11.11-.19.08-.07-.03-.11-.11-.08-.18.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m55.21,46c-.04.11-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.26-.12.11.04.16.16.12.26Z"
              strokeWidth="0"
            />
            <path
              d="m56.35,46.78c-.03.08-.11.11-.19.08-.07-.03-.11-.11-.08-.18.03-.08.11-.11.19-.09.08.03.11.11.09.19Z"
              strokeWidth="0"
            />
            <path
              d="m56.58,45.33c-.02.06-.1.09-.16.07-.06-.02-.1-.1-.07-.16.03-.06.1-.1.16-.07.07.03.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m57.07,44.56c-.05.12-.18.18-.29.13-.12-.04-.18-.18-.13-.29.05-.12.18-.18.29-.13.12.04.18.18.13.29Z"
              strokeWidth="0"
            />
            <path
              d="m57.36,45.4c-.03.07-.1.1-.16.07-.06-.03-.09-.1-.07-.16.02-.06.09-.1.16-.07.06.03.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m49.34,42.82c-.04.11-.16.16-.26.12-.11-.04-.16-.16-.12-.26.04-.11.16-.16.27-.12.11.04.16.16.12.27Z"
              strokeWidth="0"
            />
            <path
              d="m48.83,42.61c-.03.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.06.1-.09.16-.07.06.02.1.09.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m48.04,41.64s-.06.06-.11.05c-.04-.02-.06-.06-.05-.11.02-.04.06-.06.11-.05.04.01.06.06.05.11Z"
              strokeWidth="0"
            />
            <path
              d="m50.18,43.56c-.02.06-.09.1-.16.07-.07-.02-.1-.1-.07-.16.02-.07.1-.1.16-.07.06.02.09.09.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m50.7,44.34c-.03.07-.11.11-.18.08-.07-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m50.56,45.06c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.06.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m51.15,45.42c-.05.13-.19.19-.32.14-.12-.05-.19-.2-.14-.32.05-.12.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m51.68,45.88c-.02.07-.09.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.09.09.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m52.63,46.58c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.15-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m52.88,46.16c-.03.08-.11.11-.19.09-.08-.03-.11-.11-.08-.19.03-.08.11-.11.19-.08.08.03.11.11.09.18Z"
              strokeWidth="0"
            />
            <path
              d="m53.77,46.26c-.05.12-.18.18-.29.13-.12-.05-.18-.18-.13-.29.04-.12.18-.18.3-.13.12.04.17.18.13.29Z"
              strokeWidth="0"
            />
            <path
              d="m54.23,46.55c-.03.07-.11.11-.19.08-.07-.03-.11-.11-.08-.19.03-.08.11-.11.18-.08.08.03.11.11.09.19Z"
              strokeWidth="0"
            />
            <path
              d="m52.83,47.45s-.06.06-.11.05c-.04-.01-.07-.06-.05-.1.02-.04.06-.06.11-.05.04.02.06.06.05.11Z"
              strokeWidth="0"
            />
            <path
              d="m53.83,47.76c-.03.07-.1.09-.16.07-.07-.02-.09-.1-.07-.16.02-.07.09-.1.16-.07.06.02.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m56.51,48.9c-.03.08-.11.11-.19.09-.08-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.18Z"
              strokeWidth="0"
            />
            <path
              d="m57.77,48.32s-.03.03-.05.02c-.02,0-.03-.03-.03-.05,0-.02.03-.03.05-.02.02,0,.03.03.02.05Z"
              strokeWidth="0"
            />
            <path
              d="m60.2,48.61c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.14.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m60.31,49.14c-.03.09-.13.13-.21.09-.09-.03-.13-.13-.1-.21.03-.08.13-.13.21-.1.08.03.13.13.09.21Z"
              strokeWidth="0"
            />
            <path
              d="m61.93,49c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m63.16,47.86c-.03.07-.11.11-.19.08-.07-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.08.03.11.11.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m63.65,48.67c-.02.06-.1.09-.16.07-.06-.02-.1-.1-.07-.16.03-.07.09-.09.16-.07.06.02.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m63.42,49.55c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.14-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m63.14,49.86c-.02.06-.1.1-.16.07-.06-.02-.1-.1-.07-.16.02-.06.09-.1.16-.07.06.02.09.09.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m64.45,50.38c-.04.1-.14.15-.24.11-.1-.04-.14-.14-.11-.24.04-.09.14-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m65.73,50.19c-.04.11-.16.16-.26.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.26-.12.11.04.16.16.12.27Z"
              strokeWidth="0"
            />
            <path
              d="m65.03,49.55c-.02.06-.1.09-.16.07-.06-.02-.09-.09-.07-.16.02-.06.09-.09.16-.07.06.02.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m64.67,49.23s-.06.06-.11.05c-.04-.02-.06-.06-.05-.11.02-.04.06-.06.11-.05.04.02.07.06.05.11Z"
              strokeWidth="0"
            />
            <path
              d="m64.58,48.43c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m65.18,48.7c-.04.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.14-.14.24-.11.09.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m65.46,49.01s-.03.03-.05.02c-.02,0-.03-.03-.02-.05,0-.02.03-.03.05-.02.02,0,.03.04.02.05Z"
              strokeWidth="0"
            />
            <path
              d="m66.34,49.14c-.04.1-.14.14-.24.11-.09-.04-.14-.15-.11-.24.04-.1.14-.14.24-.11.1.03.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m66,49.5c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.06.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m67.12,49.57c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m67.79,49.74c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m67.71,49.29s-.05.05-.08.04c-.03-.01-.05-.05-.03-.08.01-.03.05-.05.08-.04.03,0,.05.05.04.08Z"
              strokeWidth="0"
            />
            <path
              d="m67.76,48.71c-.04.09-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.09.14-.14.24-.11.09.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m67.03,48.77c-.03.1-.14.14-.24.11-.1-.04-.14-.15-.11-.24.04-.1.14-.15.24-.11s.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m69.07,50.14c-.03.07-.11.11-.19.08-.08-.03-.11-.11-.08-.18.03-.07.12-.11.19-.09.07.03.11.11.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m69.52,48.95c-.03.08-.13.13-.22.1-.08-.03-.12-.13-.09-.21.03-.09.13-.13.21-.1.08.03.13.12.1.21Z"
              strokeWidth="0"
            />
            <path
              d="m66.49,51.74c-.02.06-.1.1-.16.07-.06-.03-.09-.1-.07-.16.02-.06.1-.1.16-.07.06.02.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m65.53,50.97c-.02.05-.08.08-.13.06-.06-.02-.08-.08-.06-.13s.08-.08.13-.06c.06.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m66.64,50.54c-.03.09-.13.13-.21.1-.09-.04-.13-.13-.09-.21.03-.08.12-.13.21-.09.08.03.13.12.09.21Z"
              strokeWidth="0"
            />
            <path
              d="m64.88,51.15c-.03.08-.11.11-.19.08-.07-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m60.89,51.26c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.07.02.1.09.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m60.82,50.33c-.04.11-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.11.04.16.16.12.27Z"
              strokeWidth="0"
            />
            <path
              d="m60.3,50.08c-.03.08-.13.13-.21.09-.09-.03-.13-.13-.1-.21.04-.08.13-.13.21-.1.08.03.13.13.09.21Z"
              strokeWidth="0"
            />
            <path
              d="m60.2,50.93c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m59.5,51.08c-.03.07-.11.11-.18.08-.08-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m59.14,51.56c-.03.09-.13.13-.22.1-.08-.03-.13-.13-.09-.21.03-.08.13-.13.21-.09.09.03.13.13.1.21Z"
              strokeWidth="0"
            />
            <path
              d="m59.98,52.43s-.03.03-.05.02c-.02,0-.03-.03-.03-.05.01-.02.04-.03.05-.02.02,0,.03.03.02.05Z"
              strokeWidth="0"
            />
            <path
              d="m60.09,53.29s-.06.06-.11.04c-.04-.02-.06-.06-.05-.11.02-.05.07-.06.11-.05.04.02.06.06.05.11Z"
              strokeWidth="0"
            />
            <path
              d="m59.78,53.59c-.04.11-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.1.04.16.16.12.27Z"
              strokeWidth="0"
            />
            <path
              d="m59.24,52.97c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.14.02-.05.08-.07.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m58.54,52.44c-.06.15-.22.22-.37.17-.15-.06-.22-.22-.17-.37.06-.15.23-.22.37-.17.15.06.22.22.16.37Z"
              strokeWidth="0"
            />
            <path
              d="m58.31,53.14c-.03.07-.11.11-.18.08-.08-.03-.11-.11-.09-.19.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m57.91,51.2s-.06.06-.11.05c-.04-.02-.06-.07-.05-.11.02-.04.06-.06.11-.05.04.02.06.06.05.11Z"
              strokeWidth="0"
            />
            <path
              d="m58.28,50.04c-.02.06-.1.1-.16.07-.06-.02-.09-.1-.07-.16.02-.06.1-.1.16-.07.06.02.1.09.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m58.8,54.41c-.05.13-.2.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.15.32Z"
              strokeWidth="0"
            />
            <path
              d="m58.58,55.52c-.03.09-.13.13-.21.09-.09-.03-.13-.13-.1-.21.03-.09.13-.13.21-.1.08.03.13.13.1.21Z"
              strokeWidth="0"
            />
            <path
              d="m58.89,56.15c-.04.11-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.1.04.16.16.12.27Z"
              strokeWidth="0"
            />
            <path
              d="m58.31,56.63c-.04.1-.14.14-.24.11-.09-.04-.14-.14-.1-.24.04-.1.14-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m58.89,56.79s-.06.06-.11.04c-.04-.01-.06-.06-.05-.11.02-.04.06-.06.11-.05.04.02.06.07.05.11Z"
              strokeWidth="0"
            />
            <path
              d="m60.17,55.64c-.04.1-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.11.04.16.16.12.27Z"
              strokeWidth="0"
            />
            <path
              d="m60.52,54.76c-.02.06-.1.1-.16.07-.06-.03-.09-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m59.5,55.01c-.02.05-.06.09-.08.08-.03-.01-.03-.06-.01-.12.02-.05.06-.09.08-.08.03,0,.03.06.01.12Z"
              strokeWidth="0"
            />
            <path
              d="m62.44,54.43c-.02.07-.1.1-.16.07-.06-.02-.1-.09-.07-.16.03-.06.1-.09.16-.07.06.02.1.09.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m63.37,53.97c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.14.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m63.42,54.63c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.12.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m62.99,55.06c-.03.08-.11.11-.19.08-.07-.03-.11-.11-.08-.19.03-.07.11-.11.18-.08.08.03.11.11.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m64.49,54.95c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m64.15,55.9s-.06.06-.11.05c-.04-.02-.06-.06-.05-.11.01-.04.06-.06.11-.05.04.02.06.06.05.11Z"
              strokeWidth="0"
            />
            <path
              d="m63.94,56.28c-.05.12-.18.18-.29.13-.12-.04-.18-.17-.13-.29.04-.12.17-.17.29-.13.12.04.18.17.13.29Z"
              strokeWidth="0"
            />
            <path
              d="m64.26,56.61c-.02.05-.08.08-.14.06-.05-.02-.08-.08-.06-.13.02-.06.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m63.39,57.82c-.02.07-.09.1-.16.07-.07-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m64.15,58.04c-.06.17-.25.26-.42.19-.17-.06-.26-.25-.19-.42.06-.17.26-.26.43-.19.17.07.26.26.19.43Z"
              strokeWidth="0"
            />
            <path
              d="m60.81,47.65c-.03.08-.11.11-.19.08-.08-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
              strokeWidth="0"
            />
            <path
              d="m60.57,46.14c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
              strokeWidth="0"
            />
            <path
              d="m61.75,45.43c-.04.09-.14.14-.24.11-.09-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m62.39,46.69c-.06.15-.23.22-.37.17-.15-.06-.22-.22-.17-.38.06-.15.23-.22.37-.17.15.06.23.22.17.37Z"
              strokeWidth="0"
            />
            <path
              d="m59.17,58.68c-.05.14-.22.22-.36.16-.14-.06-.21-.22-.16-.37.06-.14.22-.21.36-.16.15.06.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m59.24,59.28c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m58.5,60.33c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m58.58,60.93c-.04.1-.14.14-.24.11s-.15-.14-.11-.24c.04-.1.14-.15.24-.11.1.03.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m59.44,60.32c-.04.12-.17.17-.28.13-.11-.05-.17-.17-.12-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m59.67,60.87c-.04.1-.15.15-.24.11-.1-.04-.14-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m60.65,60.21c-.04.1-.14.15-.24.11-.1-.04-.15-.15-.11-.24.04-.1.14-.15.24-.11.09.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m61.28,59.89c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.07.1-.1.16-.07.07.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m62.6,59.13c-.02.06-.1.1-.16.07-.06-.02-.1-.1-.07-.16.03-.06.1-.1.16-.07s.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m63.67,59.83c-.07.18-.26.27-.44.2-.18-.07-.26-.27-.2-.44.07-.18.27-.27.44-.2.18.06.26.26.2.44Z"
              strokeWidth="0"
            />
            <path
              d="m63.77,60.71c-.02.06-.1.1-.16.07-.07-.02-.1-.1-.07-.16.03-.07.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m62.38,61.38c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m61.81,60.86c-.03.07-.09.1-.16.07-.07-.02-.1-.1-.07-.16.02-.07.09-.1.16-.07.07.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m61.68,61.88c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.12.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m62.16,62.63c-.06.18-.26.27-.44.2-.18-.07-.27-.27-.2-.44.07-.18.26-.26.44-.2.17.07.26.26.19.44Z"
              strokeWidth="0"
            />
            <path
              d="m61.07,62.98c-.03.06-.1.1-.16.07-.06-.03-.09-.1-.07-.16.02-.07.1-.1.16-.07.07.03.1.1.08.16Z"
              strokeWidth="0"
            />
            <path
              d="m61.89,63.86c-.05.12-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.2-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m61.09,63.95c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m60.03,63.32c-.02.07-.1.1-.16.07-.07-.02-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m60,64.44c-.04.1-.15.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m59.25,64.49c-.04.1-.14.14-.24.11-.1-.04-.15-.15-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m58.74,64.79c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m59.34,65.32c-.06.14-.22.22-.36.16-.14-.05-.22-.22-.16-.36.06-.15.22-.22.36-.16.15.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m60.39,65.36c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.04.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m61.12,64.83c-.06.15-.22.22-.36.16-.15-.06-.22-.22-.16-.36.06-.15.22-.22.36-.16.14.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m61.52,64.85s-.05.05-.08.04c-.03-.01-.05-.04-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
              strokeWidth="0"
            />
            <path
              d="m61.39,65.8c-.02.06-.1.1-.16.07-.06-.02-.1-.1-.07-.16.02-.06.09-.1.16-.07.07.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m60.86,65.97c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m59.94,66.35c-.04.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.15-.15.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m59.28,66.17c-.06.14-.22.22-.36.16-.14-.05-.22-.22-.16-.36.06-.14.22-.22.36-.16.15.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m54.59,62.9c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m55.28,63.37c-.04.1-.15.14-.24.11-.1-.04-.15-.14-.11-.24.03-.1.14-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m56.4,62.53c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m56.73,61.49c-.04.1-.15.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.14-.15.24-.11.1.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m52.69,61.05s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m54.59,61.94c-.05.13-.19.19-.32.15-.13-.05-.2-.2-.14-.33.05-.13.19-.19.32-.14.13.05.2.2.15.32Z"
              strokeWidth="0"
            />
            <path
              d="m50.93,61.31c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m51.2,61.91c-.05.14-.22.22-.36.16-.15-.06-.22-.22-.16-.36.06-.15.22-.22.36-.16.14.05.21.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m51.69,61.93c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m52.44,62.05c-.04.11-.17.17-.28.13-.11-.05-.17-.17-.13-.28.04-.12.17-.17.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m53.16,62.89c-.05.14-.22.21-.36.16-.15-.05-.22-.22-.16-.36s.22-.22.36-.16c.14.05.21.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m53.73,63.14c-.04.1-.15.14-.24.11-.09-.04-.14-.14-.11-.24.04-.1.14-.15.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m53.55,62.47c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m54.76,63.94c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m55.88,64.33c-.07.19-.29.29-.48.21-.19-.07-.29-.29-.22-.48.07-.19.29-.29.48-.21.2.07.29.29.22.48Z"
              strokeWidth="0"
            />
            <path
              d="m56.35,64.21c-.03.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.07.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m49.81,59.94c-.05.13-.19.19-.32.14-.13-.05-.19-.2-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m49.93,61.56c-.05.13-.19.19-.32.15-.13-.05-.19-.2-.15-.32.05-.13.2-.2.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m48.82,61.4c-.04.1-.15.15-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m48.45,61.93c-.04.1-.15.14-.24.11-.1-.04-.15-.14-.11-.24.04-.09.15-.14.24-.11.1.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m49.1,61.88s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.03.03.01.05.05.04.08Z"
              strokeWidth="0"
            />
            <path
              d="m47.62,62.54c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.05-.11.17-.17.29-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m63.95,61.88c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m64.4,61.15c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m65.87,60.71c-.04.1-.15.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.15.24-.11.1.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m64.66,60.38c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m67.76,58.46c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.09-.09.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m67.04,59.49c-.03.07-.1.1-.16.07-.06-.03-.09-.1-.07-.16.02-.06.09-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m66.61,57.12s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m68.07,56.18c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.12.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m70.93,56.47c-.04.09-.15.15-.24.11-.09-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m70.79,57.71c-.05.13-.2.19-.32.14-.13-.05-.2-.2-.15-.32.05-.13.2-.19.32-.14.13.05.2.19.15.32Z"
              strokeWidth="0"
            />
            <path
              d="m71.25,57.62s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m71.77,57.66c-.02.07-.07.11-.1.1-.03-.01-.04-.08-.01-.14.03-.06.07-.11.1-.09.04.01.04.07.01.14Z"
              strokeWidth="0"
            />
            <path
              d="m71.2,59.16c-.02.05-.08.09-.14.06-.06-.02-.09-.08-.06-.14.02-.06.09-.09.14-.06.06.02.09.08.06.14Z"
              strokeWidth="0"
            />
            <path
              d="m71.67,61.69c-.05.13-.19.2-.32.15-.13-.05-.19-.2-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m70.69,61.02c-.03.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m69.53,60.91c-.04.1-.07.18-.07.18,0,0,.03-.08.07-.18.04-.1.07-.17.07-.17,0,0-.03.08-.07.17Z"
              strokeWidth="0"
            />
            <path
              d="m68.69,60.92c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.21.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m68.19,61.26c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.2.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m67.37,61.15c-.05.14-.22.21-.36.16-.15-.06-.22-.22-.16-.36.05-.14.22-.22.36-.16.15.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m66.82,61.37c-.04.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m67.24,61.83c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m67.75,62.33c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m68.35,62.36c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m68.11,62.8c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.12.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m67.07,63.4c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.2.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m66.98,62.7s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m66.24,62.02c-.06.16-.24.24-.4.18-.16-.07-.24-.25-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m65.81,62.69s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.03.08Z"
              strokeWidth="0"
            />
            <path
              d="m65.05,62.93c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m64.59,62.05c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m66.13,63.51c-.07.18-.26.26-.44.2-.17-.07-.26-.26-.2-.44.07-.18.27-.27.44-.2.18.07.26.27.2.45Z"
              strokeWidth="0"
            />
            <path
              d="m66.37,62.9c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m66.83,64.31c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m67.74,64.03c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m67.6,64.84s-.07.07-.12.05c-.05-.02-.07-.07-.06-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m68.8,63.7c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m69.22,63.29c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m69.8,62.55c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.09.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m69.51,60.96c-.02.07-.09.1-.16.07-.07-.03-.1-.1-.07-.16.03-.07.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m71.06,63.73c-.08.22-.34.34-.56.25-.22-.09-.34-.34-.25-.56.08-.22.34-.34.56-.25.22.08.34.34.25.56Z"
              strokeWidth="0"
            />
            <path
              d="m69.99,64.08s-.08.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.06.12Z"
              strokeWidth="0"
            />
            <path
              d="m69.58,64.26c-.04.1-.15.14-.24.11-.09-.04-.14-.15-.11-.24.03-.1.14-.14.24-.11.1.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m69.23,64.76c-.06.14-.22.22-.36.16-.14-.05-.22-.21-.16-.36.06-.14.22-.22.36-.16.15.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m69.09,65.48c-.06.16-.24.24-.4.18-.16-.06-.25-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.41Z"
              strokeWidth="0"
            />
            <path
              d="m69.88,65.41c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.21.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m70.72,65.23c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m70.96,65.82c-.04.1-.15.14-.24.11-.09-.04-.14-.15-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m71.26,65.11c-.04.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.04-.09.15-.14.24-.11.1.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m70.27,65.96c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.13-.29.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m71.94,64.66c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m71.35,66.27c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m72.24,66.05c-.03.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.14-.15.24-.11.1.04.14.14.1.24Z"
              strokeWidth="0"
            />
            <path
              d="m72.08,66.8c-.02.05-.08.08-.14.06-.05-.02-.08-.08-.06-.14.02-.05.08-.08.14-.06.06.02.08.08.06.14Z"
              strokeWidth="0"
            />
            <path
              d="m72.83,66.51c-.07.19-.29.29-.48.22-.19-.07-.29-.29-.22-.48.07-.19.29-.29.48-.21.19.07.29.29.22.48Z"
              strokeWidth="0"
            />
            <path
              d="m73.37,65.61c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m74.02,64.45c-.07.18-.27.27-.44.2-.18-.07-.27-.27-.2-.44.07-.18.27-.27.44-.2.18.07.26.27.2.44Z"
              strokeWidth="0"
            />
            <path
              d="m73.32,63.83c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.21Z"
              strokeWidth="0"
            />
            <path
              d="m74.03,65.9c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.41Z"
              strokeWidth="0"
            />
            <path
              d="m73.41,66.56c-.04.1-.14.14-.24.11-.1-.04-.14-.15-.11-.24.04-.1.15-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m74.3,65.03c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m75.03,65.47c-.05.13-.19.19-.32.15-.13-.05-.19-.2-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m75.68,65.09c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m74.98,59.58c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m76.55,58.95c-.11.29-.43.44-.72.33-.29-.12-.43-.44-.32-.73.11-.29.43-.43.72-.33.29.11.43.44.32.73Z"
              strokeWidth="0"
            />
            <path
              d="m77.25,57.99c-.03.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.07.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m77.73,57.17c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m78.42,58.96c-.05.14-.22.21-.36.16-.15-.06-.22-.22-.16-.36.05-.14.22-.22.36-.16.15.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m78.21,60.72c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m78.36,61.48c-.04.11-.17.17-.28.13-.11-.05-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m78.12,62.35c-.03.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.03-.07.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m76.27,61.44c-.05.14-.21.22-.36.16-.15-.05-.22-.22-.16-.36.05-.15.22-.22.36-.16.14.06.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m76.69,62.78c-.04.1-.15.15-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.15.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m75.27,63.63c-.03.07-.1.1-.16.07-.07-.02-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.02.1.09.08.16Z"
              strokeWidth="0"
            />
            <path
              d="m76.72,64.79c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m77.44,63.7c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.09-.1.16-.07.06.03.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m78,64.34c-.08.21-.31.31-.52.23-.21-.08-.31-.31-.24-.52.08-.21.31-.31.52-.23.21.08.31.31.23.52Z"
              strokeWidth="0"
            />
            <path
              d="m78.94,64.84c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m78.24,63.53s-.08.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m77.82,65.68c-.02.06-.1.1-.16.07-.07-.02-.1-.1-.07-.16.02-.07.09-.1.16-.07.07.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m77.83,66.18c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m76.47,66.16c-.07.18-.26.27-.44.2-.18-.07-.26-.27-.2-.44.07-.18.27-.27.44-.2.18.07.27.27.2.44Z"
              strokeWidth="0"
            />
            <path
              d="m75.37,66.34s-.07.07-.12.05c-.04-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m75,66.33c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m75.22,67.15c-.05.14-.22.21-.36.16-.15-.06-.22-.22-.16-.36.05-.14.22-.22.36-.16.15.05.22.21.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m74.28,67.08c-.03.07-.11.11-.18.08-.07-.03-.11-.11-.08-.18.03-.07.11-.11.18-.08.07.03.11.11.08.18Z"
              strokeWidth="0"
            />
            <path
              d="m76.33,67.21c-.07.19-.29.29-.49.21-.19-.07-.29-.29-.22-.48.08-.19.29-.29.48-.22.19.07.29.29.22.48Z"
              strokeWidth="0"
            />
            <path
              d="m76.89,67.06c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m77.16,67.66c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.15-.32.05-.13.2-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m77.79,67.16c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m78.6,67.64c-.09.24-.37.36-.61.27-.24-.09-.36-.36-.27-.61.1-.24.36-.36.61-.27.24.09.36.36.27.6Z"
              strokeWidth="0"
            />
            <path
              d="m79,66.7c-.05.12-.19.19-.32.14-.13-.05-.19-.19-.15-.32.05-.13.19-.19.32-.15.13.05.19.2.14.33Z"
              strokeWidth="0"
            />
            <path
              d="m78.28,66.55s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m78.95,65.87c-.03.09-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.15.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m79.43,65.66c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m82.44,58.83s-.07.07-.12.05c-.05-.02-.08-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m83.42,58.87c-.04.1-.15.15-.24.11-.09-.04-.15-.15-.11-.24.04-.1.15-.14.24-.11.09.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m82.31,59.35c-.02.07-.09.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m81.47,59.7c-.05.13-.19.19-.32.14-.13-.05-.2-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m81.61,60.38c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m82.1,60.77c-.04.11-.17.17-.28.13-.12-.05-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m82.79,60.7c-.07.18-.27.27-.44.2-.18-.07-.27-.26-.2-.44.07-.18.27-.27.44-.2.18.06.27.26.2.44Z"
              strokeWidth="0"
            />
            <path
              d="m83.03,60.16c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m83.92,59.66c-.05.13-.19.19-.32.14-.13-.05-.2-.19-.15-.32.05-.13.2-.2.33-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m85.64,58.65c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m83.62,57.65c-.05.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m86.69,58.79c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m86.04,59.87c-.05.13-.19.19-.32.14-.13-.05-.2-.19-.15-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m86.12,60.97c-.07.19-.29.29-.48.21-.19-.07-.29-.29-.21-.48.07-.2.29-.29.48-.22.19.07.29.29.22.48Z"
              strokeWidth="0"
            />
            <path
              d="m86.33,61.92c-.04.09-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.14.24-.11.09.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m87.58,60.23c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m85.61,67.28c-.09.23-.34.34-.56.25s-.34-.34-.25-.56c.08-.22.33-.34.56-.25.23.09.34.34.25.56Z"
              strokeWidth="0"
            />
            <path
              d="m85.39,64.63c-.05.13-.19.19-.32.15-.13-.05-.2-.2-.15-.32.05-.13.2-.2.32-.15.13.05.2.2.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m82.24,62.59c-.09.23-.34.34-.56.25-.23-.09-.34-.34-.25-.56.09-.22.34-.34.56-.25.23.09.34.34.25.56Z"
              strokeWidth="0"
            />
            <path
              d="m83.06,62.87c-.02.07-.09.1-.16.07-.07-.02-.1-.1-.07-.16.03-.07.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m83.2,61.99c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m84.44,66c-.06.15-.22.22-.36.16-.15-.06-.22-.22-.16-.36.06-.15.22-.22.36-.16.14.06.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m83.36,65.76c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.21-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m81.45,64.29c-.04.1-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m80.82,64.29s-.08.07-.12.05c-.05-.02-.08-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.06.12Z"
              strokeWidth="0"
            />
            <path
              d="m81.22,65.24c-.05.15-.22.22-.36.16-.15-.05-.22-.21-.16-.36.05-.15.22-.22.36-.16.15.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m81.46,65.93c-.04.1-.15.15-.24.11-.1-.04-.14-.15-.11-.24.04-.1.14-.15.24-.11.09.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m80.79,65.84c-.05.13-.19.2-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m80.89,66.55c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m80.44,66.94c-.09.23-.34.34-.56.25-.23-.08-.34-.34-.25-.56.09-.22.34-.34.57-.25.23.09.34.34.25.56Z"
              strokeWidth="0"
            />
            <path
              d="m79.6,67.49c-.02.07-.1.1-.16.07-.06-.03-.09-.1-.07-.16.03-.06.1-.1.17-.07.06.03.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m86.95,62.56c-.05.13-.19.19-.32.14-.13-.05-.2-.19-.15-.32.05-.13.19-.2.32-.15.13.05.19.2.15.32Z"
              strokeWidth="0"
            />
            <path
              d="m88.05,58.3c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m91.09,59.32s-.06.06-.1.04c-.04-.01-.06-.06-.04-.1.01-.04.06-.06.1-.05.04.02.06.06.04.1Z"
              strokeWidth="0"
            />
            <path
              d="m92.46,60.9c-.07.19-.29.29-.48.21-.19-.07-.29-.29-.21-.48.07-.19.29-.29.48-.21.19.07.29.29.22.49Z"
              strokeWidth="0"
            />
            <path
              d="m94.07,60.1c-.04.11-.17.17-.28.13-.11-.05-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m94.85,59.63c-.02.06-.1.1-.16.07-.07-.02-.1-.1-.07-.16.02-.07.1-.1.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m94.79,60.82c-.04.1-.15.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m94.86,62.38c-.04.1-.15.14-.24.11-.1-.04-.14-.14-.1-.24.04-.1.14-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m95.39,62.91c-.05.15-.22.22-.36.16-.14-.05-.21-.22-.16-.36.06-.14.22-.22.36-.16.14.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m95.33,61.86c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m93.37,62.61c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.12.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m93.9,63.34c-.05.13-.19.19-.32.15-.13-.05-.19-.19-.14-.32.05-.13.19-.2.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m93.89,63.98c-.03.08-.12.12-.21.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m94.13,62.03c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m94.53,63.42s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.06.05.02.07.08.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m91.3,64.72c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m90.45,64.23c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m90.81,63.39c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.05.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m89.62,64.41c-.04.11-.17.17-.28.13-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m90.57,65.14c-.06.14-.22.22-.36.16-.14-.05-.22-.22-.16-.36.06-.14.22-.21.36-.16.15.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m89.53,65.34c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m90.08,66.07c-.03.07-.11.11-.18.08-.07-.03-.11-.11-.08-.18.03-.08.11-.11.18-.08.07.03.11.11.08.18Z"
              strokeWidth="0"
            />
            <path
              d="m89.52,66.41c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m89.09,66.65c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.12.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m87.38,66.59c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m87.09,67.09c-.05.14-.22.21-.36.16s-.22-.22-.16-.36c.06-.14.22-.22.36-.16.14.05.22.21.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m87.09,67.78c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m86.2,68.56c-.02.06-.09.08-.14.06-.05-.02-.08-.08-.06-.14.02-.05.09-.08.14-.06.06.02.08.08.06.14Z"
              strokeWidth="0"
            />
            <path
              d="m86.82,68.51c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m85.83,69.51c-.04.1-.15.15-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.03.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m85.02,69.46c-.04.1-.15.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m84.22,69.45c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m84.58,69.9c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m85.79,70.32c-.08.21-.32.31-.52.23-.21-.08-.31-.31-.23-.52.08-.21.31-.32.52-.23.21.08.32.31.23.52Z"
              strokeWidth="0"
            />
            <path
              d="m86.37,69.68c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m83.48,69.81c-.04.1-.14.14-.24.11-.09-.04-.14-.14-.11-.24.04-.1.15-.15.25-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m81.83,70.21s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.06.05.02.07.07.06.12Z"
              strokeWidth="0"
            />
            <path
              d="m92.73,63.86c-.07.19-.29.29-.49.21-.19-.07-.29-.29-.22-.48.07-.19.29-.29.48-.22.19.08.29.29.22.48Z"
              strokeWidth="0"
            />
            <path
              d="m93.17,64.1c-.02.06-.09.1-.16.07-.07-.02-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m92.16,64.38c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.07.02.1.09.08.16Z"
              strokeWidth="0"
            />
            <path
              d="m91.71,63.31c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m88.89,66.04c-.06.16-.24.24-.41.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m90.63,65.86c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m89.12,67.36c-.07.18-.27.26-.44.2-.18-.07-.27-.26-.2-.44.07-.18.27-.26.44-.2.18.07.26.27.2.44Z"
              strokeWidth="0"
            />
            <path
              d="m89.64,66.89c-.03.06-.1.1-.16.08-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.07.03.1.1.08.16Z"
              strokeWidth="0"
            />
            <path
              d="m87.89,67.19c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.12.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m88.18,67.73c-.02.06-.1.09-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.02.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m87.85,68.24c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m86.95,69.56c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m86.41,70.36s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m85.24,68.18c-.03.06-.1.09-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.02.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m86.05,67.89c-.04.11-.17.17-.28.13-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m84.1,67.04c-.02.06-.09.1-.16.07-.06-.03-.09-.1-.07-.16.03-.06.1-.1.16-.07.07.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m85.01,66.32c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m83.86,72.22c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m85.96,71.02c-.06.15-.22.22-.36.16-.15-.06-.22-.22-.16-.36.06-.15.22-.22.36-.16.14.06.22.21.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m88.72,70.61c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.21.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m89.3,70.66c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.04.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m88.3,73.45c-.08.2-.29.29-.49.22-.2-.07-.29-.29-.22-.48.07-.19.29-.29.48-.22.19.07.29.29.22.48Z"
              strokeWidth="0"
            />
            <path
              d="m89.9,70.76s-.05.05-.08.04c-.03,0-.05-.04-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
              strokeWidth="0"
            />
            <path
              d="m90.43,70.76c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m90.1,71.44c-.07.18-.27.27-.45.2-.18-.07-.27-.27-.2-.44.07-.18.27-.26.44-.2.18.07.27.27.2.44Z"
              strokeWidth="0"
            />
            <path
              d="m91.16,70.61c-.03.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m91.76,70.33c-.03.08-.12.12-.21.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m90.77,72.06c-.02.06-.1.1-.16.07-.06-.02-.09-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m85.69,73.45c-.09.23-.34.34-.57.25-.22-.08-.34-.34-.25-.56.09-.22.34-.34.56-.25.23.09.34.34.25.56Z"
              strokeWidth="0"
            />
            <path
              d="m90.97,74.67c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.2.32-.14.12.05.19.2.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m90.93,73.29c-.03.07-.09.1-.16.07-.06-.02-.1-.1-.07-.16.02-.07.1-.1.16-.07.06.03.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m92.71,70.3c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.12.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m78.26,71.25c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m78.1,72.36c-.05.12-.17.17-.28.13-.11-.05-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m78.44,73.39c-.07.18-.26.27-.44.2-.18-.07-.27-.26-.2-.44.07-.18.27-.26.44-.2.18.07.26.26.2.44Z"
              strokeWidth="0"
            />
            <path
              d="m78.47,73.93c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m79.2,74.01c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m79.18,74.61c-.05.14-.22.21-.36.16-.14-.05-.22-.21-.16-.36.06-.14.22-.22.36-.16.14.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m79.81,74.45c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m80.17,73.68c-.04.12-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m80.26,74.32c-.02.06-.09.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m80.94,74.11c-.06.14-.22.22-.36.16-.15-.05-.22-.21-.17-.36.06-.15.22-.22.36-.16.14.06.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m80.71,74.69c-.02.06-.1.09-.16.07-.06-.02-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.03.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m82.93,73.77c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m83.43,73.09c-.04.11-.17.17-.28.12-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m83.85,73.82c-.06.15-.22.22-.36.16s-.22-.22-.16-.36c.06-.15.22-.22.36-.16.15.06.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m84.38,73.22c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m84.58,73.83c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m86.38,73.32c-.03.07-.1.1-.16.07-.06-.02-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m87.32,73.74c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m91.54,75.79c-.04.11-.17.17-.28.12-.12-.04-.17-.17-.12-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m91.76,76.44c-.03.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m92.19,76.87s-.07.07-.12.05c-.05-.02-.07-.07-.06-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m90.19,73.3c-.05.15-.21.22-.36.16-.14-.05-.21-.22-.16-.36.05-.15.22-.22.36-.16.14.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m89.04,71.93c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m90.95,71.23c-.03.07-.1.1-.16.07-.07-.02-.1-.1-.07-.16.03-.07.1-.1.16-.07.07.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m91.88,70.98c-.04.1-.15.15-.24.11-.09-.04-.14-.14-.11-.24.04-.1.14-.15.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m94.09,69.99c-.04.1-.14.15-.24.11-.1-.04-.14-.14-.11-.24.04-.09.15-.14.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m93.2,78c-.02.06-.1.09-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.07.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m92.78,77.6c-.04.1-.14.14-.24.11-.1-.04-.15-.15-.11-.24.04-.1.15-.15.24-.11.1.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m87.74,75c-.05.13-.19.19-.32.15-.13-.05-.19-.2-.14-.32.05-.13.19-.2.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m87.26,75.72c-.03.06-.1.1-.16.07-.06-.03-.09-.1-.07-.16.03-.07.1-.1.16-.07.06.03.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m86.88,76.38c-.03.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m86.34,74.47s-.07.07-.12.05c-.04-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m89.49,74.97c-.03.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.09-.1.16-.07.06.03.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m89.34,75.61c-.04.1-.15.15-.24.11-.1-.04-.14-.15-.11-.24.04-.1.14-.14.24-.11.09.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m89.32,76.28c-.04.1-.14.15-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.15.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m84.67,70.53c-.04.1-.14.15-.24.11-.1-.04-.14-.14-.11-.24.04-.1.14-.15.24-.11.1.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m85.22,71.2c-.03.07-.1.1-.16.07-.07-.02-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.03.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m98.38,61.48c-.04.11-.17.17-.28.12-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.05.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m98.83,62.13c-.05.14-.22.21-.36.16s-.22-.22-.16-.36c.05-.14.22-.21.36-.16.14.05.22.21.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m99.28,60.6c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m99.07,59.85c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m100.36,60.74c-.06.14-.22.22-.36.16-.15-.05-.22-.22-.16-.36.05-.14.21-.21.36-.16.15.06.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m100.15,61.63c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.2-.2.32-.14.13.05.2.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m99.62,61.99c-.04.11-.17.17-.28.13-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m101.5,61.34c-.06.14-.22.22-.36.16-.14-.06-.22-.22-.16-.36.06-.14.22-.22.36-.16.14.06.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m101.12,60.33s-.05.05-.08.04c-.03,0-.05-.05-.04-.08.01-.04.05-.05.08-.04.03.01.05.05.04.08Z"
              strokeWidth="0"
            />
            <path
              d="m98.8,54.7c-.04.11-.17.17-.28.12-.12-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m99.25,54.48c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m92.88,55.25c-.11.29-.44.44-.72.32-.29-.11-.43-.43-.33-.72.11-.29.44-.44.73-.32.29.11.43.44.32.72Z"
              strokeWidth="0"
            />
            <path
              d="m93.67,54.08c-.04.11-.17.17-.28.13-.11-.05-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m92.71,53.42s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m84.05,54.61c-.04.1-.15.14-.25.11-.09-.04-.14-.14-.1-.24.04-.1.14-.14.24-.11.09.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m85.47,54.75c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m86.76,53.97c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m88.41,53.34c-.07.18-.27.26-.44.2-.18-.07-.27-.26-.2-.44.07-.18.27-.26.44-.2.18.07.26.27.2.44Z"
              strokeWidth="0"
            />
            <path
              d="m86.14,52.64c-.07.18-.27.27-.44.2-.18-.07-.27-.27-.2-.44.07-.18.27-.27.44-.2.18.06.26.26.2.44Z"
              strokeWidth="0"
            />
            <path
              d="m85.13,52.75c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m90.91,53.96c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.12.12.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m93.66,54.88c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m91.16,52.15c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.25.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m90.13,51.19c-.04.1-.14.15-.24.11-.1-.04-.14-.14-.11-.24.04-.09.14-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m89.11,50.8c-.03.06-.09.1-.16.07-.06-.03-.09-.1-.07-.16.03-.06.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m88.73,50.22c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m89.27,50.2c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.12.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m88.04,50.36c-.04.1-.15.15-.24.11-.1-.04-.15-.14-.11-.24.04-.09.15-.14.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m87.47,49.61c-.04.1-.15.14-.24.11-.09-.04-.14-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m86.54,49.92c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.16.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m86.11,50.19c-.05.12-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m85.43,50.23c-.04.1-.15.14-.24.11-.09-.04-.14-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m84.91,50.1c-.05.13-.19.19-.32.14-.13-.05-.19-.2-.14-.32.05-.13.19-.19.32-.14.13.05.2.19.15.32Z"
              strokeWidth="0"
            />
            <path
              d="m84.29,49.79c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.25-.24.41-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m83.52,49.97c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.05.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m88.42,49.2c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m88.75,48.7c-.03.06-.1.1-.16.07-.06-.02-.1-.1-.07-.16.02-.06.1-.09.16-.07.07.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m89.26,49.36c-.07.18-.27.27-.44.2-.18-.07-.26-.27-.2-.44.07-.18.26-.27.44-.2s.26.27.2.44Z"
              strokeWidth="0"
            />
            <path
              d="m89.98,49.66c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.21-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m89.74,48.97c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m90.62,50.25c-.05.14-.22.21-.36.16-.14-.06-.22-.22-.16-.36.06-.15.22-.22.36-.16.15.05.22.22.16.37Z"
              strokeWidth="0"
            />
            <path
              d="m90.54,49.51c-.04.09-.14.14-.24.11-.09-.04-.14-.14-.1-.24.04-.1.14-.15.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m91.33,50.51c-.07.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m91.78,51.16c-.03.06-.1.1-.16.07-.07-.02-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.02.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m91.06,51.01s-.07.08-.12.05c-.04-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m92.26,51.74c-.05.15-.22.22-.36.16-.14-.05-.22-.22-.16-.36.06-.14.22-.22.36-.16.15.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m81.67,47.75c-.05.13-.19.2-.32.15-.13-.05-.19-.2-.14-.32.05-.13.19-.19.32-.14.13.05.19.2.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m81,46.97c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m80.76,45.68c-.04.09-.15.14-.24.11-.1-.04-.14-.15-.11-.24.04-.1.14-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m83.59,46.03c-.04.11-.17.17-.28.12-.12-.04-.17-.17-.13-.28.04-.12.17-.17.28-.13.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m83.83,45.41c-.04.1-.15.14-.24.11-.1-.04-.14-.14-.11-.24.04-.09.14-.14.24-.11.09.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m84.04,46c-.02.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.07.09-.1.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m84.74,47.3c-.06.14-.22.22-.36.16-.14-.05-.22-.21-.16-.36.05-.14.22-.22.36-.16.14.06.21.22.16.37Z"
              strokeWidth="0"
            />
            <path
              d="m85.75,48.08c-.05.13-.19.19-.32.14-.13-.05-.2-.2-.15-.32.05-.13.19-.2.32-.14.13.05.2.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m85.59,46.82s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m86.7,47.68c-.04.1-.14.14-.25.11-.09-.04-.14-.14-.11-.24.04-.1.15-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m86.18,47.55c-.05.12-.17.17-.28.13-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.05.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m86.49,46.93s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
              strokeWidth="0"
            />
            <path
              d="m87.46,48.14c-.05.13-.2.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.2.15.32Z"
              strokeWidth="0"
            />
            <path
              d="m88.23,48.4c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.21.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m87.81,48.7c-.05.13-.19.19-.32.15-.13-.05-.19-.2-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m90.27,48.81c-.04.1-.15.14-.24.11-.09-.04-.14-.14-.11-.24.04-.1.14-.14.24-.11.1.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m91.31,49.57c-.02.07-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.06.09-.1.16-.07.06.02.1.09.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m92.04,50.45c-.02.06-.09.1-.16.07-.07-.02-.09-.1-.07-.16.03-.07.1-.1.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m86.87,51.42c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.25.4-.18.16.06.24.24.18.41Z"
              strokeWidth="0"
            />
            <path
              d="m85.94,51.06c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m85.31,50.88c-.04.1-.14.15-.24.11-.1-.04-.14-.14-.11-.24.04-.1.14-.15.24-.11.1.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m84.73,51.1c-.05.14-.22.21-.36.16-.14-.05-.22-.22-.16-.36.06-.14.22-.21.36-.16.15.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m83.75,50.69c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m83.88,51.31c-.06.16-.24.24-.4.18-.17-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m85.7,51.43c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m82.99,50.76c-.04.11-.17.17-.28.13-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m82.36,51.09c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m82.85,51.28c-.04.1-.14.15-.24.11-.1-.04-.15-.15-.11-.24.04-.1.14-.14.24-.1.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m81.45,50.68c-.04.1-.15.15-.24.11-.1-.04-.14-.15-.11-.24.04-.1.15-.14.24-.11s.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m81.61,51.14c-.02.06-.09.1-.16.07-.06-.03-.09-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m80.9,50.97s-.07.07-.12.05c-.05-.02-.07-.07-.06-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m80.66,50.74c-.04.1-.15.14-.24.1-.1-.04-.15-.14-.11-.24.04-.1.15-.15.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m80.16,50.99c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m80.62,51.53c-.02.05-.07.07-.12.05-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m80.76,52.05c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m81.6,52.37c-.06.16-.24.24-.4.18-.16-.07-.24-.24-.18-.4.06-.16.24-.24.41-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m80.16,52.75c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m79.39,53.63c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m78.48,53.11c-.05.14-.22.21-.36.16-.15-.06-.22-.22-.16-.36.05-.15.22-.22.36-.16.14.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m77.53,54.22c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m72.92,53.52c-.02.07-.1.1-.16.07-.06-.02-.1-.1-.07-.16.03-.06.1-.09.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m73.86,52.45c-.04.1-.14.14-.24.11-.1-.03-.15-.14-.11-.24.04-.1.15-.14.24-.11.09.04.14.14.1.24Z"
              strokeWidth="0"
            />
            <path
              d="m74.36,52.27c-.04.1-.14.15-.24.11-.1-.04-.14-.15-.11-.24.04-.1.15-.14.24-.11.09.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m74.13,51.41s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m74.79,51.24c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m75.56,51.6c-.05.14-.22.22-.36.16-.14-.06-.22-.22-.16-.36.05-.14.22-.22.36-.16.14.06.21.21.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m79.49,51.79c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m72.81,50.85c-.06.14-.22.21-.36.16-.15-.05-.22-.22-.16-.36.05-.14.22-.22.36-.16.14.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m72.43,50.27c-.04.1-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m70.26,51.31c-.04.09-.14.14-.24.11-.1-.03-.15-.14-.11-.24.04-.1.14-.15.24-.11.1.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m70.62,51.58c-.02.06-.1.1-.16.07-.06-.03-.09-.1-.07-.16.03-.07.1-.1.16-.07.06.03.1.09.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m72.7,52.01s-.05.05-.08.04c-.03,0-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
              strokeWidth="0"
            />
            <path
              d="m74.04,50.08c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.21-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m74.61,50.23c-.06.14-.22.22-.37.16-.14-.06-.21-.22-.16-.36.06-.14.22-.22.36-.16.14.05.22.21.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m75.02,50.12c-.02.06-.1.09-.16.07-.06-.03-.09-.1-.07-.16.02-.06.09-.1.16-.07.07.02.1.09.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m75.37,49.65c-.02.05-.07.07-.12.06-.05-.02-.07-.08-.05-.12.02-.05.07-.07.12-.06.05.02.07.08.06.12Z"
              strokeWidth="0"
            />
            <path
              d="m76.1,49.74c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m74.84,49.02c-.02.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.06.09-.1.16-.07.07.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m75.84,48.67c-.05.15-.22.22-.36.16-.15-.05-.22-.22-.16-.36.05-.15.22-.22.36-.16.14.06.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m76.47,49.21c-.05.13-.2.19-.32.14-.13-.05-.19-.19-.15-.32.05-.13.19-.19.32-.14.13.05.19.2.15.32Z"
              strokeWidth="0"
            />
            <path
              d="m76.97,48.77c-.03.07-.1.1-.16.07-.06-.03-.09-.1-.07-.16.02-.06.1-.1.16-.07.07.02.1.09.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m76.54,48.33c-.04.1-.15.15-.24.11-.1-.04-.14-.14-.11-.24.04-.09.14-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m77.07,48.34c-.06.15-.22.22-.36.16-.14-.06-.22-.22-.16-.36.06-.15.22-.22.36-.16.14.06.22.22.16.37Z"
              strokeWidth="0"
            />
            <path
              d="m77.08,49.18c-.02.05-.07.07-.12.05-.05-.02-.07-.07-.05-.12.02-.05.07-.08.12-.06.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m71.6,48.85c-.04.1-.14.15-.24.11-.1-.04-.14-.14-.11-.24.04-.09.15-.14.24-.11.1.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m70.64,47.78c-.03.1-.14.14-.24.11-.09-.04-.14-.14-.11-.24.04-.09.15-.14.25-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m71.86,47.75c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m72.19,47.31c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m72.8,46.5c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m72.71,45.77c-.04.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.04-.09.15-.15.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m73.27,46.15c-.06.15-.22.22-.36.16-.14-.05-.22-.22-.16-.36.06-.15.22-.22.36-.16.15.05.22.21.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m74.53,44.69s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.04.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m75.09,45.04c-.05.14-.22.22-.36.16-.14-.06-.22-.22-.16-.36.05-.14.22-.21.36-.16.15.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m75.46,45.48c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m75.06,45.56c-.02.07-.1.1-.16.07-.07-.03-.1-.1-.08-.16.03-.07.1-.1.16-.07.07.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m75.84,45.97c-.04.11-.17.16-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m75.75,47.43c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m76.2,47.82s-.06.06-.1.04c-.04-.01-.06-.06-.05-.1.01-.04.06-.06.1-.05.04.02.06.06.05.1Z"
              strokeWidth="0"
            />
            <path
              d="m74.84,48.15c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.21.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m71.33,42.94c-.04.11-.17.17-.28.12-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.12.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m72.71,43.33c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m74.58,43.58c-.05.13-.19.2-.32.15-.13-.05-.19-.2-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m73.94,43c-.02.07-.1.1-.16.07-.06-.02-.1-.09-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m74.33,42.58c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.12-.29.04-.11.17-.17.28-.12.11.05.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m73.63,42.51s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.06.12Z"
              strokeWidth="0"
            />
            <path
              d="m72.67,42.48c-.02.07-.1.1-.16.07-.06-.02-.1-.1-.07-.16.03-.06.1-.1.16-.07.07.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m72.61,41.93c-.02.07-.1.1-.16.07-.06-.03-.09-.1-.07-.16.03-.06.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m73.21,42.99c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.12.17-.17.28-.13.11.04.17.17.12.29Z"
              strokeWidth="0"
            />
            <path
              d="m71.05,41.83s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m70.03,43.18c-.04.1-.14.15-.24.11-.1-.04-.14-.15-.11-.24.04-.1.14-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m70.72,43.3c-.04.1-.15.15-.24.11-.1-.04-.14-.14-.11-.24.04-.1.15-.15.24-.11.09.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m71.12,43.73c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m71.66,43.73c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13s.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m72.37,43.78s-.04.04-.07.03c-.03-.02-.05-.04-.04-.07,0-.03.04-.04.07-.02.03.01.05.04.04.06Z"
              strokeWidth="0"
            />
            <path
              d="m68.83,42.75c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m69.35,42.78c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.12.17-.17.28-.13.12.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m70.23,42.22c-.03.06-.1.1-.16.07-.06-.02-.09-.1-.07-.16.02-.07.1-.1.16-.07.07.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m74,41.45c-.02.05-.07.07-.12.05-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m73.79,41.98s-.07.07-.12.06c-.05-.02-.07-.08-.06-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m69.94,41.07c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.15-.32.05-.13.19-.19.32-.14.13.05.2.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m69.92,41.63c-.02.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.07.09-.1.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m72,41.09s-.07.07-.12.05c-.05-.02-.07-.07-.06-.12.02-.05.07-.07.12-.06.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m85.96,43.69c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.21Z"
              strokeWidth="0"
            />
            <path
              d="m87.34,42.42c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.29.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m87.56,42.9s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
              strokeWidth="0"
            />
            <path
              d="m87.78,43.45c-.06.14-.22.22-.36.16-.15-.05-.22-.22-.16-.36.06-.14.22-.22.36-.16.15.06.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m88.96,43.33c-.04.1-.14.15-.24.11-.1-.04-.14-.15-.11-.24.04-.1.14-.14.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m88.93,43.93c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m88.51,44.17c-.03.06-.1.1-.16.07-.06-.02-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m89.17,44.72c-.03.06-.1.1-.16.07-.06-.02-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m89.78,44.25c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m89.92,44.94c-.04.11-.17.17-.28.12-.12-.04-.17-.17-.13-.28.04-.12.17-.17.28-.12.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m90.24,44.53c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m90.5,45.16c-.02.06-.09.1-.16.07-.06-.02-.09-.1-.07-.16.02-.06.1-.09.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m91.05,45.11c-.05.14-.21.22-.36.16-.14-.06-.22-.22-.16-.36.06-.14.22-.21.36-.16.14.06.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m91.58,45.47c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m91.48,44.87s-.07.07-.12.05c-.05-.02-.08-.07-.06-.12.02-.05.08-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m90.77,43.76c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m89.7,42.79s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m89.16,42.48c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m92.36,45.44c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m93.3,45.6c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m94.07,45.69c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m90.56,42.38c-.02.05-.07.07-.12.05-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.06.05.02.07.07.06.12Z"
              strokeWidth="0"
            />
            <path
              d="m90.05,42.32c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.05.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m90.23,43.07s-.06.06-.1.05c-.04-.02-.06-.06-.04-.1.01-.04.06-.06.1-.04s.06.06.05.1Z"
              strokeWidth="0"
            />
            <path
              d="m86.79,45.71c-.06.14-.22.22-.36.16-.14-.05-.22-.22-.16-.36.05-.14.22-.22.36-.16.15.05.22.21.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m87.37,45.57c-.04.09-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.15.24-.11.09.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m87.31,44.78c-.03.06-.1.1-.16.07-.06-.02-.09-.09-.07-.16.02-.06.09-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m85.69,45.96c-.04.1-.15.15-.24.11-.1-.04-.15-.15-.11-.24.04-.1.14-.15.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m86.41,46.27c-.04.1-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.15.24-.11.09.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m86.87,46.88c-.07.18-.27.27-.44.2-.18-.07-.26-.27-.2-.44.07-.18.26-.27.44-.2.18.07.26.27.2.44Z"
              strokeWidth="0"
            />
            <path
              d="m85.2,46.64c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m85.45,47.37c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m69.73,49.91c-.04.09-.14.14-.24.11-.1-.04-.15-.15-.11-.24.04-.09.14-.14.24-.11.1.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m65.95,51.86c-.05.12-.17.17-.28.13-.11-.05-.17-.17-.13-.28.04-.11.17-.17.29-.12.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m104.72,57.97s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.01-.05.07-.07.12-.05.05.02.07.07.06.12Z"
              strokeWidth="0"
            />
            <path
              d="m105.52,57.97c-.05.13-.19.2-.32.15-.13-.05-.2-.2-.15-.32.05-.13.19-.19.32-.15.13.05.19.2.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m105.91,58.46c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m106.75,58.08s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.06.12Z"
              strokeWidth="0"
            />
            <path
              d="m107.73,58.22c-.07.18-.26.27-.44.2-.18-.07-.27-.27-.2-.44.07-.18.27-.27.45-.2.17.07.26.27.2.44Z"
              strokeWidth="0"
            />
            <path
              d="m108.42,57.55c-.02.07-.1.1-.16.07-.07-.02-.1-.1-.08-.16.02-.06.1-.1.16-.07.07.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m109.34,57.86c-.05.13-.2.19-.32.14-.13-.05-.2-.19-.14-.32.05-.13.19-.19.32-.15.13.05.19.19.15.32Z"
              strokeWidth="0"
            />
            <path
              d="m108.48,58.44c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m109.37,58.58c-.08.19-.29.29-.48.21-.19-.08-.29-.29-.22-.48.07-.19.29-.29.48-.21.2.07.29.29.22.48Z"
              strokeWidth="0"
            />
            <path
              d="m108.48,58.97c-.03.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m107.8,59.08c-.05.14-.22.22-.36.16-.15-.06-.22-.22-.16-.36.05-.14.22-.22.36-.16.14.06.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m106.59,58.75c-.03.09-.14.15-.24.11-.1-.04-.15-.15-.11-.24.04-.09.14-.14.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m106.9,59.43c-.05.15-.22.22-.36.17-.14-.05-.22-.22-.16-.36.05-.15.22-.22.36-.16.15.06.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m105.54,59.51c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m105.07,60.3c-.08.21-.31.31-.52.23s-.31-.31-.23-.52c.08-.21.31-.31.52-.23.21.08.32.32.23.52Z"
              strokeWidth="0"
            />
            <path
              d="m105.78,60.01c-.04.1-.14.15-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.14.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m105.17,58.91c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m107.5,55.86c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m106.69,53.08c-.04.11-.17.17-.28.12-.11-.05-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m107.73,52.48c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m107,52.2s-.02.06-.02.06c0,0,.01-.03.02-.06.01-.03.02-.06.02-.06,0,0,0,.03-.02.06Z"
              strokeWidth="0"
            />
            <path
              d="m106.03,52.73c-.04.1-.15.14-.24.11-.1-.04-.15-.14-.11-.24.03-.1.14-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m105.11,53.13s-.04.04-.06.03c-.03,0-.04-.04-.03-.06,0-.03.04-.04.06-.03.02.01.04.04.03.06Z"
              strokeWidth="0"
            />
            <path
              d="m104.1,53.33c-.03.06-.1.09-.16.07-.07-.03-.1-.1-.08-.16.03-.06.1-.1.16-.07.07.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m111.31,50.94c-.04.13-.19.2-.32.15-.13-.05-.19-.2-.14-.32.05-.13.19-.2.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m112.11,50.51c-.05.15-.22.22-.36.16-.14-.05-.21-.22-.16-.36.06-.14.22-.22.36-.16.15.05.22.21.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m112.89,54.05c-.02.06-.1.09-.16.07-.07-.02-.1-.1-.07-.16.02-.06.09-.1.16-.07.06.02.1.09.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m113.67,54.98c-.04.1-.14.14-.24.11-.1-.04-.15-.15-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m115.09,53.46c-.04.1-.15.14-.25.11-.09-.04-.14-.14-.11-.24.04-.1.14-.14.24-.11.09.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m115.31,54.01c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.2.32-.15.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m114.91,55.59c-.07.18-.27.27-.44.2-.18-.07-.26-.27-.2-.44.07-.18.27-.27.44-.2.18.06.27.26.2.44Z"
              strokeWidth="0"
            />
            <path
              d="m115.68,55.25c-.04.1-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.15.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m115.46,55.73c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m114.52,56.17c-.04.1-.15.15-.24.11-.09-.04-.14-.14-.11-.24.04-.1.15-.15.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m113.8,56.13c-.07.2-.29.29-.48.22-.19-.07-.29-.29-.22-.49.07-.19.29-.29.48-.21.19.07.29.29.22.48Z"
              strokeWidth="0"
            />
            <path
              d="m113.63,56.77c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m112.96,56.58c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m112.91,57.16c-.06.14-.22.22-.36.16-.15-.05-.22-.21-.16-.36.05-.14.21-.22.36-.16.15.06.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m109.5,56.73c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m116.44,48.53c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m117.08,48.17c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.12.17-.17.28-.13.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m117.67,47.84s-.07.08-.12.06c-.05-.02-.07-.08-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m117.99,47.19c-.05.13-.19.19-.32.14-.13-.05-.2-.19-.14-.32.05-.13.19-.19.32-.15.13.05.2.2.15.32Z"
              strokeWidth="0"
            />
            <path
              d="m118.81,46.96c-.02.07-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.09-.09.16-.07.07.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m118.49,47.18c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.07.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m120,49.43c-.05.13-.19.19-.32.14-.13-.05-.2-.19-.15-.32.05-.13.2-.19.32-.14.13.05.19.2.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m120.64,50.91c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m121.8,50.65c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.05.17.17.12.29Z"
              strokeWidth="0"
            />
            <path
              d="m119.81,51.42c-.09.24-.36.37-.61.27-.24-.09-.36-.36-.27-.61.09-.24.36-.36.6-.27.24.09.36.36.27.6Z"
              strokeWidth="0"
            />
            <path
              d="m120.14,52.04c-.04.1-.15.15-.24.11-.1-.04-.14-.14-.11-.24.04-.09.14-.14.24-.11.09.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m119.59,52.78c-.04.09-.14.14-.24.1-.1-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m120.76,52.52c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m121,51.61c-.04.1-.14.15-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m121.55,51.92c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m122.23,51.28c-.08.22-.34.34-.56.25-.23-.08-.33-.34-.25-.56.09-.22.34-.34.56-.25.23.09.34.34.25.56Z"
              strokeWidth="0"
            />
            <path
              d="m122.22,49.91s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m119.57,53.36c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m118.97,52.9c-.07.18-.27.27-.44.2-.17-.07-.27-.27-.2-.44.07-.18.27-.27.44-.2.18.07.27.27.2.44Z"
              strokeWidth="0"
            />
            <path
              d="m124.97,47.52c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m125.46,46.57c-.04.11-.17.17-.28.12-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m126.54,46.28c-.08.21-.31.32-.52.24-.21-.08-.32-.31-.23-.52.08-.21.31-.32.52-.23.21.08.32.31.23.52Z"
              strokeWidth="0"
            />
            <path
              d="m126.31,47.23c-.04.1-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.15.24-.11.1.03.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m125.7,47.53c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m125.68,48.36c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m124.6,48.75c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.15-.32.05-.13.2-.19.32-.14.13.04.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m124.54,47.96c-.04.09-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m124.92,49.13c-.04.1-.14.15-.24.11-.1-.04-.15-.15-.11-.24.04-.1.15-.14.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m126.82,46.86c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m122.6,42.98c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m122.46,43.53c-.05.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m121.77,44.03s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m121.42,44.59c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.12.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m125.22,40.24s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.04.05-.05.08-.04.03.01.05.05.04.08Z"
              strokeWidth="0"
            />
            <path
              d="m125.49,39.25s-.07.07-.12.05c-.05-.02-.07-.07-.06-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m126,38.54c-.02.06-.1.1-.16.07-.06-.02-.1-.1-.07-.16.02-.06.09-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m128.12,40.95c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.05.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m129.33,40.81c-.04.09-.15.14-.24.11-.1-.04-.14-.14-.11-.24.04-.09.15-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m129.43,41.78c-.04.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.14-.14.24-.11.09.04.14.15.1.24Z"
              strokeWidth="0"
            />
            <path
              d="m129.25,42.52c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m129.98,41.13c-.02.06-.09.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.03.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m130.52,41.83c-.08.2-.29.29-.48.22-.2-.07-.29-.29-.22-.48.07-.19.29-.29.48-.22.19.07.29.29.22.48Z"
              strokeWidth="0"
            />
            <path
              d="m129.9,42.66c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m129.26,43.28c-.07.18-.26.27-.44.2-.18-.07-.27-.26-.2-.44.07-.18.26-.27.44-.2.17.07.27.26.2.44Z"
              strokeWidth="0"
            />
            <path
              d="m129.07,43.95c-.02.07-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m130.39,40.51c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m128.46,42.48c-.04.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.03-.1.14-.15.24-.11.09.03.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m131.58,35.63c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.33-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m131.61,36.44c-.04.1-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.15.24-.11.1.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m132.1,36.03c-.04.1-.15.15-.24.11s-.14-.15-.11-.24c.04-.1.14-.14.24-.11s.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m131.86,36.91c-.03.06-.1.1-.16.07-.07-.02-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m130.56,35.94c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m130.87,36.7c-.02.07-.1.1-.16.07-.06-.02-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m131.71,37.38c-.04.1-.14.14-.24.11-.1-.04-.14-.15-.11-.24.04-.1.15-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m132.45,31.62c-.06.15-.22.22-.36.16-.15-.05-.22-.21-.16-.36.06-.14.22-.21.36-.16.14.06.22.21.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m131.46,30.88c-.02.06-.09.1-.16.07-.06-.03-.1-.09-.07-.16.03-.06.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m131.74,30.49c-.02.06-.1.1-.16.07-.07-.03-.09-.09-.07-.16.02-.07.09-.1.16-.07.07.02.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m132.14,30.51c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m132.28,29.96s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.06.12Z"
              strokeWidth="0"
            />
            <path
              d="m131.98,29.28c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m132.64,29.8c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m132.75,30.57c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.12.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m132.38,30.93s-.04.05-.08.03c-.03-.01-.05-.05-.04-.08.02-.03.05-.05.08-.04.03.01.05.05.04.08Z"
              strokeWidth="0"
            />
            <path
              d="m132.65,32.04s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m131.74,31.46c-.04.1-.15.14-.24.11-.09-.04-.14-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m131.44,25.27c-.04.1-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.15.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m132.08,24.91c-.04.11-.17.17-.28.13-.11-.05-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m132.14,25.6c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m131.77,26.06c-.02.05-.07.08-.12.06-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.08.07.06.12Z"
              strokeWidth="0"
            />
            <path
              d="m132.36,26.45c-.05.13-.19.19-.32.15-.13-.05-.2-.19-.15-.32.05-.13.19-.2.32-.15.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m131.8,24.24c-.02.06-.09.1-.16.07-.07-.02-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m128.05,25.4c-.03.07-.1.1-.17.07-.06-.02-.09-.1-.07-.16.02-.06.1-.09.16-.07.07.02.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m127.72,25.48s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m127.86,26.33c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m128.23,26.41s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m128.08,29.42c-.02.05-.07.08-.12.06-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m127.79,29.84c-.02.07-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m127.96,30.71c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m127.9,31.29c-.05.13-.19.19-.32.15-.13-.05-.19-.2-.15-.32.05-.13.2-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m126.57,20.8s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.08.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m126.46,21.26c-.04.1-.15.14-.24.1-.1-.04-.15-.14-.11-.24.04-.1.14-.14.24-.11.1.04.14.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m126.99,21.46c-.05.13-.2.2-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.15.13.05.19.2.15.32Z"
              strokeWidth="0"
            />
            <path
              d="m126.93,22.14c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m127.42,20.76s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
              strokeWidth="0"
            />
            <path
              d="m126.52,20.42c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m127.55,21.91s-.07.08-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m130.66,20.13c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.02.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m130.53,20.58c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m131.05,20.78c-.05.13-.19.2-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.15.13.05.19.2.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m130.99,21.29c-.02.07-.1.1-.16.07-.07-.02-.09-.1-.07-.16.02-.06.1-.1.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m131.4,21.51c-.04.1-.15.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m130.2,19.69c-.02.06-.09.1-.16.07-.07-.03-.1-.1-.07-.16.02-.06.1-.09.16-.07.06.02.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m127.78,33.98c-.02.07-.09.1-.16.07-.07-.02-.1-.09-.07-.16.02-.06.1-.1.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m127.36,34.45c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m127.58,35.01c-.03.06-.1.09-.16.07-.06-.03-.09-.1-.07-.16.02-.07.1-.1.16-.07.07.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m127.18,35.35c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m124.93,40.03c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m125.53,39.77c-.02.06-.08.09-.14.06-.06-.02-.08-.08-.06-.14.02-.06.08-.08.14-.06.06.02.08.08.06.14Z"
              strokeWidth="0"
            />
            <path
              d="m125.59,38.75s-.05.05-.08.04c-.03-.02-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.04.04.08Z"
              strokeWidth="0"
            />
            <path
              d="m124.73,17.5c-.05.15-.22.22-.36.16-.14-.06-.22-.22-.16-.36.05-.15.22-.22.36-.16.14.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m124.84,18.17c-.03.07-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.02.09.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m125.37,17.47c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m125.42,18.39c-.04.1-.14.15-.24.11-.09-.04-.14-.15-.11-.24.04-.1.14-.15.24-.11.09.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m122.88,15.42c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.12.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m122.08,14.55c-.02.06-.09.09-.16.07-.07-.02-.1-.1-.07-.16.03-.07.1-.1.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m122.06,13.74c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m123.12,14.55c-.04.11-.17.17-.28.13-.12-.05-.17-.17-.13-.28.04-.11.17-.17.28-.13s.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m122.61,14.92c-.04.1-.14.15-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.14.24-.11.09.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m119.66,12.42c-.05.13-.19.19-.32.14-.13-.05-.19-.2-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m118.75,11.74s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
              strokeWidth="0"
            />
            <path
              d="m118.18,11.15c-.06.14-.22.21-.36.16-.14-.05-.22-.22-.16-.36.06-.14.22-.22.36-.16.14.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m118.01,11.76c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m118.63,12.33c-.05.15-.22.22-.36.16-.15-.06-.22-.22-.17-.36.06-.15.22-.22.36-.16.14.05.22.22.16.36Z"
              strokeWidth="0"
            />
            <path
              d="m119.37,12.91c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m121.17,10.56s-.07.07-.12.06c-.04-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m120.44,10.21c-.02.05-.07.07-.12.05-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m119.49,9.72s-.02.06-.02.06c0,0,.01-.03.02-.06.01-.03.02-.06.02-.06,0,0,0,.02-.02.06Z"
              strokeWidth="0"
            />
            <path
              d="m118.55,9.56c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m123.19,11.93s-.05.05-.08.04c-.03-.01-.05-.05-.03-.08,0-.03.04-.05.08-.04.03.01.05.05.04.08Z"
              strokeWidth="0"
            />
            <path
              d="m119.7,9.87c-.05.13-.19.19-.32.15-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.15.13.05.2.2.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m124.07,12.4c-.06.16-.24.24-.41.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
              strokeWidth="0"
            />
            <path
              d="m124.5,12.87c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m125.29,13.14c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
              strokeWidth="0"
            />
            <path
              d="m125.64,13.71c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.12.28Z"
              strokeWidth="0"
            />
            <path
              d="m127.12,15.27c-.04.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.14-.14.24-.11.1.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m127.82,15.61c-.05.11-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m127.96,16.3c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m128.55,16.58c-.04.1-.14.15-.24.11-.1-.04-.15-.14-.11-.24.04-.09.14-.14.24-.11.1.04.14.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m128.85,17.1c-.02.06-.09.1-.16.07-.07-.02-.1-.1-.07-.16.03-.07.09-.1.16-.08.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m113.55,9.72c-.03.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.09.09.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m114.54,9.83c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.21-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m114.24,10.18c-.04.1-.14.14-.24.11-.1-.04-.14-.15-.11-.24.04-.09.15-.14.24-.11.1.04.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m114.72,10.43c-.02.06-.1.09-.16.07-.07-.03-.1-.1-.07-.16.02-.06.1-.09.16-.07.06.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m115.8,10.91c-.07.19-.29.29-.49.22-.19-.07-.29-.29-.21-.48.07-.19.29-.29.48-.21.19.07.29.29.22.48Z"
              strokeWidth="0"
            />
            <path
              d="m115.54,9.94c-.04.1-.15.14-.24.11-.1-.04-.14-.15-.11-.24.04-.1.14-.15.24-.11.1.03.15.14.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m112.61,9.83c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m111.88,9.11s-.07.07-.12.06c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m111.22,9.36c-.03.06-.1.09-.16.07-.06-.02-.09-.09-.07-.16.03-.07.1-.1.16-.07.07.03.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m111.79,9.71c-.04.1-.15.15-.24.11-.09-.04-.14-.15-.11-.24.04-.1.14-.15.24-.11.1.04.15.15.11.24Z"
              strokeWidth="0"
            />
            <path
              d="m108.83,8.81c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.07.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m109.96,9.35c-.04.11-.17.17-.28.13-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
              strokeWidth="0"
            />
            <path
              d="m109.43,8.88c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m110.64,9.4s-.07.08-.12.06c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.06.12Z"
              strokeWidth="0"
            />
            <path
              d="m107.98,8.76s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.06.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m107.41,8.41s-.07.07-.12.06c-.05-.02-.07-.08-.06-.12.02-.05.07-.08.12-.06.05.02.07.07.05.12Z"
              strokeWidth="0"
            />
            <path
              d="m106.92,8.48s-.05.05-.08.04c-.03-.01-.05-.05-.03-.08,0-.04.05-.05.08-.04.03.01.05.05.03.08Z"
              strokeWidth="0"
            />
            <path
              d="m105.86,8.28c-.02.07-.1.1-.16.08-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
              strokeWidth="0"
            />
            <path
              d="m104.78,7.97c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
              strokeWidth="0"
            />
            <path
              d="m103.75,8.04s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
              strokeWidth="0"
            />
            <path
              d="m103,7.81s-.05.03-.09.02c-.04-.02-.06-.05-.06-.07.01-.03.05-.03.09-.02.04.01.07.05.06.07Z"
              strokeWidth="0"
            />
            <path
              d="m101.88,7.7s-.05.05-.08.03c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
              strokeWidth="0"
            />
            <path
              d="m100.6,7.54s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
              strokeWidth="0"
            />
          </g>
          <g opacity=".3">
            <image
              width="327"
              height="361"
              transform="translate(19.41 -1.88) scale(.24)"
              href="data:image/png;base64,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"
            />
          </g>
          <g>
            <g>
              <image
                width="324"
                height="338"
                transform="translate(11.49 -2.6) scale(.24)"
                href="data:image/png;base64,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"
              />
            </g>
            <g>
              <image
                width="323"
                height="336"
                transform="translate(11.49 -2.6) scale(.24)"
                href="data:image/png;base64,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"
              />
            </g>
            <g>
              <path
                d="m52.15,40.59s.05,0,.07,0c.27-3.78-1.99-4.74-1.99-4.74h.02s-.01,0-.02,0c-.67-.35-1.32-.64-1.97-1.22,0,0,.03,1.97,0,2.43,0,0,.33,3.26,3.96,3.53"
                strokeWidth="0"
              />
              <g>
                <path
                  d="m52.25,39.5c-.08.18-.2.33-.36.44-.37.26-.86.26-1.36.05,0,0-.01,0-.02,0-.01,0-.03,0-.04-.02-.02,0-.04-.02-.07-.03-.01,0-.02-.02-.04-.02,0,0,0,0-.02,0,0,0-.01,0-.02,0-.02-.01-.04-.02-.06-.03-.02-.01-.04-.02-.07-.04,0,0-.01,0-.02-.02,0,0-.01,0-.02,0,0,0-.01,0-.02-.01-.03-.02-.05-.04-.08-.05-.02-.01-.04-.02-.05-.04,0,0-.01,0-.02-.01,0,0,0,0-.01-.01-.02-.02-.04-.03-.06-.05-.03-.02-.05-.04-.08-.06,0,0-.02-.01-.02-.02,0,0-.01,0-.01-.01-.03-.03-.06-.06-.09-.08-.02-.02-.04-.03-.05-.05,0,0-.01-.01-.02-.02-.03-.03-.06-.06-.09-.09-.02-.02-.05-.05-.07-.07-.03-.04-.07-.07-.1-.11-.07-.08-.14-.17-.2-.26-.07-.1-.13-.19-.18-.29-.02-.04-.05-.08-.07-.12-.02-.03-.03-.06-.05-.09-.02-.03-.03-.07-.05-.1,0,0,0-.01-.01-.02-.01-.03-.03-.06-.04-.09-.01-.03-.03-.06-.04-.09,0,0,0-.01,0-.02,0,0,0-.02-.01-.03-.01-.04-.02-.07-.03-.11,0-.02-.01-.03-.02-.05,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0-.02-.01-.05-.02-.07,0-.03-.01-.06-.02-.09,0,0,0-.01,0-.02,0,0,0-.02,0-.02,0-.01,0-.03,0-.04,0-.03,0-.06-.01-.09,0-.01,0-.03,0-.04,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0-.02,0-.03,0-.05,0-.03,0-.05,0-.08,0-.01,0-.03,0-.04,0,0,0,0,0-.01-.03-.54.14-1.01.5-1.27.26-.19.6-.24.95-.17-.24-.12-.48-.25-.72-.38-.22.04-.42.12-.58.27-.72.63-.54,2.11.41,3.29.43.54.96.95,1.5,1.15.61.23,1.16.18,1.54-.15.04-.03.07-.06.1-.1,0-.12-.01-.25-.02-.37Z"
                  strokeWidth="0"
                />
                <path
                  d="m49.08,35.95c-.37.26-.53.72-.5,1.27,0-.51.18-.96.54-1.21.27-.2.62-.25.98-.2-.02-.01-.04-.02-.06-.03-.35-.07-.69-.02-.95.17Z"
                  fill="#b8b8b8"
                  strokeWidth="0"
                />
                <path
                  d="m50.53,39.99c.5.21,1,.21,1.36-.05.16-.11.28-.26.36-.44,0-.03,0-.06,0-.1-.09.2-.22.36-.4.48-.37.26-.84.28-1.32.11Z"
                  fill="#b8b8b8"
                  strokeWidth="0"
                />
                <path
                  d="m50.51,39.98s.01,0,.02,0c.48.17.96.15,1.32-.11.18-.12.3-.29.4-.48,0,0,0,0,0,0-.09.2-.22.36-.4.48-.37.26-.85.28-1.34.1Z"
                  fill="#b9b9b9"
                  strokeWidth="0"
                />
                <path
                  d="m49.12,36c-.37.25-.55.7-.54,1.21,0,0,0,0,0,.01,0-.52.18-.96.54-1.22.28-.2.62-.25.98-.19h0c-.36-.06-.7,0-.98.19Z"
                  fill="#b9b9b9"
                  strokeWidth="0"
                />
                <path
                  d="m50.47,39.96s.03.01.04.02c.49.18.97.16,1.34-.1.17-.12.31-.29.4-.48h0c-.09.19-.22.36-.4.48-.38.27-.88.28-1.38.08Z"
                  fill="#bababa"
                  strokeWidth="0"
                />
                <path
                  d="m49.12,36c-.37.26-.55.71-.54,1.22,0,.01,0,.03,0,.04-.01-.53.17-1,.54-1.26.28-.2.63-.25.99-.19h0c-.37-.06-.71,0-.99.19Z"
                  fill="#bababa"
                  strokeWidth="0"
                />
                <path
                  d="m49.12,36c-.37.26-.55.73-.54,1.26,0,.03,0,.05,0,.08-.03-.57.14-1.06.54-1.34.28-.2.63-.25,1-.19,0,0,0,0,0,0-.36-.06-.71,0-.99.19Z"
                  fill="#bbb"
                  strokeWidth="0"
                />
                <path
                  d="m50.4,39.93s.04.02.07.03c.5.2,1,.19,1.38-.08.18-.12.31-.29.4-.49,0,0,0,0,0,0-.09.2-.22.37-.4.49-.39.27-.92.28-1.44.05Z"
                  fill="#bbb"
                  strokeWidth="0"
                />
                <path
                  d="m50.36,39.91s.03.01.04.02c.52.22,1.05.22,1.44-.05.18-.12.31-.29.4-.49,0,0,0,0,0,0-.09.2-.22.37-.4.5-.41.28-.95.27-1.48.04Z"
                  fill="#bcbcbc"
                  strokeWidth="0"
                />
                <path
                  d="m49.12,36.01c-.39.28-.57.77-.54,1.34,0,.01,0,.03,0,.05-.05-.58.13-1.1.53-1.38.28-.2.63-.26,1-.19,0,0,0,0,0,0-.37-.06-.72,0-1,.19Z"
                  fill="#bcbcbc"
                  strokeWidth="0"
                />
                <path
                  d="m49.12,36.01c-.4.28-.58.8-.53,1.38,0,0,0,.01,0,.02-.05-.59.12-1.11.53-1.4.28-.2.64-.25,1.01-.19h0c-.37-.07-.72-.01-1,.18Z"
                  fill="#bdbdbd"
                  strokeWidth="0"
                />
                <path
                  d="m50.34,39.9s.01,0,.02,0c.53.24,1.07.25,1.48-.04.18-.12.31-.29.4-.5h0c-.09.2-.23.37-.4.5-.41.28-.96.27-1.5.03Z"
                  fill="#bdbdbd"
                  strokeWidth="0"
                />
                <path
                  d="m49.12,36.01c-.41.29-.58.81-.53,1.4,0,0,0,0,0,.02-.06-.6.12-1.12.53-1.41.28-.2.64-.26,1.01-.19,0,0,0,0,0,0-.37-.07-.73-.01-1.01.19Z"
                  fill="#bebebe"
                  strokeWidth="0"
                />
                <path
                  d="m50.33,39.89s.01,0,.02,0c.54.25,1.09.26,1.5-.03.18-.13.31-.3.4-.5,0,0,0,0,0,0-.09.2-.23.38-.4.5-.41.29-.97.28-1.51.02Z"
                  fill="#bebebe"
                  strokeWidth="0"
                />
                <path
                  d="m49.12,36.01c-.41.29-.59.82-.53,1.41,0,.02,0,.03,0,.04-.07-.61.11-1.16.53-1.45.29-.2.65-.26,1.02-.18,0,0,0,0,0,0-.38-.07-.73-.02-1.01.18Z"
                  fill="#bfbfbf"
                  strokeWidth="0"
                />
                <path
                  d="m50.27,39.86s.04.02.06.03c.54.25,1.1.27,1.51-.02.18-.12.31-.3.4-.5h0c-.09.2-.23.37-.4.5-.43.3-1.01.27-1.57,0Z"
                  fill="#bfbfbf"
                  strokeWidth="0"
                />
                <path
                  d="m50.2,39.82s.05.03.07.04c.56.28,1.14.31,1.57,0,.18-.12.31-.3.4-.5h0c-.09.2-.23.38-.4.5-.44.31-1.06.27-1.64-.05Z"
                  fill="silver"
                  strokeWidth="0"
                />
                <path
                  d="m49.13,36.02c-.42.29-.59.84-.53,1.45,0,.03,0,.06.01.09-.09-.65.08-1.23.51-1.54.29-.2.65-.26,1.03-.18h0c-.37-.07-.74-.02-1.02.18Z"
                  fill="silver"
                  strokeWidth="0"
                />
                <path
                  d="m50.18,39.81s.01,0,.02.02c.58.32,1.2.35,1.64.05.18-.13.31-.3.4-.51,0,0,0,0,0,0-.09.2-.23.38-.41.51-.44.31-1.07.27-1.65-.06Z"
                  fill="#c1c1c1"
                  strokeWidth="0"
                />
                <path
                  d="m49.13,36.02c-.44.31-.61.89-.51,1.54,0,.01,0,.02,0,.04-.11-.66.06-1.26.51-1.58.29-.2.65-.25,1.03-.18,0,0,0,0,0,0-.38-.07-.74-.02-1.03.18Z"
                  fill="#c1c1c1"
                  strokeWidth="0"
                />
                <path
                  d="m50.16,39.8s.01,0,.01,0c.59.33,1.22.38,1.66.06.18-.13.32-.3.41-.51h0c-.09.2-.22.38-.41.5-.45.32-1.08.27-1.67-.06Z"
                  fill="#c2c2c2"
                  strokeWidth="0"
                />
                <path
                  d="m49.13,36.02c-.45.31-.62.91-.51,1.58,0,0,0,.01,0,.02-.11-.67.06-1.28.51-1.6.29-.21.65-.25,1.03-.18h0c-.38-.08-.74-.03-1.03.18Z"
                  fill="#c2c2c2"
                  strokeWidth="0"
                />
                <path
                  d="m49.13,36.02c-.45.32-.62.92-.51,1.6,0,0,0,.01,0,.02-.12-.68.04-1.29.5-1.61.29-.21.66-.26,1.04-.17,0,0,0,0,0,0-.38-.08-.75-.03-1.04.18Z"
                  fill="#c3c3c3"
                  strokeWidth="0"
                />
                <path
                  d="m50.14,39.78s.01,0,.02.01c.59.34,1.22.38,1.67.06.18-.13.32-.3.41-.51h0c-.09.2-.22.38-.41.51-.45.32-1.09.27-1.69-.08Z"
                  fill="#c3c3c3"
                  strokeWidth="0"
                />
                <path
                  d="m51.83,39.86c-.48.34-1.15.26-1.77-.13.03.02.05.04.08.05.6.34,1.24.39,1.69.08.18-.13.32-.31.41-.51h0c-.09.2-.23.38-.41.51Z"
                  fill="#c4c4c4"
                  strokeWidth="0"
                />
                <path
                  d="m49.13,36.02c-.46.32-.62.94-.5,1.61,0,.03.01.06.02.09-.15-.71,0-1.37.48-1.7.29-.21.66-.25,1.05-.17h0c-.38-.08-.75-.03-1.04.17Z"
                  fill="#c4c4c4"
                  strokeWidth="0"
                />
                <path
                  d="m51.83,39.86c-.49.35-1.19.26-1.82-.16.02.02.04.03.05.04.62.39,1.29.46,1.77.13.18-.13.32-.31.41-.52,0,0,0,0,0,0-.09.21-.23.39-.41.52Z"
                  fill="#c5c5c5"
                  strokeWidth="0"
                />
                <path
                  d="m49.13,36.03c-.47.33-.63.99-.48,1.7,0,.02.01.05.02.07-.18-.74-.02-1.42.47-1.77.29-.21.67-.26,1.05-.17,0,0,0,0,0,0-.39-.08-.76-.03-1.05.17Z"
                  fill="#c5c5c5"
                  strokeWidth="0"
                />
                <path
                  d="m51.83,39.85c-.49.35-1.2.25-1.84-.17,0,0,.01,0,.02.01.63.42,1.33.51,1.82.16.18-.13.32-.31.41-.52h0c-.09.21-.22.39-.41.52Z"
                  fill="#c6c6c6"
                  strokeWidth="0"
                />
                <path
                  d="m49.14,36.03c-.49.35-.64,1.03-.47,1.77,0,0,0,.01,0,.02-.19-.74-.04-1.44.46-1.78.3-.21.67-.26,1.06-.17,0,0,0,0,0,0-.39-.08-.76-.04-1.05.17Z"
                  fill="#c6c6c6"
                  strokeWidth="0"
                />
                <path
                  d="m51.83,39.85c-.5.35-1.21.25-1.85-.18,0,0,0,0,.01.01.63.43,1.35.52,1.84.17.19-.13.32-.31.41-.52h0c-.09.21-.23.39-.41.52Z"
                  fill="#c7c7c7"
                  strokeWidth="0"
                />
                <path
                  d="m49.14,36.03c-.49.35-.65,1.04-.46,1.78,0,0,0,.01,0,.02-.19-.75-.04-1.45.46-1.8.3-.21.67-.26,1.07-.17,0,0,0,0,0,0-.39-.08-.76-.04-1.06.17Z"
                  fill="#c7c7c7"
                  strokeWidth="0"
                />
                <path
                  d="m49.14,36.03c-.5.35-.65,1.05-.46,1.8,0,.02.01.04.02.05-.21-.76-.07-1.49.44-1.85.3-.21.68-.26,1.07-.17,0,0,0,0,0,0-.39-.09-.77-.04-1.07.17Z"
                  fill="#c8c8c8"
                  strokeWidth="0"
                />
                <path
                  d="m51.82,39.85c-.51.36-1.26.24-1.91-.23.02.01.04.03.06.05.64.44,1.35.53,1.85.18.19-.13.32-.31.41-.53,0,0,0,0,0,0-.09.21-.23.4-.41.53Z"
                  fill="#c8c8c8"
                  strokeWidth="0"
                />
                <path
                  d="m49.14,36.03c-.51.36-.65,1.09-.44,1.85.01.04.02.08.03.11-.26-.8-.13-1.59.41-1.96.3-.21.68-.26,1.08-.17,0,0,0,0,0,0-.39-.09-.77-.04-1.07.17Z"
                  fill="#c9c9c9"
                  strokeWidth="0"
                />
                <path
                  d="m51.82,39.85c-.53.38-1.32.24-1.99-.28.02.02.05.04.08.06.65.47,1.4.59,1.91.23.19-.13.32-.31.41-.53,0,0,0,0,0,0-.09.22-.22.4-.41.53Z"
                  fill="#c9c9c9"
                  strokeWidth="0"
                />
                <path
                  d="m51.82,39.85c-.54.38-1.33.23-2.01-.3,0,0,.02.01.02.02.67.52,1.45.66,1.99.28.19-.13.32-.31.41-.53t0,0c-.09.22-.22.4-.41.54Z"
                  fill="#cacaca"
                  strokeWidth="0"
                />
                <path
                  d="m49.14,36.04c-.53.37-.66,1.15-.41,1.96,0,0,0,.02.01.03-.27-.81-.14-1.61.4-1.99.3-.22.68-.26,1.08-.17,0,0,0,0,0,0-.39-.09-.78-.05-1.08.17Z"
                  fill="#cacaca"
                  strokeWidth="0"
                />
                <path
                  d="m49.14,36.04c-.54.38-.67,1.17-.4,1.99,0,0,0,.01,0,.02-.28-.82-.15-1.62.39-2,.3-.22.69-.26,1.09-.16,0,0,0,0,0,0-.4-.09-.78-.05-1.08.17Z"
                  fill="#cbcbcb"
                  strokeWidth="0"
                />
                <path
                  d="m51.82,39.84c-.54.38-1.34.23-2.02-.31,0,0,0,0,.01.01.68.53,1.47.68,2.01.3.19-.13.32-.32.41-.54h0c-.09.21-.22.4-.41.53Z"
                  fill="#cbcbcb"
                  strokeWidth="0"
                />
                <path
                  d="m49.14,36.04c-.54.38-.67,1.18-.39,2,.01.03.03.06.04.09-.32-.85-.21-1.7.36-2.09.3-.21.69-.26,1.09-.16h0c-.4-.1-.78-.06-1.09.16Z"
                  fill="#ccc"
                  strokeWidth="0"
                />
                <path
                  d="m51.82,39.84c-.57.4-1.42.21-2.11-.39.03.03.06.05.09.08.68.54,1.48.69,2.02.31.19-.13.32-.32.41-.54,0,0,0,0,0,0-.09.22-.23.41-.42.54Z"
                  fill="#ccc"
                  strokeWidth="0"
                />
                <path
                  d="m51.82,39.84c-.58.41-1.46.2-2.16-.44.02.02.03.03.05.05.69.6,1.54.79,2.11.39.19-.13.33-.32.42-.54h0c-.09.22-.22.41-.42.54Z"
                  fill="#cdcdcd"
                  strokeWidth="0"
                />
                <path
                  d="m49.15,36.04c-.56.39-.68,1.24-.36,2.09,0,.03.02.06.04.09-.36-.88-.26-1.78.32-2.19.3-.21.69-.26,1.1-.16h0c-.4-.1-.79-.06-1.09.16Z"
                  fill="#cdcdcd"
                  strokeWidth="0"
                />
                <path
                  d="m49.15,36.04c-.58.41-.69,1.31-.32,2.19,0,0,0,.02.01.02-.38-.89-.27-1.79.31-2.21.31-.21.7-.26,1.1-.15,0,0,0,0,0,0-.4-.1-.79-.06-1.1.16Z"
                  fill="#cecece"
                  strokeWidth="0"
                />
                <path
                  d="m51.81,39.84c-.58.41-1.47.2-2.18-.45,0,0,.01.01.02.02.71.64,1.58.84,2.16.44.19-.13.33-.32.42-.54h0c-.09.22-.23.41-.42.54Z"
                  fill="#cecece"
                  strokeWidth="0"
                />
                <path
                  d="m49.15,36.04c-.58.41-.69,1.32-.31,2.21.02.04.03.07.05.1-.43-.92-.34-1.88.27-2.3.31-.22.7-.26,1.11-.16h0c-.4-.1-.79-.06-1.1.15Z"
                  fill="#cfcfcf"
                  strokeWidth="0"
                />
                <path
                  d="m51.81,39.84c-.61.43-1.54.18-2.27-.54.03.03.06.06.09.09.71.65,1.59.86,2.18.45.19-.14.33-.32.42-.55h0c-.09.22-.23.41-.42.55Z"
                  fill="#cfcfcf"
                  strokeWidth="0"
                />
                <path
                  d="m49.15,36.05c-.61.43-.69,1.38-.27,2.3.01.03.03.06.05.09-.48-.94-.41-1.96.22-2.39.31-.22.7-.26,1.11-.16h0c-.41-.1-.8-.06-1.11.15Z"
                  fill="#d0d0d0"
                  strokeWidth="0"
                />
                <path
                  d="m51.81,39.83c-.63.44-1.61.16-2.33-.61.02.02.05.05.07.07.72.72,1.66.96,2.27.54.19-.14.33-.33.42-.55h0c-.09.22-.23.41-.42.55Z"
                  fill="#d0d0d0"
                  strokeWidth="0"
                />
                <path
                  d="m50.27,35.9s0,0,0,0h0s0,0,0,0Z"
                  fill="#d0d0d0"
                  strokeWidth="0"
                />
                <polygon
                  points="50.27 35.9 50.28 35.9 50.27 35.9 50.27 35.89 50.27 35.9"
                  fill="#d1d1d1"
                  strokeWidth="0"
                />
                <path
                  d="m51.81,39.83c-.66.46-1.7.14-2.43-.72.03.04.07.08.1.11.73.77,1.7,1.05,2.33.61.19-.14.33-.33.42-.55,0,0,0,0,0,0-.09.23-.23.42-.42.56Z"
                  fill="#d1d1d1"
                  strokeWidth="0"
                />
                <path
                  d="m49.15,36.06c.31-.22.71-.27,1.12-.16h0c-.41-.11-.81-.07-1.12.15-.63.44-.7,1.45-.22,2.39.02.04.04.08.07.12-.55-.97-.5-2.05.15-2.51Z"
                  fill="#d1d1d1"
                  strokeWidth="0"
                />
                <path
                  d="m50.28,35.9h0c-.41-.11-.81-.07-1.12.15-.65.46-.7,1.53-.15,2.51.05.1.11.2.18.29.06.09.13.18.2.26.73.85,1.77,1.18,2.43.72.2-.14.33-.33.42-.56h0c-.09.22-.23.42-.42.55-.71.51-1.89.07-2.62-.97-.73-1.04-.74-2.3-.03-2.8.32-.23.72-.26,1.14-.15,0,0,0,0-.01,0h0,0Z"
                  fill="#d2d2d2"
                  strokeWidth="0"
                />
                <path
                  d="m49.15,36.06c-.72.5-.71,1.76.03,2.8.73,1.04,1.91,1.48,2.62.97.2-.13.34-.33.42-.56,0,0,0,0,0,0-.09.23-.22.43-.42.56-.71.5-1.89.07-2.62-.97-.73-1.04-.74-2.3-.03-2.8.32-.22.72-.26,1.15-.15,0,0,0,0-.01,0-.42-.11-.82-.08-1.14.15Z"
                  fill="#d3d3d3"
                  strokeWidth="0"
                />
                <path
                  d="m49.16,36.06c-.72.5-.71,1.75.03,2.8.73,1.04,1.91,1.47,2.62.97.2-.13.34-.33.42-.56h0c-.09.23-.23.43-.42.56-.72.5-1.89.07-2.62-.97-.73-1.04-.75-2.29-.03-2.79.32-.23.73-.26,1.16-.14,0,0,0,0-.01,0-.42-.12-.83-.08-1.15.15Z"
                  fill="#d4d4d4"
                  strokeWidth="0"
                />
                <path
                  d="m49.16,36.06c-.72.5-.71,1.75.03,2.79.73,1.04,1.91,1.47,2.62.97.2-.13.34-.33.42-.56,0,0,0,0,0,0-.09.23-.23.43-.42.57-.72.5-1.89.07-2.62-.97-.73-1.04-.74-2.29-.02-2.79.32-.23.74-.26,1.16-.13,0,0,0,0,0,0-.42-.12-.83-.09-1.16.14Z"
                  fill="#d5d5d5"
                  strokeWidth="0"
                />
                <path
                  d="m49.16,36.06c-.72.5-.71,1.75.02,2.79.73,1.04,1.9,1.47,2.62.97.2-.14.34-.34.42-.57,0,0,0,0,0,0-.09.23-.23.44-.43.57-.71.5-1.89.07-2.62-.97-.73-1.04-.74-2.29-.03-2.79.32-.23.74-.26,1.17-.14,0,0,0,0,0,0-.43-.12-.85-.09-1.17.14Z"
                  fill="#d6d6d6"
                  strokeWidth="0"
                />
                <path
                  d="m49.16,36.06c-.71.5-.7,1.75.03,2.79.73,1.04,1.9,1.47,2.62.97.2-.14.34-.34.43-.57t0,0c-.09.23-.23.44-.42.57-.71.5-1.88.07-2.61-.97-.73-1.04-.74-2.28-.02-2.78.32-.23.75-.26,1.18-.13,0,0,0,0,0,0-.43-.12-.85-.09-1.17.14Z"
                  fill="#d7d7d7"
                  strokeWidth="0"
                />
                <path
                  d="m49.17,36.07c-.72.5-.7,1.75.02,2.78.73,1.04,1.9,1.47,2.61.97.2-.14.34-.34.42-.57h0c-.09.23-.22.43-.43.57-.71.5-1.88.07-2.61-.97-.73-1.04-.74-2.28-.02-2.78.33-.23.76-.26,1.19-.12,0,0,0,0-.01,0-.43-.13-.85-.1-1.18.13Z"
                  fill="#d8d8d8"
                  strokeWidth="0"
                />
                <path
                  d="m49.17,36.07c-.72.5-.7,1.75.02,2.78.73,1.04,1.9,1.47,2.61.97.2-.14.34-.34.43-.58,0,0,0,0,0,0-.08.24-.23.44-.43.58-.71.5-1.88.07-2.6-.97-.73-1.03-.74-2.28-.03-2.78.33-.23.76-.26,1.2-.12,0,0,0,0,0,0-.43-.13-.86-.11-1.19.12Z"
                  fill="#d9d9d9"
                  strokeWidth="0"
                />
                <path
                  d="m49.17,36.07c-.71.5-.7,1.75.03,2.78.73,1.04,1.9,1.47,2.6.97.2-.14.34-.34.43-.58,0,0,0,0,0,0-.08.24-.23.44-.43.59-.71.5-1.88.07-2.6-.96-.73-1.03-.74-2.28-.03-2.78.33-.24.77-.26,1.21-.12,0,0,0,0-.01,0-.43-.14-.87-.11-1.2.12Z"
                  fill="#dadada"
                  strokeWidth="0"
                />
                <path
                  d="m49.17,36.07c-.71.5-.7,1.74.03,2.78.72,1.03,1.89,1.46,2.6.96.2-.14.34-.35.43-.59,0,0,0,0,0,0-.08.24-.23.45-.43.59-.71.5-1.87.07-2.6-.96-.73-1.03-.74-2.27-.03-2.77.33-.24.77-.26,1.21-.12h0c-.44-.15-.87-.12-1.21.12Z"
                  fill="#dbdbdb"
                  strokeWidth="0"
                />
                <path
                  d="m49.17,36.07c-.71.5-.7,1.74.03,2.77.73,1.03,1.89,1.46,2.6.96.2-.14.35-.35.43-.59,0,0,0,0,0,0-.08.24-.23.45-.43.59-.71.5-1.87.07-2.6-.96-.72-1.03-.73-2.27-.03-2.77.33-.24.78-.26,1.22-.12,0,0,0,0,0,0-.45-.14-.88-.12-1.21.12Z"
                  fill="#dcdcdc"
                  strokeWidth="0"
                />
                <path
                  d="m49.17,36.08c-.71.5-.7,1.74.03,2.77.73,1.03,1.89,1.46,2.6.96.21-.14.35-.35.43-.59h0c-.08.24-.23.45-.43.59-.71.5-1.87.07-2.59-.96-.72-1.03-.73-2.27-.03-2.77.34-.24.78-.26,1.23-.11,0,0,0,0,0,0-.45-.15-.89-.12-1.22.12Z"
                  fill="#ddd"
                  strokeWidth="0"
                />
                <path
                  d="m49.17,36.08c-.71.5-.7,1.74.03,2.77.72,1.03,1.89,1.46,2.59.96.21-.14.35-.35.43-.59t0,0c-.08.24-.23.45-.43.6-.71.5-1.87.07-2.59-.96-.72-1.03-.73-2.26-.03-2.76.34-.24.79-.26,1.24-.11,0,0,0,0,0,0-.45-.15-.89-.13-1.23.11Z"
                  fill="#dedede"
                  strokeWidth="0"
                />
                <path
                  d="m49.17,36.08c-.71.5-.7,1.73.03,2.76.72,1.03,1.88,1.46,2.59.96.21-.15.35-.35.43-.6h0c-.08.24-.23.45-.43.6-.71.5-1.87.07-2.59-.96-.72-1.02-.73-2.26-.03-2.76.34-.24.79-.26,1.25-.11,0,0,0,0,0,0-.45-.15-.9-.13-1.24.11Z"
                  fill="#dfdfdf"
                  strokeWidth="0"
                />
                <path
                  d="m49.17,36.08c-.71.5-.69,1.74.03,2.76.72,1.03,1.88,1.46,2.59.96.21-.15.35-.36.43-.6,0,0,0,0,0,0-.08.24-.22.46-.43.6-.71.49-1.87.07-2.58-.96-.72-1.03-.74-2.26-.03-2.76.34-.24.79-.26,1.25-.1,0,0,0,0,0,0-.45-.15-.9-.13-1.25.11Z"
                  fill="#e0e0e0"
                  strokeWidth="0"
                />
                <path
                  d="m49.17,36.08c-.71.5-.69,1.73.03,2.76.72,1.03,1.88,1.45,2.58.96.21-.15.35-.36.43-.6,0,0,0,0,0,0-.08.25-.23.46-.44.61-.71.5-1.86.07-2.58-.96s-.73-2.26-.03-2.75c.34-.24.8-.26,1.26-.1h0c-.46-.16-.91-.14-1.25.1Z"
                  fill="#e1e1e1"
                  strokeWidth="0"
                />
                <path
                  d="m49.18,36.09c-.71.5-.69,1.73.03,2.75s1.88,1.45,2.58.96c.21-.15.35-.36.44-.61,0,0,0,0,0,0-.08.25-.23.46-.43.61-.71.5-1.86.07-2.58-.96-.72-1.02-.73-2.25-.03-2.75.35-.24.81-.26,1.26-.1,0,0,0,0,0,0-.46-.16-.91-.14-1.26.1Z"
                  fill="#e2e2e2"
                  strokeWidth="0"
                />
                <path
                  d="m49.18,36.09c-.71.5-.69,1.73.03,2.75.72,1.03,1.87,1.45,2.58.96.21-.15.35-.36.43-.61,0,0,0,0,0,0-.08.25-.23.47-.44.61-.7.49-1.86.07-2.58-.96-.72-1.02-.73-2.25-.03-2.74.35-.24.81-.26,1.27-.1h0c-.46-.17-.92-.15-1.26.09Z"
                  fill="#e3e3e3"
                  strokeWidth="0"
                />
                <path
                  d="m49.18,36.09c-.7.49-.69,1.72.03,2.74.72,1.02,1.87,1.45,2.58.96.21-.15.36-.36.44-.61,0,0,0,0,0,0-.08.25-.23.47-.44.62-.7.5-1.86.07-2.57-.95-.72-1.02-.73-2.25-.03-2.74.35-.25.81-.27,1.27-.09h0c-.46-.17-.92-.15-1.27.09Z"
                  fill="#e4e4e4"
                  strokeWidth="0"
                />
                <path
                  d="m49.18,36.09c-.7.49-.69,1.72.03,2.74.72,1.02,1.87,1.45,2.57.95.21-.14.35-.36.44-.62h0c-.08.25-.23.47-.44.62-.7.49-1.85.07-2.57-.95-.72-1.02-.73-2.24-.03-2.74.35-.25.82-.26,1.28-.09h0c-.47-.18-.93-.16-1.28.09Z"
                  fill="#e6e6e6"
                  strokeWidth="0"
                />
                <path
                  d="m49.18,36.1c-.7.49-.69,1.72.03,2.74.72,1.02,1.87,1.45,2.57.95.21-.15.36-.36.44-.62,0,0,0,0,0,0-.08.26-.22.48-.44.62-.7.49-1.85.07-2.57-.95-.72-1.02-.73-2.24-.03-2.74.35-.25.82-.26,1.29-.08,0,0,0,0,0,0-.46-.17-.93-.16-1.28.09Z"
                  fill="#e7e7e7"
                  strokeWidth="0"
                />
                <path
                  d="m49.19,36.1c-.71.5-.69,1.72.03,2.74.72,1.02,1.87,1.45,2.57.95.21-.15.36-.37.44-.62h0c-.08.26-.23.47-.44.62-.7.49-1.85.07-2.56-.95-.72-1.02-.73-2.24-.03-2.73.35-.25.83-.27,1.29-.09,0,0,0,0,0,0-.47-.18-.94-.16-1.29.08Z"
                  fill="#e8e8e8"
                  strokeWidth="0"
                />
                <path
                  d="m49.19,36.1c-.7.49-.69,1.71.03,2.73.72,1.02,1.87,1.45,2.56.95.21-.15.36-.37.44-.62,0,0,0,0,0,0-.08.26-.23.48-.44.63-.7.49-1.85.07-2.56-.95-.71-1.02-.73-2.24-.03-2.73.36-.25.83-.26,1.3-.08,0,0,0,0-.01,0-.47-.18-.94-.17-1.29.09Z"
                  fill="#e9e9e9"
                  strokeWidth="0"
                />
                <path
                  d="m49.19,36.1c-.7.49-.69,1.71.03,2.73.71,1.02,1.86,1.44,2.56.95.21-.15.36-.37.44-.63t0,0c-.08.26-.23.48-.44.63-.7.49-1.85.07-2.56-.95-.71-1.02-.73-2.24-.03-2.73.36-.25.84-.26,1.31-.07,0,0,0,0-.01,0-.47-.19-.95-.18-1.3.08Z"
                  fill="#eaeaea"
                  strokeWidth="0"
                />
                <path
                  d="m49.19,36.1c-.7.49-.69,1.71.03,2.73.71,1.01,1.86,1.44,2.56.95.22-.15.36-.37.44-.63,0,0,0,0,0,0-.08.26-.23.48-.44.63-.7.49-1.84.07-2.56-.94-.71-1.02-.73-2.24-.03-2.73.36-.25.84-.26,1.32-.07,0,0,0,0,0,0-.48-.19-.96-.18-1.31.07Z"
                  fill="#ebebeb"
                  strokeWidth="0"
                />
                <path
                  d="m49.19,36.11c-.7.49-.69,1.71.03,2.73.72,1.01,1.86,1.44,2.56.94.22-.15.36-.37.44-.63,0,0,0,0,0,0-.08.27-.23.49-.44.64-.7.49-1.84.06-2.55-.95-.71-1.01-.73-2.23-.03-2.72.36-.25.85-.26,1.33-.06,0,0,0,0,0,0-.48-.19-.96-.18-1.32.07Z"
                  fill="#ececec"
                  strokeWidth="0"
                />
                <path
                  d="m49.19,36.11c-.7.49-.69,1.71.03,2.72.71,1.01,1.86,1.44,2.55.95.22-.15.36-.38.44-.64,0,0,0,0,0,0-.08.27-.23.49-.45.64-.69.49-1.84.07-2.55-.94-.71-1.01-.72-2.23-.03-2.72.37-.26.85-.26,1.34-.06,0,0,0,0,0,0-.49-.2-.97-.19-1.33.06Z"
                  fill="#ededed"
                  strokeWidth="0"
                />
                <path
                  d="m49.19,36.11c-.7.49-.69,1.71.03,2.72.71,1.01,1.86,1.43,2.55.94.22-.15.37-.37.45-.64h0c-.08.26-.23.48-.45.64-.7.49-1.84.07-2.55-.94-.71-1.01-.72-2.23-.03-2.71.37-.26.86-.26,1.34-.06,0,0,0,0,0,0-.49-.2-.97-.2-1.34.06Z"
                  fill="#eee"
                  strokeWidth="0"
                />
                <path
                  d="m49.19,36.11c-.7.49-.68,1.7.03,2.71.71,1.01,1.85,1.43,2.55.94.22-.15.37-.37.45-.64,0,0,0,0,0,0-.08.27-.23.5-.45.65-.69.49-1.84.07-2.55-.94-.71-1.01-.72-2.22-.03-2.71.37-.26.87-.26,1.36-.06h-.01c-.49-.21-.98-.21-1.34.05Z"
                  fill="#efefef"
                  strokeWidth="0"
                />
                <path
                  d="m49.19,36.11c-.69.49-.68,1.7.03,2.71.71,1.01,1.85,1.43,2.55.94.22-.15.37-.38.45-.65,0,0,0,0,0,0-.08.27-.23.5-.45.66-.69.49-1.83.06-2.54-.95-.71-1.01-.72-2.22-.03-2.71.37-.26.87-.26,1.36-.05,0,0,0,0,0,0-.49-.21-.99-.2-1.36.06Z"
                  fill="#f0f0f0"
                  strokeWidth="0"
                />
                <path
                  d="m49.2,36.11c-.69.49-.68,1.7.03,2.71.71,1.01,1.85,1.43,2.54.95.22-.16.37-.38.45-.66,0,0,0,0,0,0-.08.28-.23.51-.45.66-.69.49-1.83.06-2.54-.95-.71-1-.72-2.22-.03-2.71.37-.26.87-.26,1.37-.05h0c-.49-.21-.99-.22-1.36.04Z"
                  fill="#f1f1f1"
                  strokeWidth="0"
                />
                <path
                  d="m49.2,36.12c-.69.49-.68,1.7.03,2.71.71,1.01,1.85,1.43,2.54.95.22-.16.37-.38.45-.66,0,0,0,0,0,0-.08.28-.22.51-.45.66-.69.48-1.83.06-2.54-.94-.71-1-.72-2.21-.02-2.7.37-.26.88-.26,1.37-.04,0,0,0,0,0,0-.49-.21-.99-.21-1.37.05Z"
                  fill="#f2f2f2"
                  strokeWidth="0"
                />
                <path
                  d="m49.2,36.12c-.69.49-.68,1.7.02,2.7.71,1.01,1.84,1.43,2.54.94.22-.16.37-.39.45-.67,0,0,0,0,0,0-.08.28-.22.51-.45.67-.69.49-1.83.06-2.53-.94-.71-1-.72-2.21-.03-2.7.38-.26.88-.26,1.38-.04,0,0,0,0,0,0-.5-.21-1-.22-1.37.04Z"
                  fill="#f3f3f3"
                  strokeWidth="0"
                />
                <path
                  d="m49.2,36.12c-.69.49-.68,1.7.03,2.7.71,1,1.84,1.43,2.53.94.23-.16.37-.39.45-.67,0,0,0,0,0,0-.08.28-.23.52-.45.67-.69.49-1.82.06-2.53-.94-.7-1-.72-2.21-.02-2.7.38-.27.88-.26,1.38-.04,0,0,0,0,0,0-.5-.22-1-.22-1.38.04Z"
                  fill="#f4f4f4"
                  strokeWidth="0"
                />
                <path
                  d="m49.21,36.12c-.69.48-.68,1.7.02,2.7.71,1,1.84,1.42,2.53.94.23-.16.37-.39.45-.67,0,0,0,0,0,0-.07.28-.22.52-.45.67-.69.49-1.82.07-2.53-.94-.71-1-.72-2.21-.02-2.69.37-.27.89-.26,1.39-.03,0,0,0,0,0,0-.5-.22-1.01-.23-1.38.04Z"
                  fill="#f5f5f5"
                  strokeWidth="0"
                />
                <path
                  d="m49.21,36.13c-.69.49-.68,1.69.02,2.69.7,1,1.84,1.42,2.53.94.23-.16.37-.39.45-.67,0,0,0,0,0,0-.08.28-.22.52-.45.68-.69.49-1.82.07-2.52-.94-.7-1-.72-2.2-.03-2.69.38-.27.89-.26,1.4-.03,0,0,0,0,0,0-.5-.22-1.01-.23-1.39.03Z"
                  fill="#f6f6f6"
                  strokeWidth="0"
                />
                <path
                  d="m49.21,36.13c-.69.48-.68,1.69.03,2.69.71,1,1.83,1.42,2.52.94.23-.16.38-.4.45-.68,0,0,0,0,0-.01-.08.29-.23.53-.45.69-.69.48-1.82.07-2.52-.94-.71-1-.72-2.2-.03-2.69.38-.27.9-.26,1.4-.03h0c-.5-.23-1.02-.24-1.4.03Z"
                  fill="#f7f7f7"
                  strokeWidth="0"
                />
                <path
                  d="m49.21,36.13c-.69.48-.68,1.69.03,2.69.7,1,1.83,1.42,2.52.94.23-.16.38-.4.45-.69,0,0,0,0,0,0-.07.29-.22.53-.45.69-.69.48-1.81.07-2.52-.94-.7-1-.71-2.2-.02-2.68.38-.27.9-.26,1.41-.03,0,0,0,0,0,0-.5-.23-1.02-.24-1.4.03Z"
                  fill="#f8f8f8"
                  strokeWidth="0"
                />
                <path
                  d="m49.21,36.13c-.69.48-.68,1.69.02,2.68.7,1,1.83,1.42,2.52.94.23-.16.38-.4.45-.69h0c-.07.29-.23.53-.45.69-.69.48-1.81.07-2.52-.93-.7-1-.71-2.2-.03-2.68.39-.27.91-.26,1.41-.02,0,0,0,0,0,0-.51-.23-1.03-.25-1.41.03Z"
                  fill="#f9f9f9"
                  strokeWidth="0"
                />
                <path
                  d="m49.21,36.14c-.69.48-.68,1.68.03,2.68.7,1,1.83,1.42,2.52.93.23-.16.38-.4.45-.7h0c-.07.29-.22.53-.46.69-.69.48-1.81.06-2.51-.93-.7-1-.71-2.2-.03-2.68.39-.27.91-.26,1.42-.02h0c-.5-.24-1.03-.26-1.41.02Z"
                  fill="#fafafa"
                  strokeWidth="0"
                />
                <path
                  d="m49.21,36.14c-.69.48-.67,1.68.03,2.68.7,1,1.83,1.41,2.51.93.23-.16.38-.41.46-.7,0,0,0,0,0,0-.07.29-.22.54-.45.7-.68.48-1.81.06-2.51-.93-.7-1-.71-2.19-.03-2.68.39-.27.92-.26,1.42-.01,0,0,0,0,0,0-.51-.24-1.03-.25-1.42.02Z"
                  fill="#fbfbfb"
                  strokeWidth="0"
                />
                <path
                  d="m49.21,36.14c-.68.48-.67,1.68.03,2.68.7.99,1.83,1.41,2.51.93.23-.17.38-.41.45-.7t0,0c-.07.29-.22.54-.45.71-.69.48-1.81.06-2.51-.93-.7-1-.71-2.19-.03-2.68.39-.27.92-.26,1.44,0,0,0-.01,0-.02,0-.51-.24-1.04-.26-1.42.01Z"
                  fill="#fcfcfc"
                  strokeWidth="0"
                />
                <path
                  d="m49.21,36.14c-.68.48-.67,1.68.03,2.68.7.99,1.82,1.41,2.51.93.23-.16.38-.42.45-.71,0,0,0,0,0,0-.08.29-.22.54-.46.71-.68.48-1.81.06-2.5-.93-.7-.99-.71-2.19-.03-2.67.4-.27.93-.26,1.45,0,0,0,0,0,0,0-.52-.25-1.04-.27-1.44,0Z"
                  fill="#fdfdfd"
                  strokeWidth="0"
                />
                <path
                  d="m49.22,36.14c-.68.48-.67,1.68.03,2.67.7.99,1.82,1.41,2.5.93.24-.16.38-.42.46-.71,0,0,0,0,0,0-.07.3-.22.55-.46.71-.68.48-1.8.06-2.5-.93-.7-.99-.71-2.19-.02-2.67.39-.28.93-.25,1.45,0,0,0,0,0,0,0-.52-.25-1.05-.27-1.45,0Z"
                  fill="#fefefe"
                  strokeWidth="0"
                />
                <path
                  d="m49.22,36.14c-.68.48-.67,1.68.02,2.67.7.99,1.82,1.41,2.5.93.24-.16.39-.42.46-.71-.24-1.65-1.04-2.5-1.53-2.88-.52-.26-1.06-.28-1.45,0Zm2.51,3.2c-.5.43-1.43.11-2.09-.71-.66-.83-.79-1.85-.3-2.28.5-.43,1.43-.12,2.09.71.66.83.79,1.85.3,2.28Z"
                  fill="#ccc"
                  strokeWidth="0"
                />
                <path
                  d="m49.34,36.35c-.49.43-.36,1.45.3,2.28.66.83,1.59,1.14,2.09.71.5-.43.36-1.46-.3-2.28-.66-.83-1.59-1.14-2.09-.71Zm1.25,1.94c-.08-.1-.06-.26.05-.35.11-.09.27-.08.36.02.09.1.06.25-.05.35-.11.09-.27.08-.36-.02Zm.65.07s-.09.02-.12-.01c-.03-.04-.03-.09,0-.12.03-.03.09-.02.12.02.03.04.03.09,0,.12Z"
                  strokeWidth="0"
                />
                <path
                  d="m51,37.96c-.08-.1-.24-.11-.36-.02-.11.09-.13.25-.05.35.08.1.25.11.36.02.11-.09.13-.25.05-.35Z"
                  strokeWidth="0"
                />
                <path
                  d="m51.13,38.23s-.04.08,0,.12c.03.04.08.04.12.01.03-.03.04-.08,0-.12-.03-.04-.08-.04-.12-.02Z"
                  strokeWidth="0"
                />
                <line
                  x1="50.27"
                  y1="35.89"
                  x2="50.27"
                  y2="35.9"
                  fill="none"
                  stroke="#696969"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="0"
                />
                <line
                  x1="50.28"
                  y1="35.9"
                  x2="50.27"
                  y2="35.9"
                  fill="none"
                  stroke="#696969"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="0"
                />
                <line
                  x1="50.26"
                  y1="35.89"
                  x2="50.27"
                  y2="35.89"
                  fill="none"
                  stroke="#696969"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="0"
                />
              </g>
              <path
                d="m52.58,40.85s-.14-.77-.19-1.6c0,0-.08-2.7-2.6-3.75,0,0-1.14-.65-1.62-1.15,0,0,.27.69,1.65,1.43,0,0,1.98.87,2.39,3.35.4,2.48,0,.06,0,.06,0,0,.27,1.42.38,1.66Z"
                strokeWidth="0"
              />
            </g>
            <image
              width="313"
              height="326"
              transform="translate(14.37 -1.16) scale(.24)"
              href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATcAAAFGCAYAAAAPXNhWAAAACXBIWXMAAC4jAAAuIwF4pT92AAAErklEQVR4nO3d607cVhQG0I9LUkL6QFXz/K36Rg0QmP4Yb2ZzcKg0viCitaQjAzOWjGR92sfn4gQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAXrh47wvg4/vr73/evI++/fnHYa9rgSLcWGQKtrqP5u6nQz8KOvYi3DhbC7a5Vg5JnqZjNSHH5oQbZxmC7XJo9fcKs6ehHZIcBBxbunzvC+DDq3C7SvIpyeckv03tZjp+nj67nr53meTi/57VwRLCjSV65XaVY3hVuH0Z2k1OIXc1NQHHZoQbS1XAVbh9yjHIbpLcJvk6tdscQ64quQq4SwHHFoQba+gVXA+4LzmFW7UKuKrgdFHZhHBjTb2K+5RT9/Rrkt/zuoITcGzm+r0vgA9vHA2tEdCLHO+v6xzD67H9PE4VqXP6+bCIyo0lxqkej0l+TK2CqrqqVcXd5vXzt+fQU72xFuHGWaY5aj3cfiR5aO1+Oj5Np9RIag001Aiq7imb0C1lqQq3qtruc5rMWyOozyOjOQbcYfr+YzvvMa+7tnA2lRtne6N6u0vyPcm/U7ubPqtuag02VKuuqeqN1Qg3FmkBV9VbdUl7uP0s4D639qJruus/wS9JuLHYTMBV93QMuPvp8+Tlcq1XS7N2vHx+UcKNVQwBV93THnDfc6ze+iBDX9UwhpuAYxHhxmre6KLWM7i7vKze+qBDDzfP3VhMuLGqNwKuQu4hp3lwyWkktY+oCjUWE26sbgq4cWJvBdwYbn1XkXE/ODibcGNLcysX+py2Q15udnkVwcZKhBubaLvs9nWn44Td0iu2XrkJOc4m3NjSGHDjKoSq3PqWSYKNVQg3tnYYWq/kutlQM2LKuYQbexlD7sXbsAYCjcUsnGdr/b2lc1Vc/854DpxNuLGHHnDja/4y/C7YWIVwYy9zc9+q+zm35ZGXN7OIZ25spgVT74pWsPWNLefmv8EiKjf2UhVbLcm6zKlb2kOuV25CjrMJN7Y2DiA85LgSITkG3SGn5VmqN1Yj3NjD3F5vFXTJqZp7iHBjJcKNPfTnbTWI8Jhj17TvAde7pQYTWMSAApv6yS69fZ+3vltIPZNTubGYyo29jJN2517M/DwVRNXGUpa5sItpjei4fvQiMysYBBtrEG7spi2Cn7vvPGdjVcKN3c3t9CHUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEiS/AebWWwrK+r00QAAAABJRU5ErkJggg=="
            />
            <g opacity=".5">
              <image
                width="314"
                height="326"
                transform="translate(14.13 -1.4) scale(.24)"
                href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATcAAAFFCAYAAACJyKr4AAAACXBIWXMAAC4jAAAuIwF4pT92AAAEUUlEQVR4nO3dTW9VVRTH4d8RUPEFjUFFJ5L4MvELaOL3nzlQJ47UBPAFjCJgCy3tcbBPbTE6kXPv1fI8yc1Jb9pkD27+2XuttW8LAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+F+adr0Azod5np/4LE3TNO9qLVDCjRUswXapen5567B6XB0LOXbl4q4XwLlwsbpSvVW9UN2r7la/z/N8mJBjB4QbT2XZtV1ohNsH1bvVg+pWdbP6pXowz/PhNE3HO1sozxzhxlOZpmme5/moelg9ql6vPqw+qr6rvl2ed+Z53p+m6WhHS+UZI9xYw1H1W/VN9XKj9natert6v/qy+qK6KeDYFuHGU5um6Xie5/3qh0Yj4dfG7u3jxlH1SqPhMFU3BBzbINxYxRJwe9X3jYbCnWqv+qRRh/vkzK8LODZOuLGaJeAOGp3Sg8ZxtU4D7tPl57lxRN3TZGBThBurWkY+jpZd3I2Tt6vPqvcandWjRvjdmuf5wJgImyDc2Ihpmo6WOtzNTufg3mx0Ufeq240mxN1Od3iwmud2vQDOr6WmttdoNHzdGAmput5oNLxRXfzr1S1Yg3Bj046r+415t88b4yKXGyMi16oXcw2QDXAsZaOWId/DxjH0q+pq9dryvNoItwe7WyHnlZ0bG7d0RB82Au5GYyf3SvVOI+guOZqyNuHGthxX+435t58bO7brjVsMz//zn8G/I9zYlrlx9/R2o7Gw37iHevb2AqxGuLEVyyzbYae3F/YbO7aXlqdwY1XCjW2aG8O7e8vzcmP27UrqbqxMuLFNZ3dvdxvhdr3xJZfqbqxKuLFtBz1Zd3utejV1N1Ym3Niav6m77TU+gxcSbKzMEC/bdhJwD5fXUeM74FyeZ1XCjV04u4N7sDwPE3CsSLixKwfVT9WPjRrcwW6Xw3mj5sYunOzc7jcC7l516HvdWJNwY1dOAu5RjqRsgHBjFwQbGyfc2LazzYQ/j6QJOFamocAunAzy/r68NBNYncFJtm65Q3qx038W81gzATg3XJQHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP5L/gD3E/f0CwyBHgAAAABJRU5ErkJggg=="
              />
            </g>
          </g>
          <g clipPath="url(#clippath)">
            <image
              width="644"
              height="576"
              transform="translate(14.61 -27.32) scale(.24)"
              href="data:image/png;base64,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"
            />
          </g>
          <image
            width="305"
            height="308"
            transform="translate(8.37 -6.44) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAS8AAAEzCAYAAABgyoU4AAAACXBIWXMAAC4jAAAuIwF4pT92AAADDUlEQVR4nO3c324SQRjG4XeBUhv/XI/R69d4P7YWKQUPZsad4kEjO6apeZ5kA6U94GDzy7cfSxMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIDhppd+A/wfvnz91p9L7fmpvfD508dTYCDxYrEuXKuUc6qP1+9DwBhJvFikhmtKCdcqyaY+JiVaj90hYAyzev5P4FlTknWS6yQ3Sd4l+ZDkbf35qv5+Oru8hIs5kbhYN3VtkmxTQtWCtU7ykOQ+yV2SXZJ9TGAMsnnpN8Cr1wfsOiVe71OmrUNKuKbMl5DHdIt8uJR4MUIL2DpzxG5SIrVKidg+3eQVAWMhOy9GOKVMVG0xf0w5t66SvKnHNiVuq+SPWyvgr5m8WKqF65Cy1/qREqo2gSUlWi1cbUozebGIyYuL1aV7i9dDkp8pO67vSW5TlvX7zHsu0xbDiBeL1IAdMwdslxKw2zwNmGU9Q4kXi3UBO+RpwO5SLiN39fUWLwFjMTsvRmlRap8s3mf+tPGxvnaIcDGIHQTD1E8Q23J+W48p8yVlC9jRTaosZfJitGN93HfP++84ihZDmLwY6uyL2v351fZivhrEEOLFcN0NqOfx8n+9GEa8+Gf6u+hFCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHjdfgHelo9LaI6kSAAAAABJRU5ErkJggg=="
          />
          <g opacity=".6">
            <image
              width="319"
              height="313"
              transform="translate(17.97 -5) scale(.24)"
              href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATwAAAE5CAYAAAANyJy1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAD2UlEQVR4nO3cyYudRRTG4d+XpE0cEgOKQVRUxAnd6M7/fym4FzRKEqPRxDhksqdyUbfpRntlD9d0nmfz3aa5cBYfL3XqVN0CAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB46i3rLoCn3xhj7z067H0aVcuyjNOrCA4n8DiSVdhtVM+tnkv779WotqvNamv19xB+rMuFdRfAU+9Cdbl6rbrSDL4L1cXV//+sfql+r55UT8YY29Wu4OO0CTz+s9Xq7nz1YvV6dW31+UozAJ+v/qhuVj9X96qfql+rh2OMrQQfp0hLy5GMMTbaD7iXm4F3rXpv9bzYfM92q/vVt9X16kYzAB9UW8uy7J568TxzBB5Hcsge3kYz+K5Vr6ye71ZvNYPxUXW7+rr6pvquufp7vCzLzmnXz7NF4HFk/5jS7gXgxepSdbV6s7ni+6h6oxl8T6rvqy+rr6pb1SMrPU6SPTyO7MAe3KgaY+w2J7MPmsOKu819vOvVh9Xn1QfNNvjy6rub1Q9jjE17epwUgcexWwXWwfDbqh42hxV3mkG4VJ9UHzcnuXeaA477ldaWEyHwOFGr8Ns5EHx/Nc/m7YXi+9U7zXb3TvPYitaWEyHwOBUHgu9Rs73ds93c1/u0ObV9WN3W2nISBB6nalmWnTHG4/ZDb7f6onq12d7ebLa+ezcz4NgIPE7dIaFX9VnzoPLV5nT3wTpq42wTeKzFgdC71bytcb56u3mG76XqtzGGWxgcq3PrLoBn1+qg8aPqx+YNjHvtX03bWGNpnFFWeKzbbrN9vdE8rPxCc5ILx07gsVbLsozVjwjcbU5sLzXP422utTDOJFfL+F8YY5xrfy9vp9q2fwecaQfu5QIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD/9jcSsciQM0cP0wAAAABJRU5ErkJggg=="
            />
          </g>
          <path
            d="m50.36,42.2c-2.72-1.44-3.74-3.82-3.74-3.82-.39-1.25-1.54-4.09-2.74-6.12-.76-1.28-.63-2.37-.49-2.99,0,0-.56,1.27.25,2.78,0,0,1.39,2.64,1.65,3.36,0,0,.83,1.9,1.13,2.86,0,0,.89,2.53,3.93,3.93Z"
            strokeWidth="0"
          />
          <g opacity=".9">
            <image
              width="330"
              height="355"
              transform="translate(7.17 -6.44) scale(.24)"
              href="data:image/png;base64,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"
            />
          </g>
          <image
            width="334"
            height="359"
            transform="translate(16.29 -1.16) scale(.24)"
            href="data:image/png;base64,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"
          />
          <path
            d="m56.7,33.56s1.83-.48,1.04.79c0,0-.65-.23-1.04-.79Z"
            fill="url(#Fade_to_Black_2)"
            opacity=".5"
            strokeWidth="0"
          />
          <path
            d="m59.29,35.54s.54-.6.15-1.21c0,0-.5-.68-1.67-.04,0,0,.56.79,1.52,1.25Z"
            fill="url(#Fade_to_Black_2-2)"
            strokeWidth="0"
          />
          <path
            d="m59.32,35.46s1.02-.63,1.41-.26c0,0,.07.69-.51.98,0,0-.61-.1-.91-.72Z"
            fill="url(#Fade_to_Black_2-3)"
            strokeWidth="0"
          />
          <path
            d="m60.28,36.16s.61,1.03,1.3,1.48c0,0,.94-.6.78-1.5,0,0-.31-.52-2.08.03Z"
            fill="url(#Fade_to_Black_2-4)"
            strokeWidth="0"
          />
          <path
            d="m61.61,37.62s1.58-.93,2.47-.23c0,0-.11,1.29-1.53,1.68,0,0-.76-.82-.94-1.45Z"
            fill="url(#Fade_to_Black_2-5)"
            strokeWidth="0"
          />
          <path
            d="m62.64,39.06s-.29,1.05.44,1.77c0,0,1.5-.45,1.57-1.25,0,0-.39-.78-2-.52Z"
            fill="url(#Fade_to_Black_2-6)"
            strokeWidth="0"
          />
          <path
            d="m63.07,40.8s-.55,1.15.11,2.09c0,0,1.12-.01,1.67-.76,0,0-.05-.73-1.78-1.33Z"
            fill="url(#Fade_to_Black_2-7)"
            strokeWidth="0"
          />
          <path
            d="m63.16,42.87s-.51.58-.28,1.27c0,0,.49.25,1.3-.3,0,0,.2-.48-1.01-.96Z"
            fill="url(#Fade_to_Black_2-8)"
            strokeWidth="0"
          />
          <path
            d="m62.93,44.13s1.04.24,1.16.8c0,0,.07.52-.94.82,0,0-.64-.6-.22-1.62Z"
            fill="url(#Fade_to_Black_2-9)"
            strokeWidth="0"
          />
          <path
            d="m63.22,45.76s-.18.59.52.91c0,0,.32-.08.36-.47,0,0-.15-.37-.88-.44Z"
            fill="url(#Fade_to_Black_2-10)"
            strokeWidth="0"
          />
          <path
            d="m52.47,34.92s.61.64,1.17.65c0,0,.27-.51-.09-.62,0,0-.42-.23-1.09-.03Z"
            fill="url(#Fade_to_Black_2-11)"
            strokeWidth="0"
          />
          <path
            d="m54.95,36.43c-.99-.14-1.31-.87-1.31-.87,1.68-.17,1.66.16,1.66.16,0,0,.07.38-.36.71"
            fill="url(#Fade_to_Black_2-12)"
            strokeWidth="0"
          />
          <path
            d="m54.95,36.43s.53.96,1.19,1.19c0,0,.68-.52.31-.95,0,0-.43-.39-1.51-.24Z"
            fill="url(#Fade_to_Black_2-13)"
            strokeWidth="0"
          />
          <path
            d="m56.21,37.69s.26.91,1.16,1.51c0,0,1.06-.72.88-1.23,0,0-.44-.55-2.04-.28Z"
            fill="url(#Fade_to_Black_2-14)"
            strokeWidth="0"
          />
          <path
            d="m57.47,39.14s.16,1.21.78,1.86l.61.09s1.43-.59,1.33-1.47c0,0-.06-.67-2.72-.47Z"
            fill="url(#Fade_to_Black_2-15)"
            strokeWidth="0"
          />
          <path
            d="m58.25,41s-.22,1.04.24,1.73l.39.11s1.1-.36,1.25-.93c0,0-.2-.63-1.88-.91Z"
            fill="url(#Fade_to_Black_2-16)"
            strokeWidth="0"
          />
          <path
            d="m58.49,42.73s-.46,1.52.13,1.92c0,0,1.39-.12,1.69-.78,0,0-.04-.77-1.82-1.14Z"
            fill="url(#Fade_to_Black_2-17)"
            strokeWidth="0"
          />
          <path
            d="m58.63,44.65s-.69.45-.24,1.45c0,0,.96-.27,1.24-.7,0,0,.19-.4-.99-.76Z"
            fill="url(#Fade_to_Black_2-18)"
            strokeWidth="0"
          />
          <path
            d="m58.38,46.1s-.47.76.22,1.35c0,0,.4-.03.79-.55,0,0-.3-.54-1.02-.8Z"
            fill="url(#Fade_to_Black_2-19)"
            strokeWidth="0"
          />
          <path
            d="m58.47,47.52s-.09.75.39,1.35c0,0,.64-.65-.39-1.35Z"
            fill="url(#Fade_to_Black_2-20)"
            strokeWidth="0"
          />
          <g>
            <path
              d="m52.47,34.92s2.01-.53,1.14.68c0,0,.39-.92-1.14-.68Z"
              strokeWidth="0"
            />
            <path
              d="m53.64,35.57s1.59-.4,1.77.08c0,0,.1.44-.47.79,0,0,.54-.63.23-.78-.31-.15-1.54-.09-1.54-.09Z"
              strokeWidth="0"
            />
            <path
              d="m54.99,36.45s1.53-.25,1.65.3c0,0,.21.41-.5.88,0,0,.59-.58.22-.85,0,0-.31-.42-1.38-.33Z"
              strokeWidth="0"
            />
            <path
              d="m56.21,37.69s1.66-.5,2.16.12c0,0,.39.55-1,1.39,0,0,.93-.78.81-1.16,0,0-.08-.49-1.97-.35Z"
              strokeWidth="0"
            />
            <path
              d="m57.47,39.14s2.7-.5,3.01.42c0,0,.16.9-1.49,1.47,0,0,1.35-.75,1.2-1.41-.15-.66-2.72-.47-2.72-.47Z"
              strokeWidth="0"
            />
            <path
              d="m58.25,41s2.25.06,2.01,1.04c0,0-.17.44-1.18.72,0,0,1.1-.51.95-.9-.15-.39-1.49-.8-1.78-.85Z"
              strokeWidth="0"
            />
            <path
              d="m58.49,42.73s2.16.2,1.99,1.26c0,0-.09.67-1.85.66,0,0,1.5-.16,1.57-.8.08-.64-1.71-1.12-1.71-1.12Z"
              strokeWidth="0"
            />
            <path
              d="m58.68,44.67s1.14.17,1.02.82c0,0-.3.52-1.29.58,0,0,1.13-.41,1.08-.79-.05-.39-.8-.61-.8-.61Z"
              strokeWidth="0"
            />
            <path
              d="m58.38,46.1s1.22.4,1.08.85c0,0-.16.41-.86.5,0,0,.71-.29.61-.63-.1-.34-.83-.72-.83-.72Z"
              strokeWidth="0"
            />
            <path
              d="m58.47,47.52s1.29.73.39,1.35c0,0,.48-.65-.39-1.35Z"
              strokeWidth="0"
            />
          </g>
          <g>
            <image
              width="328"
              height="356"
              transform="translate(20.61 -2.6) scale(.24)"
              href="data:image/png;base64,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"
            />
          </g>
          <g>
            <path
              d="m66.42,52.7s.9.88,1.69,1c0,0,.14-.51-.51-.87,0,0-.65-.37-1.18-.13Z"
              fill="url(#linear-gradient)"
              strokeWidth="0"
            />
            <path
              d="m69.59,54.23s1.25.49,1.85.47c0,0-.08-.7-.84-.85,0,0-.61-.13-1.02.38Z"
              fill="url(#linear-gradient-2)"
              strokeWidth="0"
            />
            <path
              d="m75.97,55.92s-1.65-.25-2.47-.7c0,0,1.62-1.18,2.47.7Z"
              fill="url(#linear-gradient-3)"
              strokeWidth="0"
            />
            <path
              d="m78.73,56.22s2.72.43,3.19.32c0,0-.16-.89-1.77-1,0,0-1.25.09-1.42.68Z"
              fill="url(#linear-gradient-4)"
              strokeWidth="0"
            />
            <path
              d="m83.42,56.66s2.23.33,2.96.28c0,0-.4-.9-1.68-.93,0,0-.69.06-1.28.66Z"
              fill="url(#linear-gradient-5)"
              strokeWidth="0"
            />
            <path
              d="m91.47,56.77s-.47-1.12-2.18-.97c0,0-.84.19-1.02.89,0,0,2.27.48,3.21.08Z"
              fill="url(#linear-gradient-6)"
              strokeWidth="0"
            />
            <path
              d="m93.39,56.7s2.4.16,3.06.02c0,0-.66-1.12-1.94-.98,0,0-.98.07-1.12.97Z"
              fill="url(#linear-gradient-7)"
              strokeWidth="0"
            />
            <path
              d="m98.13,56.58s2.07.35,2.9-.32c0,0-.77-.85-1.83-.57,0,0-.83.24-1.07.88Z"
              fill="url(#linear-gradient-8)"
              strokeWidth="0"
            />
            <path
              d="m103.06,55.59s1.01-1.75,2.74-.65c0,0-1.66.82-2.79.78l.05-.14Z"
              fill="url(#linear-gradient-9)"
              strokeWidth="0"
            />
            <path
              d="m107.99,54.18s2.29-.41,2.93-1.15c0,0-2.15-.91-2.88,1.01"
              fill="url(#linear-gradient-10)"
              strokeWidth="0"
            />
            <path
              d="m115.04,51.03s-1.37,1.32-2.55,1.49c0,0,.23-2,2.55-1.49Z"
              fill="url(#linear-gradient-11)"
              strokeWidth="0"
            />
            <path
              d="m118.85,48.32s-.73,1.55-2.12,1.72c0,0-.16-1.8,2.12-1.72Z"
              fill="url(#linear-gradient-12)"
              strokeWidth="0"
            />
            <path
              d="m122.41,45.5s-1.69-.07-1.81,1.58c0,0,1.27-.58,1.81-1.58Z"
              fill="url(#linear-gradient-13)"
              strokeWidth="0"
            />
            <path
              d="m125.15,42.63s-.68,1.25-1.3,1.42c0,0,.12-1.78,1.3-1.42Z"
              fill="url(#linear-gradient-14)"
              strokeWidth="0"
            />
            <path
              d="m127.38,39.17s-.34,1.34-1,1.82c0,0-.33-1.35,1-1.82Z"
              fill="url(#linear-gradient-15)"
              strokeWidth="0"
            />
            <path
              d="m128.78,35.87s-.04,1.28-.76,2.11c0,0-.18-1.4.76-2.11Z"
              fill="url(#linear-gradient-16)"
              strokeWidth="0"
            />
            <path
              d="m129.43,32.59s.27.88-.3,1.84c0,0-.3-1.03.3-1.84Z"
              fill="url(#linear-gradient-17)"
              strokeWidth="0"
            />
            <path
              d="m104.82,7.09s.65-.28,1.17.19c0,0-.8.07-1.17-.19Z"
              fill="url(#linear-gradient-18)"
              strokeWidth="0"
            />
            <path
              d="m107.35,7.53s.38.25,1.1.18c0,0-.67-.47-1.08-.2"
              fill="url(#linear-gradient-19)"
              strokeWidth="0"
            />
            <path
              d="m110.04,7.97s.53.32,1.12.29c0,0-.4-.55-1.12-.29Z"
              fill="url(#linear-gradient-20)"
              strokeWidth="0"
            />
            <path
              d="m113.13,8.68s.9.44,1.45.36c0,0-.89-.84-1.45-.36Z"
              fill="url(#linear-gradient-21)"
              strokeWidth="0"
            />
            <path
              d="m116.09,9.45s.69.46,1.34.41c0,0-.43-.69-1.34-.41Z"
              fill="url(#linear-gradient-22)"
              strokeWidth="0"
            />
            <path
              d="m119.02,10.58s.88.64,1.45.6c0,0-.45-.71-1.42-.63"
              fill="url(#linear-gradient-23)"
              strokeWidth="0"
            />
            <path
              d="m121.68,11.73s.75.79,1.61,1.07c0,0-.43-1.09-1.61-1.07Z"
              fill="url(#linear-gradient-24)"
              strokeWidth="0"
            />
            <path
              d="m124.79,14.17l1.42,1.23s-.26-1.5-1.42-1.23Z"
              fill="url(#linear-gradient-25)"
              strokeWidth="0"
            />
            <path
              d="m127.23,16.76s.17,1.03,1.11,1.95c0,0-.3-1.44-1.11-1.95Z"
              fill="url(#linear-gradient-26)"
              strokeWidth="0"
            />
            <path
              d="m129.24,20.92s-.29.86.65,2.07c0,0-.24-1.63-.65-2.07Z"
              fill="url(#linear-gradient-27)"
              strokeWidth="0"
            />
            <path
              d="m129.96,24.63s-.43,1.59.11,2.4c0,0,.35-1.83-.11-2.4Z"
              fill="url(#linear-gradient-28)"
              strokeWidth="0"
            />
            <path
              d="m130.08,29.01s-.55,1.47-.28,2.1c0,0,.6-1.56.28-2.1Z"
              fill="url(#linear-gradient-29)"
              strokeWidth="0"
            />
          </g>
          <g>
            <path
              d="m66.43,52.7s.89.88,1.69,1c0,0,.14-.51-.51-.87,0,0-.65-.37-1.18-.12Z"
              fill="url(#Fade_to_Black_2-21)"
              strokeWidth="0"
            />
            <path
              d="m69.59,54.22s1.25.49,1.85.47c0,0-.08-.7-.83-.85,0,0-.61-.13-1.01.39Z"
              fill="url(#Fade_to_Black_2-22)"
              strokeWidth="0"
            />
            <path
              d="m75.98,55.91s-1.65-.25-2.47-.7c0,0,1.62-1.18,2.47.7Z"
              fill="url(#Fade_to_Black_2-23)"
              strokeWidth="0"
            />
            <path
              d="m78.73,56.21s2.72.43,3.19.33c0,0-.15-.89-1.77-1.01,0,0-1.25.1-1.42.68Z"
              fill="url(#Fade_to_Black_2-24)"
              strokeWidth="0"
            />
            <path
              d="m83.43,56.65s2.23.33,2.96.27c0,0-.4-.9-1.68-.93,0,0-.69.06-1.28.66Z"
              fill="url(#Fade_to_Black_2-25)"
              strokeWidth="0"
            />
            <path
              d="m91.47,56.76s-.47-1.12-2.18-.97c0,0-.84.2-1.03.89,0,0,2.27.48,3.21.08Z"
              fill="url(#Fade_to_Black_2-26)"
              strokeWidth="0"
            />
            <path
              d="m93.39,56.69s2.41.17,3.06.02c0,0-.66-1.12-1.94-.98,0,0-.98.07-1.13.97Z"
              fill="url(#Fade_to_Black_2-27)"
              strokeWidth="0"
            />
            <path
              d="m98.13,56.56s2.07.35,2.9-.32c0,0-.77-.85-1.83-.57,0,0-.83.24-1.07.88Z"
              fill="url(#Fade_to_Black_2-28)"
              strokeWidth="0"
            />
            <path
              d="m103.07,55.58s1-1.75,2.74-.64c0,0-1.66.82-2.79.78l.05-.14Z"
              fill="url(#Fade_to_Black_2-29)"
              strokeWidth="0"
            />
            <path
              d="m107.99,54.17s2.3-.41,2.93-1.15c0,0-2.15-.91-2.88,1.01"
              fill="url(#Fade_to_Black_2-30)"
              strokeWidth="0"
            />
            <path
              d="m115.04,51.01s-1.37,1.32-2.55,1.5c0,0,.23-2,2.55-1.5Z"
              fill="url(#Fade_to_Black_2-31)"
              strokeWidth="0"
            />
            <path
              d="m118.86,48.31s-.73,1.55-2.13,1.72c0,0-.16-1.79,2.13-1.72Z"
              fill="url(#Fade_to_Black_2-32)"
              strokeWidth="0"
            />
            <path
              d="m122.41,45.48s-1.69-.07-1.81,1.58c0,0,1.27-.58,1.81-1.58Z"
              fill="url(#Fade_to_Black_2-33)"
              strokeWidth="0"
            />
            <path
              d="m125.15,42.62s-.68,1.25-1.3,1.42c0,0,.12-1.78,1.3-1.42Z"
              fill="url(#Fade_to_Black_2-34)"
              strokeWidth="0"
            />
            <path
              d="m127.39,39.16s-.33,1.34-1,1.82c0,0-.33-1.35,1-1.82Z"
              fill="url(#Fade_to_Black_2-35)"
              strokeWidth="0"
            />
            <path
              d="m128.78,35.86s-.04,1.27-.76,2.11c0,0-.18-1.4.76-2.11Z"
              fill="url(#Fade_to_Black_2-36)"
              strokeWidth="0"
            />
            <path
              d="m129.44,32.57s.26.88-.3,1.84c0,0-.3-1.03.3-1.84Z"
              fill="url(#Fade_to_Black_2-37)"
              strokeWidth="0"
            />
            <path
              d="m104.83,7.09s.65-.29,1.17.18c0,0-.8.07-1.17-.18Z"
              fill="url(#Fade_to_Black_2-38)"
              strokeWidth="0"
            />
            <path
              d="m107.35,7.52s.38.25,1.1.18c0,0-.67-.47-1.08-.2"
              fill="url(#Fade_to_Black_2-39)"
              strokeWidth="0"
            />
            <path
              d="m110.05,7.96s.53.32,1.12.28c0,0-.4-.54-1.12-.28Z"
              fill="url(#Fade_to_Black_2-40)"
              strokeWidth="0"
            />
            <path
              d="m113.13,8.67s.9.44,1.45.36c0,0-.88-.84-1.45-.36Z"
              fill="url(#Fade_to_Black_2-41)"
              strokeWidth="0"
            />
            <path
              d="m116.1,9.44s.69.46,1.34.4c0,0-.43-.69-1.34-.4Z"
              fill="url(#Fade_to_Black_2-42)"
              strokeWidth="0"
            />
            <path
              d="m119.02,10.57s.88.64,1.45.6c0,0-.45-.71-1.42-.63"
              fill="url(#Fade_to_Black_2-43)"
              strokeWidth="0"
            />
            <path
              d="m121.69,11.72s.75.78,1.61,1.06c0,0-.44-1.09-1.61-1.06Z"
              fill="url(#Fade_to_Black_2-44)"
              strokeWidth="0"
            />
            <path
              d="m124.79,14.16l1.42,1.23s-.27-1.5-1.42-1.23Z"
              fill="url(#Fade_to_Black_2-45)"
              strokeWidth="0"
            />
            <path
              d="m127.24,16.75s.17,1.03,1.11,1.95c0,0-.31-1.44-1.11-1.95Z"
              fill="url(#Fade_to_Black_2-46)"
              strokeWidth="0"
            />
            <path
              d="m129.24,20.91s-.29.85.65,2.06c0,0-.24-1.63-.65-2.06Z"
              fill="url(#Fade_to_Black_2-47)"
              strokeWidth="0"
            />
            <path
              d="m129.96,24.61s-.43,1.59.11,2.4c0,0,.35-1.83-.11-2.4Z"
              fill="url(#Fade_to_Black_2-48)"
              strokeWidth="0"
            />
            <path
              d="m130.08,29s-.55,1.47-.28,2.1c0,0,.6-1.56.28-2.1Z"
              fill="url(#Fade_to_Black_2-49)"
              strokeWidth="0"
            />
          </g>
          <path
            d="m66.43,52.7s.89.88,1.69,1c0,0,.14-.51-.51-.87,0,0-.65-.37-1.18-.12Z"
            fill="url(#linear-gradient-30)"
            strokeWidth="0"
          />
          <path
            d="m69.59,54.22s1.25.49,1.85.47c0,0-.08-.7-.83-.85,0,0-.61-.13-1.01.39Z"
            fill="url(#linear-gradient-31)"
            strokeWidth="0"
          />
          <path
            d="m75.98,55.91s-1.65-.25-2.47-.7c0,0,1.62-1.18,2.47.7Z"
            fill="url(#linear-gradient-32)"
            strokeWidth="0"
          />
          <path
            d="m78.73,56.21s2.72.43,3.19.33c0,0-.15-.89-1.77-1.01,0,0-1.25.1-1.42.68Z"
            fill="url(#linear-gradient-33)"
            strokeWidth="0"
          />
          <path
            d="m83.43,56.65s2.23.33,2.96.27c0,0-.4-.9-1.68-.93,0,0-.69.06-1.28.66Z"
            fill="url(#linear-gradient-34)"
            strokeWidth="0"
          />
          <path
            d="m91.47,56.76s-.47-1.12-2.18-.97c0,0-.84.2-1.03.89,0,0,2.27.48,3.21.08Z"
            fill="url(#linear-gradient-35)"
            strokeWidth="0"
          />
          <path
            d="m93.39,56.69s2.41.17,3.06.02c0,0-.66-1.12-1.94-.98,0,0-.98.07-1.13.97Z"
            fill="url(#linear-gradient-36)"
            strokeWidth="0"
          />
          <path
            d="m98.13,56.56s2.07.35,2.9-.32c0,0-.77-.85-1.83-.57,0,0-.83.24-1.07.88Z"
            fill="url(#linear-gradient-37)"
            strokeWidth="0"
          />
          <path
            d="m103.07,55.58s1-1.75,2.74-.64c0,0-1.66.82-2.79.78l.05-.14Z"
            fill="url(#linear-gradient-38)"
            strokeWidth="0"
          />
          <path
            d="m107.99,54.17s2.3-.41,2.93-1.15c0,0-2.15-.91-2.88,1.01"
            fill="url(#linear-gradient-39)"
            strokeWidth="0"
          />
          <path
            d="m115.04,51.01s-1.37,1.32-2.55,1.5c0,0,.23-2,2.55-1.5Z"
            fill="url(#linear-gradient-40)"
            strokeWidth="0"
          />
          <path
            d="m118.86,48.31s-.73,1.55-2.13,1.72c0,0-.16-1.79,2.13-1.72Z"
            fill="url(#linear-gradient-41)"
            strokeWidth="0"
          />
          <path
            d="m122.41,45.48s-1.69-.07-1.81,1.58c0,0,1.27-.58,1.81-1.58Z"
            fill="url(#linear-gradient-42)"
            strokeWidth="0"
          />
          <path
            d="m125.15,42.62s-.68,1.25-1.3,1.42c0,0,.12-1.78,1.3-1.42Z"
            fill="url(#linear-gradient-43)"
            strokeWidth="0"
          />
          <path
            d="m127.39,39.16s-.33,1.34-1,1.82c0,0-.33-1.35,1-1.82Z"
            fill="url(#linear-gradient-44)"
            strokeWidth="0"
          />
          <path
            d="m128.78,35.86s-.04,1.27-.76,2.11c0,0-.18-1.4.76-2.11Z"
            fill="url(#linear-gradient-45)"
            strokeWidth="0"
          />
          <path
            d="m129.44,32.57s.26.88-.3,1.84c0,0-.3-1.03.3-1.84Z"
            fill="url(#linear-gradient-46)"
            strokeWidth="0"
          />
          <path
            d="m104.83,7.09s.65-.29,1.17.18c0,0-.8.07-1.17-.18Z"
            fill="url(#linear-gradient-47)"
            strokeWidth="0"
          />
          <path
            d="m107.35,7.52s.38.25,1.1.18c0,0-.67-.47-1.08-.2"
            fill="url(#linear-gradient-48)"
            strokeWidth="0"
          />
          <path
            d="m110.05,7.96s.53.32,1.12.28c0,0-.4-.54-1.12-.28Z"
            fill="url(#linear-gradient-49)"
            strokeWidth="0"
          />
          <path
            d="m113.13,8.67s.9.44,1.45.36c0,0-.88-.84-1.45-.36Z"
            fill="url(#linear-gradient-50)"
            strokeWidth="0"
          />
          <path
            d="m116.1,9.44s.69.46,1.34.4c0,0-.43-.69-1.34-.4Z"
            fill="url(#linear-gradient-51)"
            strokeWidth="0"
          />
          <path
            d="m119.02,10.57s.88.64,1.45.6c0,0-.45-.71-1.42-.63"
            fill="url(#linear-gradient-52)"
            strokeWidth="0"
          />
          <path
            d="m121.69,11.72s.75.78,1.61,1.06c0,0-.44-1.09-1.61-1.06Z"
            fill="url(#linear-gradient-53)"
            strokeWidth="0"
          />
          <path
            d="m124.79,14.16l1.42,1.23s-.27-1.5-1.42-1.23Z"
            fill="url(#linear-gradient-54)"
            strokeWidth="0"
          />
          <path
            d="m127.24,16.75s.17,1.03,1.11,1.95c0,0-.31-1.44-1.11-1.95Z"
            fill="url(#linear-gradient-55)"
            strokeWidth="0"
          />
          <path
            d="m129.24,20.91s-.29.85.65,2.06c0,0-.24-1.63-.65-2.06Z"
            fill="url(#linear-gradient-56)"
            strokeWidth="0"
          />
          <path
            d="m129.96,24.61s-.43,1.59.11,2.4c0,0,.35-1.83-.11-2.4Z"
            fill="url(#linear-gradient-57)"
            strokeWidth="0"
          />
          <path
            d="m130.08,29s-.55,1.47-.28,2.1c0,0,.6-1.56.28-2.1Z"
            fill="url(#linear-gradient-58)"
            strokeWidth="0"
          />
          <path
            d="m113.25,8.64c.21.19,1.16.44,1.16.44-1.41-.22-1.37-.43-1.37-.43.62-.63,1.54.39,1.54.39-.9-.77-1.33-.4-1.33-.4Zm-2.06-.43s-.71-.65-1.25-.28c0,0-.16.23,1.07.32,0,0-.74-.15-.88-.31,0,0,.59-.13,1.05.27Zm-2.85-.58c-.27.08-.82,0-.82,0,.83.23,1.08.1,1.08.1-.58-.62-1.23-.2-1.23-.2.46-.2.98.11.98.11Zm-2.53-.43c-.27.07-.82,0-.82,0,.82.23,1.07.1,1.07.1-.59-.62-1.23-.2-1.23-.2.46-.2.98.11.98.11Zm-7.59,49.27c.76-1.18,2.22-.69,2.22-.69-1.89-.88-2.56.89-2.56.89,1.6.37,3.16-.42,3.16-.42-1.21.61-2.82.21-2.82.21Zm7.08-1.92s-1.86-.38-2.62,1.27c0,0,1.59.03,3.14-.87,0,0-2.14.76-2.74.64,0,0,.6-1.21,2.22-1.04Zm4.87-1.79s-2.11-.29-2.42,1.5c0,0,1.68.15,3.1-1.06,0,0-1.54.95-2.79.85,0,0,.08-1.26,2.12-1.28Zm2.43-.36c.14-1.55,2.05-1.4,2.05-1.4-2.41-.32-2.26,1.62-2.26,1.62,1.73-.27,2.68-1.6,2.68-1.6-.66.93-2.46,1.38-2.46,1.38Zm5.7-3.96s-1.66-.26-1.77,1.84c0,0,1.45-.25,2.22-1.55,0,0-1.07,1.17-2,1.33,0,0-.02-1.56,1.55-1.61Zm2.32-1.36c.15-1.43,1.43-1.59,1.43-1.59-1.8.16-1.65,1.86-1.65,1.86,1.53-.49,2.02-1.85,2.02-1.85-.4.98-1.81,1.58-1.81,1.58Zm4.32-4.55s-.67-.59-1.31,1.68c0,0,.61.5,1.54-1.57,0,0-.74,1.3-1.3,1.42,0,0,.22-1.68,1.07-1.53Zm2.19-3.3s-.88.15-.92,2.07c0,0,.86-.34,1.19-2.13,0,0-.52,1.54-1,1.82,0,0-.11-1.06.74-1.76Zm1.5-3.23s-.91.85-.69,2.16c0,0,.48-.22.88-2,0,0-.46,1.43-.76,1.69,0,0-.02-1.23.57-1.85Zm.81-3.41s-.73,1.1-.4,2.09c0,0,.43.21.52-1.94,0,0-.24,1.51-.42,1.69,0,0-.18-.76.3-1.84Zm.41-1.67c-.21-.44.18-1.75.18-1.75-.65,1.64-.22,2.1-.22,2.1.49-.53.37-2.19.37-2.19.08.79-.33,1.85-.33,1.85Zm.25-4.15c-.35-.37-.2-1.92-.2-1.92-.37,1.9.17,2.22.17,2.22.24-.04.23-.83.23-.83-.04-1.58-.34-1.62-.34-1.62.33.59.14,2.14.14,2.14Zm-.28-3.98c-.29-.24-.64-1.4-.64-1.4.29,1.53.75,1.77.75,1.77.25-1.24-.68-2.24-.68-2.24.43.39.58,1.87.58,1.87Zm-1.61-4.4c-.34-.28-.94-1.33-.94-1.33.33,1.01,1.13,1.81,1.13,1.81.04-1.63-1.23-2.14-1.23-2.14.8.53,1.03,1.66,1.03,1.66Zm-3.41-4.22s.88.89,1.5,1.37c0,0,.22-1.21-1.22-1.45,0,0,.92.22,1.08,1.12,0,0-1.14-.81-1.35-1.05Zm-1.45-1.33s-1.02-.46-1.58-1.09c0,0,1.01.03,1.46.89,0,0-.48-1.2-1.73-.95,0,0,.71.87,1.85,1.15Zm-3.09-1.93s-.74-.64-1.5-.38c0,0,.61.45,1.52.67,0,0-.88-.36-1.22-.65,0,0,.65-.02,1.2.35Zm-2.78-1.04s-.98-.11-1.29-.4c0,0,.62-.23,1.13.23,0,0-.69-.71-1.33-.29,0,0,.13.54,1.49.46Zm-49.36,43.52s-.45-1.22-1.83-.74c0,0,.45.86,1.74,1.04,0,0-1.08-.43-1.41-.89,0,0,.58-.42,1.51.6Zm1.58.76c.82-.75,1.67.28,1.67.28-.12-.51-.66-.7-.66-.7-.83-.23-1.25.48-1.25.48.6.41,1.99.5,1.99.5-1.28-.2-1.74-.56-1.74-.56Zm5.99,1.22s-.94-1.33-2.46-.14c0,0,.56.41,2.76.7,0,0-1.92-.4-2.39-.74,0,0,.99-.78,2.09.18Zm5.94.64s-1.94-1.43-3.36.23c0,0,2.24.55,3.66.31,0,0-2.61-.2-3.16-.41,0,0,.97-1.14,2.85-.13Zm1.93.61c1.35-1.27,2.68.04,2.68.04-1.66-1.77-3.05.08-3.05.08,1.22.31,3.34.21,3.34.21-1.05.02-2.97-.33-2.97-.33Zm7.56-.4s-2.32-1.51-3.05.59c0,0,1.97.44,3.41-.03,0,0-2.24.17-3.11-.12,0,0,.52-1.54,2.75-.44Zm4.61-.24s-1.89-1.12-2.59.79c0,0,1.68.38,3.14,0,0,0-2.07.05-2.74-.16,0,0,.25-1.37,2.2-.62Z"
            strokeWidth="0"
          />
          <g opacity=".5">
            <image
              width="306"
              height="309"
              transform="translate(8.61 -6.44) scale(.24)"
              href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATEAAAE0CAYAAABEqATbAAAACXBIWXMAAC4jAAAuIwF4pT92AAADOElEQVR4nO3cYU/bMBQF0JuU0cG2//8/J6AU2nofbEPoJm1TjCrQOZLVNGqlfLBu33OcJgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf3nTpC+DzKKUs59OUpLy8maby+zdgPSHGEC3Azkc5G8KM4YQYqy0CbE6yaaPPrVOSY3s9JSmCjJGEGKucBdhVkuskX9pxUgPsOclTkkN7L8gY5urvH4F/MqeG19ckt0m27dwhya6Nx9QwO5ZStJYMIcQYoVdjm9RK7FuS7+34mOQ+yc+8XSc7XuRK+XSEGKNtUiuy29QgS5Kbdv6URUtZSjmpxlhLiDFCr66Wi/hzamt5ndpaltRWcp+6RqYSY4j50hfAx9YqqR5gh7wG1VM719vLH+11m/rjOceNJQYQYozSq7B96iL+fepC/iF1nm3buE5tLeck09kGWfhvQozVFtVY306xS/KQ5C6vQVZS51sfMIQ1MUZatpQ9xG5Sw+3QximLx5FgLSHGENM0lVJKUkPqObUCu0ttH/v62EM7PmbxKBKsIcQYrbeV+9QQm1Pbyx5ivb08JZ6lZD0hxjCtGush1lvKkjrP+haLXWqlpq1kCCHGaMvtFo+pgdYX8vu6WG8nYTW3txnu7KHwPpZ3MEs8BM4gQox3cfb/Yi+n43/FGEyI8W7+tJFVeAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAjPALzDatUf/EOwoAAAAASUVORK5CYII="
            />
          </g>
          <path
            d="m56.76,33.57s1.09-.46,1.21.11c0,0-.03.35-.19.6,0,0,.42-1.1-1.01-.72Z"
            strokeWidth="0"
          />
          <path
            d="m57.77,34.29s1.18-.62,1.67.04c0,0,.33.67-.12,1.13,0,0,.41-.75-.21-1.13,0,0-.41-.28-1.35-.04Z"
            strokeWidth="0"
          />
          <path
            d="m59.41,35.38s.96-.48,1.28-.15c0,0,.18.43-.41.93,0,0,.44-.62.25-.81,0,0-.08-.25-1.12.03Z"
            strokeWidth="0"
          />
          <path
            d="m60.28,36.16s1.74-.49,2.08-.03c0,0,.12.78-.62,1.39,0,0,.57-.8.37-1.19,0,0-.15-.33-1.84-.18Z"
            strokeWidth="0"
          />
          <path
            d="m61.84,37.49s1.73-.61,2.24-.1c0,0-.21,1.2-1.32,1.62,0,0,1.04-.71,1.01-1.48,0,0-.19-.36-1.93-.04Z"
            strokeWidth="0"
          />
          <path
            d="m62.82,39.04s1.28-.14,1.78.49c0,0,.24.75-1.54,1.28,0,0,1.2-.52,1.32-1.15,0,0,0-.48-1.56-.62Z"
            strokeWidth="0"
          />
          <path
            d="m63.07,40.8s1.77.6,1.78,1.33c0,0-.51.67-1.69.73,0,0,1.19-.26,1.42-.79,0,0-.23-.73-1.52-1.27Z"
            strokeWidth="0"
          />
          <path
            d="m63.16,42.87s1.2.55,1.01.96c0,0-.5.43-1.16.37,0,0,.68-.14.93-.47,0,0,.07-.33-.78-.86Z"
            strokeWidth="0"
          />
          <path
            d="m63.13,44.2s.88.37.96.74c0,0,.04.49-.87.83,0,0,.61-.3.65-.82,0,0,.01-.29-.74-.74Z"
            strokeWidth="0"
          />
          <path
            d="m63.22,45.76s.52,0,.88.44c0,0-.03.33-.3.48,0,0,.65-.61-.64-.92"
            strokeWidth="0"
          />
          <path
            d="m49.97,41.7s.34.34.29.45c-2.64-1.45-3.53-3.74-3.53-3.74-.39-1.25-1.54-4.09-2.73-6.12-.76-1.28-.74-2.38-.59-3.01,0,0-.45,1.29.35,2.8,0,0,1.39,2.64,1.65,3.37,0,0,.83,1.9,1.13,2.86,0,0,.77,2.45,3.72,3.86-.02.03-.09.03-.24-.02,0,0,.83.39-.04-.44Z"
            strokeWidth="0"
          />
          <path
            d="m47.34,41.4l.31,2.8s.18.45.83.51c0,0,.05-.89.11-1.27.06-.37-.18-1.01-1.25-2.04Z"
            fill="url(#Fade_to_Black_2-50)"
            strokeWidth="0"
          />
          <path
            d="m48.56,43.71s-.41,3.28,1.36,3.26l.16-1.34s-.19-1.86-1.46-2.34"
            fill="url(#Fade_to_Black_2-51)"
            strokeWidth="0"
          />
          <path
            d="m50,46.4s-.42,3.74,1.37,2.48c0,0,.12-.67.22-1.01,0,0,.11-1.27-1.49-2.27l-.1.8Z"
            fill="url(#Fade_to_Black_2-52)"
            strokeWidth="0"
          />
          <path
            d="m53.2,49.33s.04-.4-1.62-1.39c0,0-.91,3.19.52,3.19l.79-.12s.17-1.5.31-1.69Z"
            fill="url(#Fade_to_Black_2-53)"
            strokeWidth="0"
          />
          <path
            d="m55.39,49.94c-.03.27-.03,1.28-.03,1.28-.54,1.69-1.45,1.65-1.45,1.65-1.53-.06-.8-3.16-.8-3.16l.09-.39s1.26,1.28,2.19.61"
            fill="url(#linear-gradient-59)"
            strokeWidth="0"
          />
          <path
            d="m55.39,49.94s-.14,2.82,1,2.98c0,0,1.5.26,2.23-3.89,0,0-1.65,2.63-3.23.91Z"
            fill="url(#linear-gradient-60)"
            strokeWidth="0"
          />
          <path
            d="m57.53,52.03c-.45.57-1.97,2.16-2.16-2.14,0,0-.1.55-.08,1.2-.19.53-.71,1.71-1.51,1.65,0,0-1.23.05-.56-3.38,0,0-.27.74-.38,1.57-.43.19-2.18.75-1.25-3.04,0,0-.14.4-.25.94-.15.13-1.64,1.33-1.35-2.51,0,0-.04.23-.07.57-.24.05-1.58.18-1.35-3.24,0,0-.08.4-.12.93-.15,0-.8-.06-.85-1.2,0,0-.14-1.87-.31-2.16,0,0,.14,1.62.08,2.27-.05.63.08,1.28,1.06,1.43-.01,1.03.22,2.28,1.46,2.24-.08,1.12,0,2.88,1.38,2.02-.2,1.19-.16,2.68,1.53,2.05-.07.86.07,1.73.89,1.9,0,0,1.15.1,1.64-1.47.1.69.39,1.34,1.08,1.46,0,0,.51,0,.89-.46.85-.9,1.18-3,1.18-3-.3,1.17-.64,1.91-.96,2.38Z"
            strokeWidth="0"
          />
        </g>
      </g>
    </g>
  </>
);
